export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="576.172"
    height="454"
    viewBox="0 0 576.172 454"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.301"
        y1="0.5"
        x2="-0.146"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#ebebf7" />
        <stop offset="0.47" stopColor="#d8d9f0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="0.597"
        y1="0.5"
        x2="-5.224"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1="0.597"
        y1="0.5"
        x2="-5.227"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-4"
        x1="0.473"
        y1="0.76"
        x2="1.085"
        y2="-5.172"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-5"
        x1="0.473"
        y1="0.76"
        x2="1.087"
        y2="-5.174"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-7"
        x1="0.473"
        y1="0.759"
        x2="1.085"
        y2="-5.177"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-8"
        x1="0.535"
        y1="0.161"
        x2="1.147"
        y2="-5.771"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-9"
        x1="0.473"
        y1="0.759"
        x2="1.085"
        y2="-5.169"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-10"
        x1="0.597"
        y1="0.499"
        x2="-5.224"
        y2="0.499"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-12"
        x1="0.597"
        y1="0.5"
        x2="-5.224"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-13"
        x1="0.597"
        y1="0.5"
        x2="-5.224"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-15"
        x1="0.597"
        y1="0.498"
        x2="-5.228"
        y2="0.498"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-17"
        x1="0.596"
        y1="0.501"
        x2="-5.221"
        y2="0.501"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-19"
        x1="0.597"
        y1="0.5"
        x2="-5.224"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <radialGradient
        id="radial-gradient"
        cx="0.491"
        cy="0.554"
        r="0.841"
        gradientTransform="translate(-0.5 3.544) scale(0.594 0.598)"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0.18" stopColor="#4d5a96" />
        <stop offset="0.25" stopColor="#6a75a7" />
        <stop offset="0.36" stopColor="#979fc2" />
        <stop offset="0.48" stopColor="#bdc2d8" />
        <stop offset="0.6" stopColor="#dadce9" />
        <stop offset="0.71" stopColor="#eef0f5" />
        <stop offset="0.83" stopColor="#fbfbfd" />
        <stop offset="0.93" stopColor="#fff" />
      </radialGradient>
      <linearGradient
        id="linear-gradient-20"
        x1="0.005"
        y1="0.5"
        x2="0.989"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#afb6e5" />
        <stop offset="0.09" stopColor="#d2d6f0" />
        <stop offset="0.18" stopColor="#ebecf8" />
        <stop offset="0.26" stopColor="#fafafd" />
        <stop offset="0.32" stopColor="#fff" />
        <stop offset="0.45" stopColor="#f7f8ff" />
        <stop offset="0.74" stopColor="#eaedff" />
        <stop offset="1" stopColor="#e5e9ff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-21"
        x1="-0.188"
        y1="0.234"
        x2="0.508"
        y2="0.503"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#afb6e5" />
        <stop offset="0.14" stopColor="#b6bce8" />
        <stop offset="0.35" stopColor="#c8cdf1" />
        <stop offset="0.58" stopColor="#e5e9ff" />
        <stop offset="0.86" stopColor="#f5f6ff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <radialGradient
        id="radial-gradient-2"
        cx="0.284"
        cy="0.704"
        r="2.088"
        gradientTransform="translate(0.35) scale(0.301 1)"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" />
      </radialGradient>
      <linearGradient
        id="linear-gradient-22"
        x1="0.503"
        y1="1.827"
        x2="0.498"
        y2="-0.024"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#afb6e5" />
        <stop offset="0.1" stopColor="#b8bee9" />
        <stop offset="0.43" stopColor="#d1d6f5" />
        <stop offset="0.74" stopColor="#e0e4fc" />
        <stop offset="0.99" stopColor="#e5e9ff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-23"
        x1="0.491"
        y1="-0.317"
        x2="0.523"
        y2="2.862"
        xlinkHref="#linear-gradient-22"
      />
      <linearGradient
        id="linear-gradient-24"
        x1="0.004"
        y1="0.123"
        x2="0.875"
        y2="1.004"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#afb6e5" />
        <stop offset="0.08" stopColor="#c7ccee" />
        <stop offset="0.19" stopColor="#e0e2f7" />
        <stop offset="0.28" stopColor="#eff0fd" />
        <stop offset="0.36" stopColor="#f4f5ff" />
        <stop offset="0.66" stopColor="#eaedff" />
        <stop offset="1" stopColor="#e5e9ff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-25"
        x1="-0.283"
        y1="0.752"
        x2="0.987"
        y2="0.229"
        xlinkHref="#linear-gradient-21"
      />
      <linearGradient
        id="linear-gradient-26"
        x1="0.344"
        y1="0.397"
        x2="1.495"
        y2="1.205"
        xlinkHref="#linear-gradient-21"
      />
      <linearGradient
        id="linear-gradient-27"
        x1="-1.743"
        y1="0.108"
        x2="-0.972"
        y2="0.656"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#c0bff6" />
        <stop offset="0.29" stopColor="#c5c4f7" />
        <stop offset="0.64" stopColor="#d3d2f9" />
        <stop offset="1" stopColor="#e9e9fd" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-28"
        x1="6.147"
        y1="0.769"
        x2="9.365"
        y2="0.294"
        xlinkHref="#linear-gradient-21"
      />
      <linearGradient
        id="linear-gradient-29"
        x1="0.315"
        y1="4.332"
        x2="0.265"
        y2="0.826"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0.05" stopColor="#394ce1" />
        <stop offset="0.22" stopColor="#3c4ce0" />
        <stop offset="0.36" stopColor="#474cdb" />
        <stop offset="0.49" stopColor="#584bd4" />
        <stop offset="0.61" stopColor="#714bc9" />
        <stop offset="0.73" stopColor="#914abc" />
        <stop offset="0.85" stopColor="#b749ac" />
        <stop offset="0.97" stopColor="#e54898" />
        <stop offset="1" stopColor="#f44892" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-30"
        x1="0"
        y1="0.5"
        x2="4.79"
        y2="0.5"
        xlinkHref="#linear-gradient-29"
      />
      <linearGradient
        id="linear-gradient-31"
        x1="-1.095"
        y1="0.5"
        x2="-0.095"
        y2="0.5"
        xlinkHref="#linear-gradient-29"
      />
      <linearGradient
        id="linear-gradient-32"
        y1="0.5"
        x2="1"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#e1e1f7" />
        <stop offset="0.47" stopColor="#c6c7f0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-33"
        x1="-2.13"
        y1="0.501"
        x2="45.755"
        y2="0.481"
        xlinkHref="#linear-gradient-32"
      />
      <linearGradient
        id="linear-gradient-35"
        x1="14.142"
        y1="0.796"
        x2="37.629"
        y2="1.305"
        xlinkHref="#linear-gradient-32"
      />
      <linearGradient id="linear-gradient-36" x1="0" x2="1" xlinkHref="#linear-gradient-32" />
      <linearGradient
        id="linear-gradient-37"
        x1="-3.395"
        y1="0.469"
        x2="43.02"
        y2="0.839"
        xlinkHref="#linear-gradient-32"
      />
      <linearGradient
        id="linear-gradient-38"
        x1="-0.6"
        y1="-0.05"
        x2="2.03"
        y2="1.243"
        xlinkHref="#linear-gradient-32"
      />
      <linearGradient
        id="linear-gradient-39"
        x1="-0.172"
        y1="0.195"
        x2="3.974"
        y2="2.075"
        xlinkHref="#linear-gradient-32"
      />
      <linearGradient
        id="linear-gradient-40"
        x1="0.505"
        y1="0.484"
        x2="1.104"
        y2="-1.444"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.05" stopColor="#fcfcfd" />
        <stop offset="0.34" stopColor="#eff1f7" />
        <stop offset="0.61" stopColor="#ebedf5" />
      </linearGradient>
    </defs>
    <g id="Asset_1" data-name="Asset 1" transform="translate(42.141 34.682)">
      <g id="Layer_2" data-name="Layer 2" transform="translate(-42.141 -34.682)">
        <g id="Layer_1" data-name="Layer 1">
          <path
            id="Path_1727"
            data-name="Path 1727"
            d="M473.384,273.592,407.842,237.9c-1.665-.915-1.665-2.553,0-3.459l62.778-38.573a2.407,2.407,0,0,0,0-4.219l-72.039-39.488c-2.3-1.336,2.324-2.48,4.576-4.438,3.45-2.1,2.141-2.874.467-3.789l-88.31-48.511a4.814,4.814,0,0,0-4.621,0L287.658,109.6a4.786,4.786,0,0,1-4.631,0L247.108,89.805a4.823,4.823,0,0,0-4.621,0L192.8,120.169a4.429,4.429,0,0,0,0,7.934l12.812,7.083a4.8,4.8,0,0,1,0,8.373l-94.616,57.232a4.786,4.786,0,0,1-4.631,0L84.315,188.9a4.814,4.814,0,0,0-4.631,0l-40.092,24.5c-3.285,1.83-3.258,3.661,0,5.491L78.824,240.4a7.257,7.257,0,0,0,6.461,0l20.133-12.263a7.486,7.486,0,0,1,6.552,0l5.491,3.02c7.834,4.31,9.5,4.438,0,10.3L69.133,270.91a3.171,3.171,0,0,0,0,5.811l63.977,35.69a3.706,3.706,0,0,0,3.578,0l10.14-5.948a3.725,3.725,0,0,1,3.587,0l70.273,38.491a3.66,3.66,0,0,0,3.587,0l50-30.675a3.093,3.093,0,0,1,3.578,0l69.431,37.868a2.416,2.416,0,0,0,2.315,0l123.781-75.526C475.059,275.8,475.059,274.5,473.384,273.592Z"
            transform="translate(14.897 -7.569)"
            fill="url(#linear-gradient)"
          />
          <path
            id="Path_1728"
            data-name="Path 1728"
            d="M431.991,135.36l-35.736-19.529c-8.987-4.905-9.151-13.3-.384-18.65l34.876-21.3a11.256,11.256,0,0,1,10.131-.247L481.06,97.593c6.543,3.578,6.671,9.682.284,13.571l-39.232,23.931A11.256,11.256,0,0,1,431.991,135.36Z"
            transform="translate(-14.998 -6.324)"
            opacity="0.76"
            fill="url(#linear-gradient-2)"
          />
          <path
            id="Path_1729"
            data-name="Path 1729"
            d="M292.2,397.239l-26.887-14.7c-6.763-3.661-6.891-10-.293-14.029l26.237-16a8.474,8.474,0,0,1,7.623-.192l30.2,16.518c4.914,2.69,5.015,7.321.211,10.213l-29.513,17.992A8.456,8.456,0,0,1,292.2,397.239Z"
            transform="translate(-4.029 -29.829)"
            fill="url(#linear-gradient-3)"
          />
          <path
            id="Path_1730"
            data-name="Path 1730"
            d="M266.777,464.229,242.865,451.17c-6.012-3.294-6.131-8.9-.265-12.482l23.345-14.24a7.541,7.541,0,0,1,6.772-.165l26.9,14.7c4.374,2.388,4.466,6.479.192,9.078l-26.246,16.006A7.5,7.5,0,0,1,266.777,464.229Z"
            transform="translate(-2.173 -35.944)"
            fill="url(#linear-gradient-4)"
          />
          <path
            id="Path_1731"
            data-name="Path 1731"
            d="M482.987,363.555l-15.5-8.474c-3.9-2.123-3.972-5.765-.165-8.09l15.127-9.225a4.887,4.887,0,0,1,4.393-.11l17.388,9.527c2.837,1.556,2.892,4.2.128,5.884l-17.021,10.378A4.859,4.859,0,0,1,482.987,363.555Z"
            transform="translate(-21.372 -28.614)"
            fill="url(#linear-gradient-5)"
          />
          <path
            id="Path_1960"
            data-name="Path 1960"
            d="M482.987,363.555l-15.5-8.474c-3.9-2.123-3.972-5.765-.165-8.09l15.127-9.225a4.887,4.887,0,0,1,4.393-.11l17.388,9.527c2.837,1.556,2.892,4.2.128,5.884l-17.021,10.378A4.859,4.859,0,0,1,482.987,363.555Z"
            transform="translate(52.404 -7.333)"
            fill="url(#linear-gradient-5)"
          />
          <path
            id="Path_1732"
            data-name="Path 1732"
            d="M215.455,98.514l-13.434-7.321c-3.377-1.83-3.441-5-.146-7l13.114-8a4.21,4.21,0,0,1,3.8-.092l15.1,8.236c2.462,1.336,2.507,3.661.11,5.1l-14.743,8.987a4.21,4.21,0,0,1-3.8.092Z"
            transform="translate(1.123 -6.422)"
            fill="url(#linear-gradient-7)"
          />
          <path
            id="Path_1733"
            data-name="Path 1733"
            d="M114.338,169.761,85.621,154.066c-7.22-3.944-7.321-10.689-.311-14.981l28.031-17.095a9.042,9.042,0,0,1,8.136-.2l32.3,17.644c5.253,2.874,5.363,7.779.229,10.908l-31.526,19.218a9.033,9.033,0,0,1-8.136.2Z"
            transform="translate(11.249 -10.26)"
            fill="url(#linear-gradient-8)"
          />
          <path
            id="Path_1734"
            data-name="Path 1734"
            d="M520.918,269.365,494.2,254.778c-6.717-3.661-6.845-9.948-.293-13.947l26.072-15.923a8.392,8.392,0,0,1,7.568-.183l30.035,16.408c4.887,2.672,4.978,7.239.21,10.149l-29.284,17.873a8.364,8.364,0,0,1-7.6.21Z"
            transform="translate(-23.458 -19)"
            opacity="0.46"
            fill="url(#linear-gradient-9)"
          />
          <path
            id="Path_1735"
            data-name="Path 1735"
            d="M158.771,381.228,139.334,370.6c-4.9-2.672-4.987-7.239-.22-10.149l18.98-11.522a6.1,6.1,0,0,1,5.491-.137l21.872,11.943c3.56,1.949,3.661,5.271.156,7.385l-21.35,13.013A6.086,6.086,0,0,1,158.771,381.228Z"
            transform="translate(6.541 -29.549)"
            fill="url(#linear-gradient-10)"
          />
          <path
            id="Path_1963"
            data-name="Path 1963"
            d="M158.771,381.228,139.334,370.6c-4.9-2.672-4.987-7.239-.22-10.149l18.98-11.522a6.1,6.1,0,0,1,5.491-.137l21.872,11.943c3.56,1.949,3.661,5.271.156,7.385l-21.35,13.013A6.086,6.086,0,0,1,158.771,381.228Z"
            transform="translate(250.875 -326.31)"
            fill="url(#linear-gradient-10)"
          />
          <path
            id="Path_1736"
            data-name="Path 1736"
            d="M64.043,462.511,19.2,437.994c-11.284-6.168-11.5-16.7-.494-23.418l43.78-26.731a14.111,14.111,0,0,1,12.711-.311l50.46,27.573c8.236,4.484,8.373,12.153.357,17.031L76.764,462.2A14.111,14.111,0,0,1,64.043,462.511Z"
            transform="translate(17.15 -32.771)"
            opacity="0.24"
            fill="url(#linear-gradient-12)"
          />
          <path
            id="Path_1737"
            data-name="Path 1737"
            d="M444.741,458.964l-35.37-19.309c-8.886-4.859-9.06-13.16-.384-18.449l34.5-21.048a11.119,11.119,0,0,1,10.012-.247l39.753,21.725c6.47,3.532,6.6,9.572.284,13.416l-38.8,23.656a11.092,11.092,0,0,1-9.993.256Z"
            transform="translate(-16.118 -33.846)"
            opacity="0.43"
            fill="url(#linear-gradient-13)"
          />
          <path
            id="Path_1959"
            data-name="Path 1959"
            d="M428.718,436.108l-21.924-11.969c-5.508-3.012-5.616-8.157-.238-11.436l21.385-13.047a6.892,6.892,0,0,1,6.206-.153l24.641,13.466c4.01,2.19,4.09,5.933.176,8.316l-24.051,14.663a6.875,6.875,0,0,1-6.194.159Z"
            transform="translate(114.324 -131.365)"
            opacity="0.43"
            fill="url(#linear-gradient-13)"
          />
          <path
            id="Path_1738"
            data-name="Path 1738"
            d="M56,326.566l-5.683-3.1c-1.428-.787-1.455-2.114-.064-2.965l5.546-3.386a1.83,1.83,0,0,1,1.611,0l6.406,3.487a1.144,1.144,0,0,1,0,2.16l-6.232,3.807a1.83,1.83,0,0,1-1.583,0Z"
            transform="translate(13.871 -26.894)"
            fill="url(#linear-gradient-15)"
          />
          <path
            id="Path_1962"
            data-name="Path 1962"
            d="M56,326.566l-5.683-3.1c-1.428-.787-1.455-2.114-.064-2.965l5.546-3.386a1.83,1.83,0,0,1,1.611,0l6.406,3.487a1.144,1.144,0,0,1,0,2.16l-6.232,3.807a1.83,1.83,0,0,1-1.583,0Z"
            transform="translate(-38.856 -90.713)"
            fill="url(#linear-gradient-15)"
          />
          <path
            id="Path_1739"
            data-name="Path 1739"
            d="M14.532,331.763,2.343,325.1c-3.066-1.675-3.13-4.576-.137-6.406l11.9-7.248a3.844,3.844,0,0,1,3.459-.091l13.727,7.495c2.233,1.217,2.279,3.3.1,4.631L18,331.635a3.816,3.816,0,0,1-3.468.128Z"
            transform="translate(18.048 -26.39)"
            opacity="0.6"
            fill="url(#linear-gradient-17)"
          />
          <path
            id="Path_1961"
            data-name="Path 1961"
            d="M14.532,331.763,2.343,325.1c-3.066-1.675-3.13-4.576-.137-6.406l11.9-7.248a3.844,3.844,0,0,1,3.459-.091l13.727,7.495c2.233,1.217,2.279,3.3.1,4.631L18,331.635a3.816,3.816,0,0,1-3.468.128Z"
            transform="translate(-0.002 -130.989)"
            opacity="0.6"
            fill="url(#linear-gradient-17)"
          />
          <path
            id="Path_1740"
            data-name="Path 1740"
            d="M132.67,87.522l-17.552-9.591c-4.411-2.416-4.5-6.534-.192-9.151l17.131-10.442a5.491,5.491,0,0,1,4.969-.128l19.739,10.744c3.212,1.748,3.276,4.75.146,6.662L137.6,87.4a5.491,5.491,0,0,1-4.933.119Z"
            transform="translate(8.565 -4.893)"
            opacity="0.24"
            fill="url(#linear-gradient-19)"
          />
          <g
            id="Group_1035"
            data-name="Group 1035"
            transform="translate(209.751 356.996)"
            opacity="0.13"
          >
            <image
              id="Rectangle_1001"
              data-name="Rectangle 1001"
              width="114.392"
              height="97.004"
              transform="translate(0)"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAABqCAYAAACRU14GAAAACXBIWXMAAAsSAAALEgHS3X78AAALaUlEQVR4Xu2cWa9sNxGF1yrv7j7n3PwuIBBFEDIIEGFSlPHvhAyQAAkvZAIUhAjDv8rpaW/X4qHs3X1uFOUJsbvtdWW5h9Pd+/pzle1yeVMSutqSfdMfdF2fOvQG1aE3qA69QXXoDapDb1AdeoPq0BtUh96gOvQG1aE3qA69QXXoDapDb1AdeoPq0BtUh96gOvQG1aE3qA69QXXoDapDb1AdeoPq0BtUh96gOvQG1aE3qA69QXXoDapDb1AdeoPq0BvU8E1/cMl68vl3SIJAKeePBQkQJEmn+otPX736uzTwWu9E8eTzbxOggTAAxvBqCYCB4Bloh+CCohYyJP3zz69dZ8PgCqF/94V3KIGADOCAAF3rWgipWDockEuYAEwFegbgAPwa4V8N9O/96F1KIgSTlCAMCNhroTzWDN2EsHUADiELAR3SCGBEPM8gnYB/8dn1uP2rgP7Uj9+lCmw5BkiDgBWEDYCVpBXi+SAgQTIAAhDuHcgIyCOA41yIkcBEMsOQv/jkOsBfNPSnX3yPcqdcJmGQa5C0krCWawNgI2GD8lrpDCks/szSA/oIcgRwAHEgcAR5IHEEOZKYaMxm9L//6eXLbTRcKPQf/Op3dBeVZXI3uQZ3reRYS1rLtZG0geNW0kbCRq51WLpWEExAjOhE5gwdR5IHEPvzmoYDySONoxkzE7MZ9fkfX7q8xsMFQn/mpd9TLrrLlD3NwLM2cm3cdaMot3LdSLiRay3XWtIgIUEwQCxf6SAdxMiw6APJHcg9DTsa9zTuzXhglNGMkyVmJnNL1F/e/+VFNeJFQf/hy3+gXJQreVaS+8qzVnJtPOtG7jeedSvXbalvSidYy7UK9z+P6RW6QHpx31Ox7H2BvaVxa8aAn7i3ZEczHpk4WrJsiZlGpxGfvfvzi2jMi4H+7KsfxNgdZfDsg2etlX3jWTeedevud8q69aw7z36jrFt3beRaeYEOVxJgUIHOmNDRmElONB6tAKZxa4m7qO3eEneWeKDZwRKPlmy0xIkn8Pr07Z8tvkEvAvpzr30Qs/MAnjz76iFwv/NJd569Ar/1rNsCfu25uPeY6KVi7QU6RcJB5uK6RxoPlrhn4s6S7Szx3pJtLXFbnu9ssAMTDzP46DROoz5568VFN+rioT//+oeURDlMPrv0tQfwW5/81rPf5YB+55Pf+RTAo2ijrLU/cPGyGNcBECKZSWQaRxb3bYkHDgE4JdvaYFtLvI/a7m3g3pLtLdnBEkcmTiQzDU5SH/96ueAXH3uXAMwRNiUBScCqzMg30jxu3yjc/M0MfNJj4H0tx1CCNzUe7wXWRONowgBjEmgx8BsdAugATXRBJskJmRRLfYqxEoirjbJYXcIuW90ksbLGXsG1ivX4bMHF1fumuPNNAR6eYPK7POVHtc6jP8pTfqI8fiKP+Yk8+iOf/FEe/S5nv/WpdiLfuPtGp1VBFOkGwqau/1Hj+uV6n3vtgzpRXJwWbenPv/4hYzENSjAIKcZkDcVV17IuE7WVu6+VPdz/pE3OuvHJb5UVnSI6zKDi3gk4IugySjxYgsX+jCPGenNS2alM0+iuia5RrkmKAnGSFOt90c4sfpFaNPQiIizIJJmEJGGAMEQUrpYyQz+N32t332h66OpPE7oCPdz7pMTRZAY5AYg0dyqTmty0os8dbZAUIV3HAMcgUyIY638W5Iu184VDjygpCKkUGKQCP2byxeoHCanAjw6QtS4dYFOs/NYnv1HWxl118wUgPMZyHmOcNzCCu5mmcfYmmtf5g3z2OCkmhbQS5TMCFEAG9kVa+6Kh48xeVMbK4uZtjqwJDzvAKQZfI3Urz9qUclOWcSsV6AzoR8gMcJHIbhxZhwtpRVcK0EjwGXaJ7CEpvBApngNfrJYOPcbzCjxCp+HuBZZ5tBX4qXiBVKw+VfjV+lWtP2stKQEgyUyBoItuk7tWDMsOsK5UvjtJshLYOXW28EIWrEEIBJft3xcPfXaQ89INNUkiGligYn+8eoGAUDrD7IZPQ0F119W9GwjJOcW2LJJOncdiEilT/JaVoE65hrnEN80Xy+USx9KXbKcR8dS4X32N5TWWt2fPgGp5Z51lhnWy1vK+CCg+q8fK6ffO65Dmoecr7z33+jKXbcu2dKJCPi2BTs2ouZx1h0rv7L05aMKzxyAcAEiW1yiA8dnHsZ9+77wO8QHpB+99/OYyo3LLhg6cwJ9sOuCBM5QAXWPoUGyVUqjRtoirZ5KTGScPK49OwrrRgomGDCJi6LHz5gRUHkdHIc+u4UGZL/L0fJlaPPRitVABiwjMesCeQecCxOc4+mmrNGrjyMQjI7zqEs9n76OZHcsO20hDfI7MMNbvjs4Qv+2lQzmjgzkiA+fMayxXS4c+u1QG7QrZT7CLVRoDdIVtnMw4KnGk82iJCSIBk6gJZZJWNlomix2zQ2y42JGx2zbOnSY6UoYVz0FmsCRPAvV5JuB8eO2L06KhR3BLQh13qTNrnl12LlBm2LNVOwczDhpYQqsQTbkGcwDMETmm2FkrW6oHS3N61Fg6wDT/DjGCGElMc40AjtOcYLFaNPSicOfFmkiFxZXGptU6ACnxaM5BxgHJBgHJyihBIrtrhGvQaeWi6hVoPNpge0sse+U8MFWXz2MpkTbFuRxBjmdW74ih6Ov+P/93LXrJ9tGbP43JVnXrkYc+RnYqR5JHcoZxnMfmZEdLdog9b+7SYLs0cGuDbdPKtrZK92mwKKv0ZRrsfn4v2c4G21myPWOvfM9Il9qRUUDuSOxA7EEcEanTBXhM9Oq1L1EXYOkPJm+ZwETiSGM6K4MZE5INkifTPH4TADxW5yWWPu+nnyVRxLhevEWM66XD0GrGDLc03tN4T+Ie5A7ggcCRZwcjwOWO5VUXAB1AWRYRcBETSANlIEgr/5KRcrNEQsWBReKDg8o0TiUce55EUaDPiZEjE0czq6lSW0u8p9k9jV/S+CWJbVg89iQOiNTpicXSl54qBWD56VJAyZHzCId69qSsoaRMrUs+3I1nv1PWI8+6ixSqSI70yKhZl63XOP1yFk6tyy0aMw2R6Wrc0WxniVsmfmnG+5IYuWXNkauJkYNNluhm9M9++4vlNyYuBDoAPPvKB5Erl2Xunjxr8OwrzTtoXlOf7zz7nc7ToGtiZNl8wXk2bMy2vQRoYnIWqc87Jt5bWHjJirWSDcuDJZtsYC5p0BeV+34x0IGS954FdzfPCot3r4kTda88Djlk3fnp0MNGKomRwlDz3gWAda4QM/A9yT2JXQG/JUsHsLKUi5z3ycyyDfS/XeApl4uCXvX9X75PzyUHPsAPioyYTclz38jxIJ9NpzNtK6jkvsdcYSIwgTwC2JPYg9yS2JHcg9gylml16TYxMf/jo1cur+GKLhI6ADz9s/fqaZew+np4cT7CNGfLbiBsJK0hrITZ0gO6It6OOKl6ALAHuSOwx+ksW43MZSb6pZ9evVjoVU/95Df0LD7cM8cK0lqRqRo15lOrQ1muVUvPACbFufQDKnjgwDjFWmPx+tdfX/evu45L0sVDr3ryhXcoP0+cwKrM1NcAyvn0B6nKpmrpQIY0CjhAOAI6AoyAC5H/8/kbVwG76mqgV33n2beps6wZRCxihYe3IIn89LjZUIbkAka4JgEjdAqp/udvb1xXA+EKoVd9+5m3In0qbjRUQSfWe85EitX5zYWyBC91vkbYVVcLvepbz7xFAGS17sdvKybN95kq0PXvz68XONAA9K6vatG7bF3/G3XoDapDb1AdeoPq0BtUh96gOvQG1aE3qA69QXXoDapDb1AdeoPq0BtUh96gOvQG1aE3qA69QXXoDapDb1AdeoPq0BtUh96gOvQG1aE3qA69QXXoDapDb1AdeoPq0BtUh96gOvQG1aE3qP8ClkpXRuoqn9oAAAAASUVORK5CYII="
            />
          </g>
          <g
            id="Group_1036"
            data-name="Group 1036"
            transform="translate(228.969 292.021)"
            opacity="0.13"
          >
            <image
              id="Rectangle_1002"
              data-name="Rectangle 1002"
              width="122.628"
              height="102.495"
              xlinkHref="data:image/png;base64,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"
            />
          </g>
          <ellipse
            id="Ellipse_177"
            data-name="Ellipse 177"
            cx="8.19"
            cy="4.768"
            rx="8.19"
            ry="4.768"
            transform="translate(195.649 174.006)"
            fill="#ced3f4"
          />
          <ellipse
            id="Ellipse_178"
            data-name="Ellipse 178"
            cx="12.309"
            cy="7.312"
            rx="12.309"
            ry="7.312"
            transform="translate(191.064 170.638)"
            fill="url(#radial-gradient)"
          />
          <path
            id="Path_1741"
            data-name="Path 1741"
            d="M214.9,168.56H189.08v1.364c1.016,7.4,2.819,21.048,4.923,24.187a7.7,7.7,0,0,0,5.573,3.34,22.886,22.886,0,0,0,2.407.128,14.7,14.7,0,0,0,1.83-.073,7.834,7.834,0,0,0,5.683-3.194c2.379-3.249,4.411-17.1,5.363-24.388C214.905,169.878,214.9,168.56,214.9,168.56Z"
            transform="translate(2.002 -14.303)"
            fill="url(#linear-gradient-20)"
          />
          <ellipse
            id="Ellipse_179"
            data-name="Ellipse 179"
            cx="12.922"
            cy="7.522"
            rx="12.922"
            ry="7.522"
            transform="translate(191.064 146.561)"
            fill="url(#linear-gradient-21)"
          />
          <path
            id="Path_1742"
            data-name="Path 1742"
            d="M201.984,175.7c-6.982,0-12.656-3.23-12.894-7.257a2.2,2.2,0,0,0,0,.256c0,4.155,5.793,7.522,12.922,7.522s12.931-3.368,12.931-7.522a2.2,2.2,0,0,0,0-.256C214.631,172.467,208.976,175.7,201.984,175.7Z"
            transform="translate(2.002 -14.293)"
            fill="url(#radial-gradient-2)"
          />
          <path
            id="Path_1743"
            data-name="Path 1743"
            d="M214.233,167.679a4.832,4.832,0,0,1-1.83,3.6c-2.16,1.94-5.985,3.212-10.341,3.212s-8.181-1.272-10.332-3.2a4.85,4.85,0,0,1-1.83-3.606c0-3.761,5.491-6.809,12.18-6.809S214.233,163.917,214.233,167.679Z"
            transform="translate(1.933 -13.65)"
            opacity="0.49"
            fill="url(#linear-gradient-22)"
          />
          <path
            id="Path_1744"
            data-name="Path 1744"
            d="M212.563,171.812c-2.16,1.94-5.985,3.212-10.341,3.212s-8.181-1.272-10.332-3.2c1.062-2.645,5.28-4.621,10.332-4.621S211.492,169.177,212.563,171.812Z"
            transform="translate(1.764 -14.188)"
            opacity="0.49"
            fill="url(#linear-gradient-23)"
          />
          <path
            id="Path_1745"
            data-name="Path 1745"
            d="M220.12,178.818c-1.126-2.919-4.695-3.578-4.695-3.578L213,176.631s3.532.659,4.649,3.542,1.116,7.175-4.109,9.627c.54-.247,1.711-.915,2.416-1.226C221.236,186.093,221.236,181.728,220.12,178.818Z"
            transform="translate(-0.028 -14.87)"
            fill="url(#linear-gradient-24)"
          />
          <path
            id="Path_1746"
            data-name="Path 1746"
            d="M217.254,180.3c-1.116-2.883-4.649-3.542-4.649-3.542l.073.915c.76.284,3,.915,3.752,2.9,1.473,3.789,0,6.809-3.661,8.538a19.446,19.446,0,0,1-3.734,1.3l-.439,1.208s-.75.805,4.512-1.647S218.37,183.184,217.254,180.3Z"
            transform="translate(0.349 -14.999)"
            fill="url(#linear-gradient-25)"
          />
          <path
            id="Path_1747"
            data-name="Path 1747"
            d="M215.034,188.71l-.183.128a7.714,7.714,0,0,1-2.883.915l-2.928,1.675a19.446,19.446,0,0,0,3.734-1.3,8.912,8.912,0,0,0,2.26-1.418Z"
            transform="translate(0.308 -16.013)"
            fill="url(#linear-gradient-26)"
          />
          <g
            id="Group_1037"
            data-name="Group 1037"
            transform="translate(144.776 138.279)"
            opacity="0.36"
          >
            <image
              id="Rectangle_1003"
              data-name="Rectangle 1003"
              width="169.3"
              height="123.543"
              transform="translate(0 0)"
              xlinkHref="data:image/png;base64,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"
            />
          </g>
          <path
            id="Path_1748"
            data-name="Path 1748"
            d="M192.787,232.261l60.573-34.967c6.827-3.944,12.373-14.532,12.373-23.638V12.336c0-4.631,3.807-5.656,1.5-7.321-.092-.064-9.243-4.164-9.344-4.2a8.913,8.913,0,0,0-8.364.485L188.953,36.267C182.117,40.211,176.58,50.8,176.58,59.9v161.32c0,4.841,1.565,8.291,4.054,9.865.146.1,10.387,4.832,10.551,4.887C193.437,236.718,189.776,233.99,192.787,232.261Z"
            transform="translate(3.063 0.002)"
            fill="url(#linear-gradient-27)"
          />
          <path
            id="Path_1749"
            data-name="Path 1749"
            d="M272.4,15.467v161.32c0,9.106-5.546,19.694-12.373,23.629l-60.573,34.976c-6.836,3.944-12.373-.247-12.373-9.353V64.729c-.677-12.647,5.491-19.694,12.373-23.647L260.031,6.115C266.858,2.225,272.4,6.362,272.4,15.467Z"
            transform="translate(2.176 -0.393)"
            fill="#fff"
          />
          <path
            id="Path_1750"
            data-name="Path 1750"
            d="M194.66,235.763a8.685,8.685,0,0,0,4.3-1.318l60.573-34.976c6.479-3.743,11.759-13.864,11.759-22.567V15.581C271.311,9.743,268.84,6,265.052,6a8.621,8.621,0,0,0-4.292,1.318L200.187,42.267C193.7,46.01,187.97,53.788,188.428,64.843V226.154C188.428,232.038,190.871,235.763,194.66,235.763Z"
            transform="translate(2.06 -0.507)"
            fill="url(#linear-gradient-28)"
          />
          <path
            id="Path_1751"
            data-name="Path 1751"
            d="M268.648,179.36V18.662c0-6.69-4.063-9.764-9.078-6.864L200.6,45.842c-6.928,3.569-9.508,10.57-9.508,17.3l.43,160.78c0,6.68,4.072,9.755,9.078,6.864l58.971-34.052C264.584,193.8,268.648,186.04,268.648,179.36Z"
            transform="translate(1.832 -0.907)"
            fill="#afb6e5"
          />
          <path
            id="Path_1752"
            data-name="Path 1752"
            d="M267.589,18.61v162.5c0,5.427-3.834,12.025-8.547,14.752l-57.653,33.256c-4.713,2.745-8.538.558-8.538-4.878V61.75c0-5.436,3.825-12.034,8.538-14.761l8.319-4.8.458-.265.165-.1.394-.229.265-.146.6-.348h.064l.3-.174.577-.339.805-.458h0l.512-.284,1.007-.595.32-.192,1.089-.613.375-.22,1.052-.558.339-.192.915-.54.394-.22.814-.476.549-.32.65-.366.915-.522.3-.174.915-.54.146-.092L225.1,33.4l.165-.11,1.83-1.062,31.975-18.449C263.755,11.005,267.589,13.183,267.589,18.61Z"
            transform="translate(1.682 -1.065)"
            fill="#fff"
          />
          <path
            id="Path_1753"
            data-name="Path 1753"
            d="M242.2,202.4c-.092,0-2.8-.723-3.038-.805a29.2,29.2,0,0,0-5.61-1.592c-1.638-.247-3.935.238-3.194,2.745a11.476,11.476,0,0,0,6.671,6.946c1.007.421,2.26.522,3.459,1.116.915.467,1.135,1.235,1.83,1.757a4.814,4.814,0,0,0,4.484.595c1.492-.512,2.032-1.144,2.389-2.938a15.211,15.211,0,0,0,0-5.811C245.694,204.681,243.306,203.51,242.2,202.4Z"
            transform="translate(-1.489 -16.967)"
            fill="#444c56"
            fillRule="evenodd"
          />
          <path
            id="Path_1754"
            data-name="Path 1754"
            d="M230.592,200.8c-.778.915-.275,2.48.174,3.459a12.19,12.19,0,0,0,6.26,5.674c1.007.421,2.242.659,3.441,1.254.915.467,1.116,1.116,1.83,1.638a5.015,5.015,0,0,0,4.576.622c1.409-.485,1.9-1.263,2.26-2.874a2.791,2.791,0,0,1-1.885,1.629,5.015,5.015,0,0,1-4.576-.622c-.686-.522-.915-1.171-1.83-1.629a38.365,38.365,0,0,0-3.661-1.153c-2.819-1.181-5.866-3.285-6.854-6.626a1.62,1.62,0,0,1,.265-1.373Z"
            transform="translate(-1.486 -17.039)"
            fill="#e161e8"
            fillRule="evenodd"
          />
          <path
            id="Path_1755"
            data-name="Path 1755"
            d="M250.392,198.885a17.04,17.04,0,0,0-.238,4.576,2.26,2.26,0,0,1-2.059,2.8c-1.9.366-5.308-1.464-4.987-3.478a27.869,27.869,0,0,0-.247-5.674Z"
            transform="translate(-2.562 -16.726)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1756"
            data-name="Path 1756"
            d="M246.466,206.211c-1.748-.458-3.6-1.83-3.359-3.377a27.869,27.869,0,0,0-.247-5.674l3.715.851C246.191,200.674,246.5,203.182,246.466,206.211Z"
            transform="translate(-2.562 -16.73)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1757"
            data-name="Path 1757"
            d="M249.86,192.841c.659-4.85,1.473-20.746,1.418-25.166-.046-5.088-1.922-8.5-2.819-17.342-.723-7.019,1.73-14.413,2.48-21.432,1.565-6.58,1.647-11.11-4.045-21.8l-5.335-2.242c-2.279,5.427-4.786,5.8-5.491,12.327a77.987,77.987,0,0,0,1.62,28.863c.3,1.171.824,3.139,1.162,4.8s.979,1.235,1.19,4.31c.174,2.425.055,10.231.769,14.981.613,4.109.229,18.6.293,21.478C241.5,195.586,247.48,196.108,249.86,192.841Z"
            transform="translate(-1.929 -8.897)"
            fill="#501cd7"
            fillRule="evenodd"
          />
          <path
            id="Path_1758"
            data-name="Path 1758"
            d="M251.055,127.866c.915-5.207.915-12.363-3.926-22.238l-5.683-.778c-2.279,5.427-4.786,5.8-5.491,12.327-1.034,9.051-3.249,16.61-.7,27.225,1.464,6.122,3.4,9.883,3.908,13.379s.824,8.41,1.107,12.363c.293,4.136.622,18.779.677,21.652.092,1.995,2.663,3.413,4.457,3.075.064-9.618.577-26.054,0-31.773a107.521,107.521,0,0,0-1.986-11.9c-1.254-6.891-1.83-8.438-1.83-15.676C244.988,134.473,249.133,132.6,251.055,127.866Z"
            transform="translate(-1.816 -8.896)"
            fill="#3a07ba"
            fillRule="evenodd"
          />
          <path
            id="Path_1759"
            data-name="Path 1759"
            d="M219.91,128.4c.064-3.23,1.977-8.236,3.23-12.528l6.7,5.884C230.059,134.438,220.1,133.441,219.91,128.4Z"
            transform="translate(-0.614 -9.831)"
            fill="#94c7e0"
            fillRule="evenodd"
          />
          <path
            id="Path_1760"
            data-name="Path 1760"
            d="M237.486,200.222c-.348-3.313-3.057-9.673-3.706-11.494l6.552-3.368c2.032,4.576.512,7.129,3.249,9Z"
            transform="translate(-1.791 -15.729)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1761"
            data-name="Path 1761"
            d="M237.486,200.375c-.348-3.313-3.057-9.673-3.706-11.494l3.349-1.72c.979,5.921,1.336,7.751,2.608,11.046Z"
            transform="translate(-1.791 -15.881)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1762"
            data-name="Path 1762"
            d="M238.109,199.941c1.894-2.334,1.647-4.978,4.878-5.381a5.034,5.034,0,0,1,2.517.988c3.276.512,3.331,3.349,2.645,5.957-.641,2.425-1.327,2.672-1.373,3.944a5.71,5.71,0,0,0,.357,1.666c.595,2.013-.723,4.438-1.638,5.674-1.409,1.9-4.887,3.294-7.44,3.057-.915-.082-1.025-1.83-.869-3.047.329-2.48.778-3.56.915-4.96a20.389,20.389,0,0,0-.329-5.235,3.478,3.478,0,0,1,.339-2.663Z"
            transform="translate(-2.075 -16.509)"
            fill="#525a68"
            fillRule="evenodd"
          />
          <path
            id="Path_1763"
            data-name="Path 1763"
            d="M244.8,195.51c3.862.192,4.1,3.285,3.377,6.076-.631,2.434-1.327,2.672-1.373,3.944a5.711,5.711,0,0,0,.357,1.666c.595,2.013-.723,4.438-1.638,5.674-1.409,1.9-4.887,3.294-7.44,3.057a.787.787,0,0,1-.6-.394c-.265-.43.494-2.837.8-3.423a19.383,19.383,0,0,0,1.949-4.484c.348-1.4.082-3.56.357-5.189C241.264,198.338,241.831,195.958,244.8,195.51Z"
            transform="translate(-2.1 -16.59)"
            fill="#e161e8"
            fillRule="evenodd"
          />
          <path
            id="Path_1764"
            data-name="Path 1764"
            d="M248.048,197.222a6.131,6.131,0,0,1,.183,4.466c-.631,2.434-1.327,2.672-1.373,3.944a5.71,5.71,0,0,0,.357,1.666c.595,2.013-.723,4.438-1.638,5.674-1.409,1.9-4.887,3.294-7.44,3.057a.677.677,0,0,1-.357-.128,3.23,3.23,0,0,1,.366-1.537c1.052-2.443,3.661-5.921,3.935-8.236.137-1.107-.073-1.995,0-2.992a8.566,8.566,0,0,1,1.528-4.878C244.561,196.911,246.62,196.124,248.048,197.222Z"
            transform="translate(-2.131 -16.691)"
            fill="#2a2733"
            fillRule="evenodd"
          />
          <path
            id="Path_1765"
            data-name="Path 1765"
            d="M229.322,156.277c.393-7.092,3.532-14.331,5.71-21.048,9.38-5.692,7.943-15.008,3.99-21.469l-10.012-3.349c-3.084,4.923-5.683,4.777-7.431,11.082a77.246,77.246,0,0,0-2.965,28.607c.11,1.217.311,3.267.384,4.978C220.546,163.4,228.837,161.676,229.322,156.277Z"
            transform="translate(-0.481 -9.368)"
            fill="#501cd7"
            fillRule="evenodd"
          />
          <path
            id="Path_1766"
            data-name="Path 1766"
            d="M240.856,189.1c-1.336-6.47-3.4-16.18-4.576-19.4-1.656-4.576-4.832-6.589-6.79-11.65l-.458-.988c-1.73-3.45-9.966-3.249-10,.329,0,3.212.915,4.713,3.029,8.1.915,2.242,3.761,8.877,5.756,13.3a111.5,111.5,0,0,1,4.713,12.684C236.436,192.247,238.962,191.14,240.856,189.1Z"
            transform="translate(-0.539 -13.117)"
            fill="#501cd7"
            fillRule="evenodd"
          />
          <path
            id="Path_1767"
            data-name="Path 1767"
            d="M235.655,134.817c8.685-5.72,7.23-14.752,3.368-21.048l-10.012-3.359c-3.084,4.923-5.683,4.777-7.431,11.082a77.246,77.246,0,0,0-2.965,28.607c.082.97.229,2.462.329,3.9.046,3.2,1.373,5.134,3.02,7.742.915,2.242,3.761,8.877,5.756,13.3a111.5,111.5,0,0,1,4.713,12.684,9.911,9.911,0,0,0,4.731-.073,105.4,105.4,0,0,0-6.745-20.874c-1.574-3.441-3.661-5.354-5.893-9.151-1.354-2.352-1.309-1.894-1.144-4.576.375-6.241,1.336-16.619,2.462-23.281C228.031,133.956,233.175,135.567,235.655,134.817Z"
            transform="translate(-0.481 -9.368)"
            fill="#3a07ba"
            fillRule="evenodd"
          />
          <path
            id="Path_1768"
            data-name="Path 1768"
            d="M251.17,116.4c.275,6.69-2.9,12.1-9.764,14.175a8.364,8.364,0,0,1-3.606.284c-6.79-.842-12.977-9.289-14.468-16.088a45.122,45.122,0,0,0-3.432,9.06c.293-3.725,2.141-10.066,3.13-13.727a42.783,42.783,0,0,0,1.281-17.79c-.915-6.644-3.148-10.616-1.949-13.352,2.471-5.637,18.019-12.574,24.041-13.242,6.781-.787,6.781,10.918,3.926,15.932-2.233,3.908-3.5,10.231-3.661,14.908C246.457,103.914,250.832,108.069,251.17,116.4Z"
            transform="translate(-0.613 -5.572)"
            fill="#ef81b9"
            fillRule="evenodd"
          />
          <path
            id="Path_1769"
            data-name="Path 1769"
            d="M237.8,132.192c-6.79-.842-12.977-9.289-14.468-16.088a45.123,45.123,0,0,0-3.432,9.06c.293-3.725,2.141-10.066,3.13-13.727a42.783,42.783,0,0,0,1.281-17.79c1.547-4.118,4.621-12.217,4.621-12.217A11.75,11.75,0,0,1,230.57,91.5c-1.583,6.076-4.667,20.709-1.83,27.454C230.772,123.81,235.439,129.539,237.8,132.192Z"
            transform="translate(-0.613 -6.909)"
            fill="#e24493"
            fillRule="evenodd"
          />
          <path
            id="Path_1770"
            data-name="Path 1770"
            d="M236.41,70.78a37.331,37.331,0,0,0-4.85-8.392l7.568-5.436,1.913-1.592a15.731,15.731,0,0,0,4.2,9.636C245.305,69.389,237.453,72.638,236.41,70.78Z"
            transform="translate(-1.603 -4.696)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1771"
            data-name="Path 1771"
            d="M227.92,65.654c.4.339,3.4-.732,4.475-1.638.988,1.83,2.233,3.871,3.606,6.3.146.275-.714-4.621,6.351-9.353a5.107,5.107,0,0,1-.1-2.315c.577-1.83,2.16-4.219,2.242-6.864C242.251,48.806,234.134,56.566,227.92,65.654Z"
            transform="translate(-1.294 -4.338)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1772"
            data-name="Path 1772"
            d="M227.538,64.663c.842.247,4.631-3.423,5.042-3.523,3.963-1,8.794-2.114,9.225-3.5.577-1.83,2.16-4.219,2.242-6.863.137-4.219-1.437-8.456-5.848-10.405-7.678-3.377-16.061,3.359-15.63,9.691.183,2.6,1.226,2.956,1.611,4.576a11.9,11.9,0,0,1-.211,2.3c-.082.439.915,1.977,1.647,4.036C226.266,62.75,226.961,64.48,227.538,64.663Z"
            transform="translate(-0.838 -3.347)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1773"
            data-name="Path 1773"
            d="M227.538,65.32c.21.064.622-.128,1.116-.448A5.1,5.1,0,0,0,229.1,62c-.75-2.535-2.581-4.265-2.846-5.3-.558-2.187.448-1.29-1-3.432a3.194,3.194,0,0,1-.522-2.407c0-1.364-1.519-3.661-1.519-3.661a5.83,5.83,0,0,0-.494,1.483,7.321,7.321,0,0,0-.156,2.041c.183,2.6,1.226,2.956,1.611,4.576a11.892,11.892,0,0,1-.21,2.3c-.082.439.915,1.977,1.647,4.036C226.266,63.407,226.961,65.137,227.538,65.32Z"
            transform="translate(-0.839 -4.004)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1774"
            data-name="Path 1774"
            d="M212.711,86.166l-7.257-8.337h0a2.553,2.553,0,0,0-.622-.549,1.583,1.583,0,0,0-1.272.055l-4.64,1.83a.915.915,0,0,0-.7.668h0a.119.119,0,0,0,0,.055l-.137.833a.851.851,0,0,0,0,.4v.082a1.931,1.931,0,0,0,.348.641l7.166,8.538c.622.741,1.034,1.043,1.949.613l4.914-2.27c.375-.174.54-.4.558-.65l.156-.915h0a1.318,1.318,0,0,0-.458-1Z"
            transform="translate(1.241 -6.547)"
            fill="#665861"
            fillRule="evenodd"
          />
          <path
            id="Path_1775"
            data-name="Path 1775"
            d="M205.356,77.992l7.257,8.337c.631.659.458,1.025,0,1.245l-4.978,2.27c-.732.339-1.052.22-1.7-.558l-7.175-8.547c-.577-.732-.393-1.2.247-1.418l4.649-1.83C204.67,77.187,204.853,77.489,205.356,77.992Z"
            transform="translate(1.21 -6.564)"
            fill="#160004"
            fillRule="evenodd"
          />
          <path
            id="Path_1776"
            data-name="Path 1776"
            d="M205.354,78.673l6.141,7.047c.531.567.384.915,0,1.062l-4.219,1.931c-.622.284-.915.183-1.446-.476l-6.067-7.23c-.494-.622-.329-1.016.21-1.208l3.935-1.51C204.787,78.014,204.942,78.243,205.354,78.673Z"
            transform="translate(1.121 -6.632)"
            fill="#311b38"
            fillRule="evenodd"
          />
          <path
            id="Path_1777"
            data-name="Path 1777"
            d="M205.664,93.485c-1.217-1.83-6.973-4.008-7.065-5.628L198.27,82c.677.833,1.83,2.132,2.544,2.9l2.636,2.745-.915-2.114c-.32-.769-.97-2.626,0-2.974.192-.064.677.485,1.409,1.885s1.391.915,2.883,2.6c1.126,1.245,1.007,2.4,3.34,3.834Z"
            transform="translate(1.222 -6.957)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1778"
            data-name="Path 1778"
            d="M205.481,93.412c-.842-1.19-1.83-1-3.4-1.968s-3.441-2.745-3.487-3.587L198.27,82a7.852,7.852,0,0,0,1.748,3.715c1.089.915,3.038,1.968,3.761,2.745l-.329-.86a26.82,26.82,0,0,1-1.245-3.084c-.174-.668-.293-1.473.128-1.83a5.619,5.619,0,0,0,.229,1.537,10.57,10.57,0,0,0,2.4,4.374c1.116,1.245,3.121,1.19,3.45,3.889Z"
            transform="translate(1.222 -6.957)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1779"
            data-name="Path 1779"
            d="M224.622,77.387c-3.285,1.977-5.591,15.347-6.955,23.537-1.2,2.855,5.9,9.481,7.577,2.69.988-3.99,2.279-9.362,2.892-12.684.677-3.661,1.986-10.68-1.19-13.059A2.559,2.559,0,0,0,224.622,77.387Z"
            transform="translate(-0.412 -6.554)"
            fill="#ef81b9"
            fillRule="evenodd"
          />
          <path
            id="Path_1780"
            data-name="Path 1780"
            d="M222.5,99.85,209.87,89.884c-2.956-1.51-5.582,3.423-4.484,5.253l12.748,11.622c1.885,1.089,3.5,1.281,4.493.723,1.19-.668,1.565-2.334,1.519-3.88A5.564,5.564,0,0,0,222.5,99.85Z"
            transform="translate(0.64 -7.602)"
            fill="#ef81b9"
            fillRule="evenodd"
          />
          <path
            id="Path_1781"
            data-name="Path 1781"
            d="M206.27,91.19c-1.016,1.29-1.537,3.1-.915,4.081L216.9,105.8a6.607,6.607,0,0,0,3.441,2.05,3.084,3.084,0,0,0,2.26-.229,2.526,2.526,0,0,0,.805-.75C220.409,107.031,209.583,97.074,206.27,91.19Z"
            transform="translate(0.644 -7.737)"
            fill="#e24493"
            fillRule="evenodd"
          />
          <path
            id="Path_1782"
            data-name="Path 1782"
            d="M223.778,77.952c-2.819,1.656-4.045,10.259-5.088,17,.686,2.48.988,4.136,2.745,6.406-1.766-5.637,3.276-20.234,5.1-23.793A3.414,3.414,0,0,0,223.778,77.952Z"
            transform="translate(-0.511 -6.569)"
            fill="#e24493"
            fillRule="evenodd"
          />
          <path
            id="Path_1783"
            data-name="Path 1783"
            d="M244.976,63.114c-4.365-5.958,2.517-11.366-2.544-19.218a10.615,10.615,0,0,0-4.777-3.972c-4.823-2.077-10.7,0-13.727,4.21-2.745,2.745-1.464,9.829,6.232,13.617l.1-.046C233.436,61.128,238.689,66.463,244.976,63.114Z"
            transform="translate(-0.843 -3.317)"
            fill="#361d07"
            fillRule="evenodd"
          />
          <path
            id="Path_1784"
            data-name="Path 1784"
            d="M242.468,43.933a.19.19,0,0,1,0-.055,10.616,10.616,0,0,0-4.814-3.953c-4.823-2.077-10.7,0-13.727,4.21-1.483,1.51-1.83,4.3-.485,7.147L223.4,51a22.1,22.1,0,0,1-.329-3.725,6.2,6.2,0,0,0,2.215,3.926,9.911,9.911,0,0,1-1.492-5.491,6.022,6.022,0,0,0,1.666,3.825,8.154,8.154,0,0,1-.348-4.9c.073,1.409.082,1.693,1.519,3.725a9.152,9.152,0,0,1-.265-4.319,13.984,13.984,0,0,0,1.464,2.91,29.077,29.077,0,0,1-.311-3.5,28.422,28.422,0,0,1,1.858,2.874,12.719,12.719,0,0,0-.915-3.661,8.181,8.181,0,0,1,2.407,2.91,8.236,8.236,0,0,0-1.062-3.111,4.978,4.978,0,0,1,2.434,2.361,6.2,6.2,0,0,0-1.025-2.745,6.022,6.022,0,0,1,2.544,2.187,5.253,5.253,0,0,0-1.08-2.617,8.4,8.4,0,0,1,3.1,2.526,8.832,8.832,0,0,0-1.235-2.883,14.742,14.742,0,0,1,2.864,2.1,16.545,16.545,0,0,0-1.528-2.645,10.47,10.47,0,0,1,3.038,2.59,5.2,5.2,0,0,0-1.437-2.471,20.13,20.13,0,0,1,3.02,2.645,7.083,7.083,0,0,0-1.958-2.745,16.9,16.9,0,0,1,3.889,3.148Z"
            transform="translate(-0.843 -3.317)"
            fill="#4a2b12"
            fillRule="evenodd"
          />
          <path
            id="Path_1785"
            data-name="Path 1785"
            d="M231.184,59.785c-.622-.915-.412-1.336.046-1.345a2.91,2.91,0,0,1,1.995,1.428c1.007,1.5.741,3.807-1.071,3.413C231.559,62.851,231.733,61.3,231.184,59.785Z"
            transform="translate(-1.538 -4.958)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1786"
            data-name="Path 1786"
            d="M231.184,59.785c-.622-.915-.412-1.336.046-1.345a2.91,2.91,0,0,1,1.995,1.428c1.007,1.5.741,3.807-1.071,3.413,1.391-.284.833-1.9.146-2.819C231.843,59.868,231.276,59.474,231.184,59.785Z"
            transform="translate(-1.538 -4.958)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1787"
            data-name="Path 1787"
            d="M231.985,60.22c-.2.814-.22,1.272,0,1.492s.448.275.778-.265A2.544,2.544,0,0,0,231.985,60.22Z"
            transform="translate(-1.626 -5.109)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1788"
            data-name="Path 1788"
            d="M253.775,68.1a17.086,17.086,0,0,1-9.325,9.087,21.329,21.329,0,0,1-2.37.75s2.022-3.2-3.368-6.223c-5.2-2.919-6.763-.741-5.491-9.49,1.034-7-3.661-5.921-3.88-4.96,0,0-6.8-3.715-7.321-8.181-.476-4.045.476-9.618,6.937-10.277a13.389,13.389,0,0,1,2.581,0s12.812-3.322,14.029,7.623C247.122,59.991,255.121,57.017,253.775,68.1Z"
            transform="translate(-0.784 -3.251)"
            fill="#4a2b12"
            fillRule="evenodd"
          />
          <path
            id="Path_1789"
            data-name="Path 1789"
            d="M245.21,72.846c.869,1.3.476,2.581-.76,4.374a21.33,21.33,0,0,1-2.37.75s2.022-3.2-3.368-6.223c-5.2-2.919-6.763-.741-5.491-9.49,1.034-7-3.661-5.921-3.88-4.96,0,0-6.8-3.715-7.321-8.181-.476-4.045.476-9.618,6.937-10.277-.668.2-6.223,3.853-4.576,9.316,2.013,6.571,8.236,4.823,10.469,9.847s-1.876,7.1,3.615,10.652S244.093,71.181,245.21,72.846Z"
            transform="translate(-0.784 -3.294)"
            fill="#301909"
            fillRule="evenodd"
          />
          <path
            id="Path_1790"
            data-name="Path 1790"
            d="M267.588,18.61v162.5c0,5.427-3.834,12.025-8.547,14.752l-57.653,33.265c-2.489,1.437-4.722,1.519-6.278.467-1.409-.915-2.27-2.745-2.27-5.344V61.75c0-5.427,3.825-12.025,8.547-14.752l8.355-4.75.458-.275.165-.092.393-.229.265-.146.6-.348h.064l.3-.174.577-.339.805-.448h0l.512-.284,1.007-.586.32-.192,1.089-.622.375-.21,1.016-.631.339-.183.915-.54.394-.229.814-.467.549-.329.65-.357.915-.531.311-.174.915-.531.146-.1,1.473-.833.156-.1,1.83-1.062,31.975-18.458C263.754,11.005,267.588,13.183,267.588,18.61Z"
            transform="translate(1.683 -1.065)"
            fill="#fff"
            opacity="0.78"
          />
          <path
            id="Path_1791"
            data-name="Path 1791"
            d="M267.592,37.09V70.575L226.128,216.841l-26.155,15.219c-1.83,1.062-3.423,0-4.814-.384-1.409-.915-2.27-2.745-2.27-5.344V167.094Z"
            transform="translate(1.679 -3.146)"
            fill="#f8feff"
            opacity="0.6"
          />
          <path
            id="Path_1792"
            data-name="Path 1792"
            d="M145.434,34.132a8.474,8.474,0,0,0-3.834,6.68l1.977,2.535L145.352,43c.979-1.7,4.713-3.185,3.844-6.653l36.166-19.785L196.288,9.13h0l.915-1.3c-.659-.375-1.29-.787-1.931-1.153a2.819,2.819,0,0,0-2.745.265h0Z"
            transform="translate(6.032 -0.544)"
            fill="#ce1d6e"
            fillRule="evenodd"
          />
          <path
            id="Path_1793"
            data-name="Path 1793"
            d="M141.692,84.87a2.681,2.681,0,0,0,1.126,2.471l2,1.2a4.164,4.164,0,0,0,.448-1.583l.174.1,1.1-25.166-1.19-15.731L141.6,44Z"
            transform="translate(6.032 -3.732)"
            fill="#ce1d6e"
            fillRule="evenodd"
          />
          <path
            id="Path_1794"
            data-name="Path 1794"
            d="M198.617,10.467c0-2.443-1.73-3.432-3.862-2.205l-47.111,27.17a8.447,8.447,0,0,0-3.834,6.644l.092,40.907c0,2.443,1.739,3.432,3.862,2.2l34.3-19.794,13.269,4.695L191.379,59.8l3.478-1.83a8.456,8.456,0,0,0,3.844-6.644Z"
            transform="translate(5.844 -0.654)"
            fillRule="evenodd"
            fill="url(#linear-gradient-29)"
          />
          <path
            id="Path_1795"
            data-name="Path 1795"
            d="M187.244,32.611,157.63,49.477V47.015L187.244,30.14Z"
            transform="translate(4.671 -2.556)"
            fill="#fcfcfc"
          />
          <path
            id="Path_1796"
            data-name="Path 1796"
            d="M187.244,44.662,157.63,61.537V59.075L187.244,42.2Z"
            transform="translate(4.671 -3.579)"
            fill="#fcfcfc"
          />
          <path
            id="Path_1797"
            data-name="Path 1797"
            d="M158.118,81.714a13.328,13.328,0,0,1-7.074,11.256c-4.219,1.94-7.824-.366-7.824-5.271s3.661-10.158,7.852-11.6C155.071,74.723,158.128,77.276,158.118,81.714Z"
            transform="translate(5.894 -6.424)"
            fill="#113ece"
          />
          <path
            id="Path_1798"
            data-name="Path 1798"
            d="M158.719,82.194a13.309,13.309,0,0,1-7.074,11.256c-4.21,1.94-7.815-.366-7.815-5.271s3.615-10.158,7.852-11.6C155.681,75.2,158.738,77.756,158.719,82.194Z"
            transform="translate(5.842 -6.465)"
            fill="url(#linear-gradient-30)"
          />
          <path
            id="Path_1799"
            data-name="Path 1799"
            d="M151.963,82.529h0l-1.29,1.226-.183-.769,1.583-1.556.824-.311v8.09l-.915.4Z"
            transform="translate(5.277 -6.882)"
            fill="#fff"
          />
          <path
            id="Path_1800"
            data-name="Path 1800"
            d="M418.975,144.526A7.129,7.129,0,0,1,422.2,150.1l-1.666,2.123-1.492-.293c-.814-1.418-3.944-2.663-3.212-5.573L385.49,129.783l-9.151-6.223h0l-.769-1.089c.558-.32,1.089-.659,1.629-.97a2.352,2.352,0,0,1,2.3.22h0Z"
            transform="translate(-13.824 -10.292)"
            fill="#113ece"
            fillRule="evenodd"
          />
          <path
            id="Path_1801"
            data-name="Path 1801"
            d="M426.006,187.069a2.233,2.233,0,0,1-.915,2.068l-1.684,1.007a3.468,3.468,0,0,1-.375-1.327l-.146.082-.915-21.1.943-13.2,3.157-1.83Z"
            transform="translate(-17.762 -12.963)"
            fill="#113ece"
            fillRule="evenodd"
          />
          <path
            id="Path_1802"
            data-name="Path 1802"
            d="M374.382,124.678c0-2.05,1.455-2.874,3.24-1.83l39.488,22.8a7.1,7.1,0,0,1,3.221,5.573l-.082,34.3c0,2.05-1.455,2.874-3.24,1.83l-28.754-16.6-11.128,3.935,3.313-8.621-2.919-1.519a7.1,7.1,0,0,1-3.221-5.573Z"
            transform="translate(-13.717 -10.385)"
            fill="#2e4ce6"
            fillRule="evenodd"
          />
          <path
            id="Path_1803"
            data-name="Path 1803"
            d="M385.89,143.248,410.718,157.4v-2.068L385.89,141.18Z"
            transform="translate(-14.7 -11.979)"
            fill="#fff"
          />
          <path
            id="Path_1804"
            data-name="Path 1804"
            d="M385.89,154.068l24.828,14.148v-2.068L385.89,152Z"
            transform="translate(-14.7 -12.898)"
            fill="#fff"
          />
          <path
            id="Path_1805"
            data-name="Path 1805"
            d="M424.144,190.966c-.055,3.825-2.745,5.363-6.031,3.5a12.986,12.986,0,0,1-5.893-10.176c0-3.862,2.6-5.573,5.921-3.752A12.876,12.876,0,0,1,424.144,190.966Z"
            transform="translate(-16.935 -15.258)"
            fill="#ce1d6e"
          />
          <path
            id="Path_1806"
            data-name="Path 1806"
            d="M423.383,191.466c-.055,3.825-2.745,5.363-6.031,3.5a13,13,0,0,1-5.9-10.176c0-3.862,2.608-5.573,5.93-3.752a12.876,12.876,0,0,1,6,10.423Z"
            transform="translate(-16.869 -15.3)"
            fill="url(#linear-gradient-31)"
          />
          <path
            id="Path_1807"
            data-name="Path 1807"
            d="M414.91,187.47l1.748,3.441,4.31-3.157"
            transform="translate(-17.163 -15.908)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="1.14"
          />
          <path
            id="Path_1808"
            data-name="Path 1808"
            d="M287.39,275.67a3.249,3.249,0,0,0,1.766,2.315l.174.421-.146.311h-.073a4.136,4.136,0,0,1-1.034-.805,2.507,2.507,0,0,1-.485-.723h0a1.262,1.262,0,0,1-.055-.146,2.35,2.35,0,0,1-.1-.659Z"
            transform="translate(-6.341 -23.393)"
            fill="#665c59"
            fillRule="evenodd"
          />
          <path
            id="Path_1809"
            data-name="Path 1809"
            d="M290.495,273.74v.741a2.489,2.489,0,0,0-.988,1.025,1.481,1.481,0,0,0-.146.677v-.741A2,2,0,0,1,290.495,273.74Z"
            transform="translate(-6.508 -23.229)"
            fill="#d6d4d2"
            fillRule="evenodd"
          />
          <path
            id="Path_1810"
            data-name="Path 1810"
            d="M315.411,263.456a5.94,5.94,0,0,0-2.745.769l-.265-.183.238-.549a5.885,5.885,0,0,1,2.745-.824,5.949,5.949,0,0,1,2.965.641v.732a3.732,3.732,0,0,0-.384-.183A6.3,6.3,0,0,0,315.411,263.456Z"
            transform="translate(-8.463 -22.289)"
            fill="#a8a5a3"
            fillRule="evenodd"
          />
          <path
            id="Path_1811"
            data-name="Path 1811"
            d="M290.6,272.877l.018.741,20.206-9.316-.018-.732Z"
            transform="translate(-6.613 -22.366)"
            fill="#b5b3b1"
            fillRule="evenodd"
          />
          <path
            id="Path_1812"
            data-name="Path 1812"
            d="M289.028,272.033l20.206-9.307a9.078,9.078,0,0,1,8.236-.265l11.979,3.935-1.208.741-12.025-3.9a6.278,6.278,0,0,0-5.692.183l-20.2,9.289c-1.547.97-1.51,2.443.082,3.3l12.574,7.916-1.245.778L289.156,276.8C286.85,275.547,286.8,273.405,289.028,272.033Z"
            transform="translate(-6.341 -22.199)"
            fill="#a8a5a3"
            fillRule="evenodd"
          />
          <path
            id="Path_1813"
            data-name="Path 1813"
            d="M301.931,285.64l.018.732-12.6-7.44-.027-.732Z"
            transform="translate(-6.505 -23.608)"
            fill="#534b48"
            fillRule="evenodd"
          />
          <path
            id="Path_1814"
            data-name="Path 1814"
            d="M315.69,263.456v-.787a5.949,5.949,0,0,1,2.965.641l.165.458-.137.275a3.737,3.737,0,0,0-.384-.183A6.3,6.3,0,0,0,315.69,263.456Z"
            transform="translate(-8.743 -22.289)"
            fill="#665c59"
            fillRule="evenodd"
          />
          <path
            id="Path_1815"
            data-name="Path 1815"
            d="M330.915,267.268l.027.732-12.025-3.9-.027-.732Z"
            transform="translate(-9.014 -22.349)"
            fill="#534b48"
            fillRule="evenodd"
          />
          <path
            id="Path_1816"
            data-name="Path 1816"
            d="M320.255,262.7l20.243,8.245-.366.275-.879.448-19.666-7.8-.577-.448Z"
            transform="translate(-9.024 -22.292)"
            fill="#c9c7c5"
            fillRule="evenodd"
          />
          <path
            id="Path_1817"
            data-name="Path 1817"
            d="M341.13,272.433l1.245-.723a2.929,2.929,0,0,0,2.745,0C343.509,272.945,342.686,273.275,341.13,272.433Z"
            transform="translate(-10.902 -23.057)"
            fill="#bfbdbb"
            fillRule="evenodd"
          />
          <path
            id="Path_1818"
            data-name="Path 1818"
            d="M345.614,270.42l1.336-.86a2.883,2.883,0,0,1-1.08,2.745l-1.4.915A2.947,2.947,0,0,0,345.614,270.42Z"
            transform="translate(-11.185 -22.874)"
            fill="#c9c7c5"
            fillRule="evenodd"
          />
          <path
            id="Path_1819"
            data-name="Path 1819"
            d="M336.74,217.684a1.018,1.018,0,0,1-.082-.128h0a37.685,37.685,0,0,0-7.1-9.444l-.174-.165a34.528,34.528,0,0,0-6.992-5.079,30.869,30.869,0,0,0-6.516-2.809l-.055-.119,1.089-.65h.119a32.751,32.751,0,0,1,6.287,2.572,35.873,35.873,0,0,1,15.017,15.7l.3.6a55.474,55.474,0,0,1,4.8,16.3,40.126,40.126,0,0,1,.311,4.576l.778,24.571-1.336.86-1.062-25.99a49.18,49.18,0,0,0-5.39-20.8Z"
            transform="translate(-8.754 -16.911)"
            fill="#d6d4d2"
            fillRule="evenodd"
          />
          <path
            id="Path_1820"
            data-name="Path 1820"
            d="M332.271,210.552a33.641,33.641,0,0,0-9.874-8.017A29.55,29.55,0,0,0,315.89,200v1.034a32.661,32.661,0,0,1,15.878,10.341,43.251,43.251,0,0,1,8.849,18.678,51.246,51.246,0,0,1,1.272,10.616l.7,23.5c.073,2.279-1.519,3.258-3.551,2.178L318.8,258.111v.732l20.243,8.236c2.379,1.272,4.255.119,4.173-2.562q-.32-11.9-.631-23.739a53.08,53.08,0,0,0-1.318-10.89c-1.73-7.7-4.667-14.267-8.968-19.337Z"
            transform="translate(-8.76 -16.971)"
            fill="#534b48"
            fillRule="evenodd"
          />
          <path
            id="Path_1821"
            data-name="Path 1821"
            d="M322.219,202.8c-.3-.165-.8-.256-1.089-.394l.073,1.281.851.439c5.655,3.029,12.885,9.151,16.9,21.158l1.016.064A34.436,34.436,0,0,0,322.219,202.8Z"
            transform="translate(-9.204 -17.176)"
            fill="#079da8"
            fillRule="evenodd"
          />
          <path
            id="Path_1822"
            data-name="Path 1822"
            d="M328.7,207.4a36.524,36.524,0,0,1,5.948,6.836,44.915,44.915,0,0,1,5.326,10.982l2.16-1.345a43.644,43.644,0,0,0-6.479-12.629,36.857,36.857,0,0,0-4.75-5.171,34.611,34.611,0,0,0-7.5-5.106h-.073l-2.151,1.354A34.053,34.053,0,0,1,328.7,207.4Z"
            transform="translate(-9.209 -17.053)"
            fill="#8662de"
            fillRule="evenodd"
          />
          <path
            id="Path_1823"
            data-name="Path 1823"
            d="M317.19,216.486a9.829,9.829,0,0,0,.915-.622c.558-.439.915-.824.915-1.034h0a.8.8,0,0,0,.128.5.476.476,0,0,1-.064.11,6.955,6.955,0,0,1-1.784,1.272.43.43,0,0,1-.11-.229Z"
            transform="translate(-8.87 -18.23)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1824"
            data-name="Path 1824"
            d="M317.24,216.762a19.805,19.805,0,0,0,1.684-1.181c.082-.082.165-.156.165-.2a6.14,6.14,0,0,0,2.645,2.425c-.238-.128-.86.119-1.062.2a11.157,11.157,0,0,0-1.226.65,7.6,7.6,0,0,1-1.345-.915,3.047,3.047,0,0,1-.86-.979Z"
            transform="translate(-8.874 -18.276)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1825"
            data-name="Path 1825"
            d="M291.69,231.252l23.336-14.642a.678.678,0,0,0,.046.229l-23.336,14.642A.43.43,0,0,1,291.69,231.252Z"
            transform="translate(-6.706 -18.381)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1826"
            data-name="Path 1826"
            d="M291.74,231.495l15.676-9.929,7.66-4.685a3.138,3.138,0,0,0,.915,1,6.726,6.726,0,0,0,1.309.915l-7.12,4.841-16.225,9.829a8.111,8.111,0,0,1-1.345-.915A2.48,2.48,0,0,1,291.74,231.495Z"
            transform="translate(-6.71 -18.404)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1827"
            data-name="Path 1827"
            d="M288.429,233.736a2.69,2.69,0,0,0,1.18-.21l.659-.284a12.576,12.576,0,0,0,1.144-.631.631.631,0,0,1,.046.22c-.247.165-.5.311-.76.467s-.641.384-1.089.622a7.013,7.013,0,0,1-1.034.439A.915.915,0,0,1,288.429,233.736Z"
            transform="translate(-6.428 -19.739)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1828"
            data-name="Path 1828"
            d="M289.41,233.907c.229-.119.512-.21.741-.339.439-.247.915-.4,1.3-.668a5.491,5.491,0,0,0,2.215,1.931c-.494.375-2.3,1.83-2.361,2.389a6.955,6.955,0,0,1-2.974-2.745A7.714,7.714,0,0,0,289.41,233.907Z"
            transform="translate(-6.421 -19.763)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1829"
            data-name="Path 1829"
            d="M321.909,218h0l.824.4.805.393c4.127,2.032,8.236,4.017,12.336,6.177.86.448,1.72.915,2.581,1.382,3.4,1.83,6.626,3.661,9.151,5.335a2.745,2.745,0,0,1,1.126,1.016,2.919,2.919,0,0,1,.238.75,1.666,1.666,0,0,1-.366,1.135,6.077,6.077,0,0,1-1.373,1.281l-.2.137-.2.128c.915-.558.1-2.306-.631-2.974a2.5,2.5,0,0,0-.4-.311c-4.347-2.681-8.017-4.786-11.622-6.708-4.576-2.443-9-4.576-14.542-7.321C320.161,218.557,321.5,217.861,321.909,218Z"
            transform="translate(-9.077 -18.497)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1830"
            data-name="Path 1830"
            d="M350.548,233.33a1.994,1.994,0,0,1,.677.723,2.918,2.918,0,0,1,.238.75,1.666,1.666,0,0,1-.366,1.135,6.078,6.078,0,0,1-1.373,1.281l-.2.137-.2.128c.915-.558.1-2.306-.631-2.974h0Z"
            transform="translate(-11.543 -19.8)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1831"
            data-name="Path 1831"
            d="M308.417,162.423l.274-.156a7.656,7.656,0,0,1,.723-.375,5.618,5.618,0,0,1,.915-.329,3.248,3.248,0,0,1,.659-.082,1.556,1.556,0,0,1,.7.165,4.731,4.731,0,0,0-2.27.915,1.345,1.345,0,0,0-.76-.156.713.713,0,0,0-.229.064C308.371,162.45,308.381,162.45,308.417,162.423Z"
            transform="translate(-8.123 -13.702)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1832"
            data-name="Path 1832"
            d="M309.51,162.523c.329-.21,1.83-1.1,2.27-.915a2.874,2.874,0,0,1,1.052,1.574l-1.958,1.162A3.3,3.3,0,0,0,309.51,162.523Z"
            transform="translate(-8.218 -13.711)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1833"
            data-name="Path 1833"
            d="M346.506,234.6c.769.577,1.611,2.389.65,2.993L323.82,252.235c.75-.5-.119-2.517-.65-2.993l8.364-6.525Z"
            transform="translate(-9.377 -19.907)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1834"
            data-name="Path 1834"
            d="M317.5,219c5.546,2.7,9.984,4.841,14.542,7.321,3.606,1.922,7.275,4.027,11.622,6.708a2.371,2.371,0,0,1,.384.293l-23.336,14.642a2.746,2.746,0,0,0-.375-.293c-4.356-2.681-8.026-4.786-11.631-6.708-4.576-2.443-9-4.576-14.542-7.275Z"
            transform="translate(-6.915 -18.584)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1835"
            data-name="Path 1835"
            d="M316.414,250.29c-2.846-1.72-5.427-3.221-7.907-4.576-3.368-1.83-7.888-4.146-13.928-7.111l-2.919-1.418a1.171,1.171,0,0,1,.274-.567,10.343,10.343,0,0,1,.915-.86c.32-.247.86-.613.915-.677a1.7,1.7,0,0,1,.174-.1c5.546,2.69,9.984,4.832,14.541,7.275,3.606,1.922,7.275,4.027,11.631,6.708a2.682,2.682,0,0,1,.394.311,3.148,3.148,0,0,1,1.007,2.178.915.915,0,0,1-.375.8l-.375.22a6.525,6.525,0,0,1-1.565.659,2.959,2.959,0,0,1-.75.091h-.128a1.949,1.949,0,0,1-.467-.128l-.1-.055c-.064,0-.064-.091-.073-.128h0a1.392,1.392,0,0,0,.329.11h0a.455.455,0,0,0,.5-.494,1.529,1.529,0,0,0-.165-.668A9.224,9.224,0,0,0,316.414,250.29Z"
            transform="translate(-6.703 -19.94)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1836"
            data-name="Path 1836"
            d="M322.914,250.58h0a3.148,3.148,0,0,1,1.007,2.178.915.915,0,0,1-.375.8l-.375.22a6.526,6.526,0,0,1-1.565.659,2.954,2.954,0,0,1-.75.091h-.128a1.953,1.953,0,0,1-.467-.128l-.1-.055c-.064,0-.064-.092-.073-.128h0a1.392,1.392,0,0,0,.329.11h0a.455.455,0,0,0,.5-.494,1.529,1.529,0,0,0-.165-.668,4.364,4.364,0,0,0-.815-.723Z"
            transform="translate(-9.103 -21.264)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1837"
            data-name="Path 1837"
            d="M282.89,177.134l23.308-14.6a.8.8,0,0,1,.641-.1h0a1.511,1.511,0,0,1,.384.146l-23.336,14.642A1.052,1.052,0,0,0,282.89,177.134Z"
            transform="translate(-5.959 -13.781)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1838"
            data-name="Path 1838"
            d="M292.642,228.22a9.568,9.568,0,0,0,.558-1.025,13.727,13.727,0,0,0,.915-2.581,11.378,11.378,0,0,0,.284-1.949,17.762,17.762,0,0,0,0-2.315,53.5,53.5,0,0,0-.622-6.305c-.055-.439-.128-.915-.2-1.327L316.893,197.6c.741,4.576,1.913,10.616-.165,15-.329.686-1.739,1.885-1.72,2.425l-7.678,4.905-15.64,9.682C291.644,229.154,292.367,228.623,292.642,228.22Z"
            transform="translate(-6.706 -16.767)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1839"
            data-name="Path 1839"
            d="M314.123,184.15c.577,2.343,2.288,4.521,2.745,6.873.421,1.958-.357,4.091-.055,5.948l-23.336,14.642c-.3-1.83-1.83-3.468-2.288-5.418-.5-2.352.146-5.061-.439-7.394Z"
            transform="translate(-6.626 -15.626)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1840"
            data-name="Path 1840"
            d="M308.838,164.56l.046.156c.641,2.562,2.242,4.969,2.947,7.522.915,3.359.979,6.863,1.83,10.249L290.324,197.13c-.32-1.309-1.666-2.187-2.013-3.487-1.235-4.631-1.592-9.655-2.745-14.294a1,1,0,0,0-.046-.156l18.1-12.29Z"
            transform="translate(-6.182 -13.963)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1841"
            data-name="Path 1841"
            d="M307.346,162.61a3.212,3.212,0,0,1,1.391,1.785l-2.114,1.318L285.4,178.991a3.194,3.194,0,0,0-1.391-1.83Z"
            transform="translate(-6.054 -13.798)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1842"
            data-name="Path 1842"
            d="M288.673,206.655c-.485-2.306-1.034-4.649-1.6-6.937-1.208-4.319-2.59-8.593-3.615-12.967-.183-.8-1.226-5.573-1.977-5.985,0-.22.311-.586.458-.741a10.294,10.294,0,0,1,1.428-1.181,2.578,2.578,0,0,1,.43-.275,3.111,3.111,0,0,1,1.437,1.94c.2.805.485,1.83.814,3.038.577,2.114,1.318,4.74,2.1,7.641.421,1.547.851,3.176,1.281,4.85q1.2,4.64,2.205,9.325a79.907,79.907,0,0,1,1.968,13.361,14.12,14.12,0,0,1-1.336,7.2c-.54.97-1.464,1.537-1.446,2.1-.229.146-.458.275-.686.394a8.741,8.741,0,0,1-.915.448c-.284.119-1.126.439-1.409.284a1.374,1.374,0,0,1,.046-.6c.146-.348.8-.805,1.025-1.144a9.977,9.977,0,0,0,.631-1.4,14.4,14.4,0,0,0,1.071-6.159c-.064-1.83-.311-4.017-.6-6.2S289.167,209.026,288.673,206.655Z"
            transform="translate(-5.839 -15.152)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1843"
            data-name="Path 1843"
            d="M280.527,180.936a1.83,1.83,0,0,1,.43-.97.189.189,0,0,1,0-.055,6.122,6.122,0,0,1,1.409-1.245,2.447,2.447,0,0,1,.448-.256h.128a1.418,1.418,0,0,1,.732.174l-.586.393c-.229.165-.458.329-.668.512a4.429,4.429,0,0,0-.979,1.043.522.522,0,0,0-.082.247.267.267,0,0,0-.091,0c-.586,0-.787.256-.613.915s.412,1.6.677,2.572c.851,3.1,1.73,6.2,2.553,9.3.778,2.9,1.583,6.031,2.315,9.151a.41.41,0,0,0,.064.265c.055.284.128.567.183.842q.659,2.883,1.171,5.582c.146.787.284,1.583.412,2.379.183,1.126.348,2.224.467,3.267.65,5.418,1.107,6.543-.622,10.012-.75,1.5-1.83,1.986-1.565,4.027.458,3.1,3.148,2.974,4.438,5.161,0,0,0,.119.055.137a11.451,11.451,0,0,1-2.919-2.187,5.829,5.829,0,0,1-.421-.522,7.876,7.876,0,0,1-.915-1.382,6.076,6.076,0,0,1-.512-1.537,4.439,4.439,0,0,1-.064-.979,3.268,3.268,0,0,1,.595-1.684c.522-.915.915-1.574,1.235-2.205.988-2,1.043-3.23.833-6.314-.055-.851-.137-1.693-.238-2.553s-.21-1.647-.348-2.5c-.165-1.052-.339-2.1-.54-3.148-.247-1.3-.512-2.6-.787-3.908-1.025-4.731-2.324-9.737-3.661-14.541-.613-2.215-1.226-4.42-1.83-6.635-.21-.75-.412-1.492-.6-2.233-.046-.165-.073-.284-.1-.375a1.966,1.966,0,0,1,0-.75Z"
            transform="translate(-5.755 -15.139)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1844"
            data-name="Path 1844"
            d="M281.516,180.908c3.542.677,8.108,22.531,8.822,25.917.485,2.37.714,5.143,1.043,7.376s-.366,3.77-.311,5.646c0,.75-.558,1.739-.595,2.443a11.314,11.314,0,0,1-.284,1.83,12.215,12.215,0,0,1-.869,2.489c-.183.329-.348.7-.531.979s-.778.805-.915,1.208a1.144,1.144,0,0,0-.091.54,1.326,1.326,0,0,0,.146.622,6.406,6.406,0,0,0,2.809,2.608c5.546,2.7,9.975,4.832,14.523,7.266,3.587,1.913,7.257,4.036,11.576,6.68a1.739,1.739,0,0,1,.778,1.382c0,.458-.357.641-.851.384a.21.21,0,0,0,.064.128h0c-4.338-2.681-8.035-4.8-11.686-6.735-2.6-1.354-5.756-2.965-9.609-4.869l-.256-.119h0l-2.416-1.162-1.995-.97a.165.165,0,0,1-.092-.137h0a9.669,9.669,0,0,1-4.155-4.082,5.494,5.494,0,0,1-.348-.915,4.113,4.113,0,0,1-.137-.915c0-1.235.393-1.437,1.062-2.306a4.017,4.017,0,0,0,.54-.915,11.69,11.69,0,0,0,.741-1.922,7.589,7.589,0,0,0,.366-2.059,19.5,19.5,0,0,0,0-2.087,65.082,65.082,0,0,0-1.171-9.426c-.97-5.225-2.407-10.982-3.761-16.033-.668-2.526-1.327-4.887-1.894-6.928s-1.043-3.77-1.373-5.07c-.119-.476.055-.723.32-.8A.915.915,0,0,1,281.516,180.908Z"
            transform="translate(-5.765 -15.349)"
            fill="#4332a5"
            fillRule="evenodd"
          />
          <path
            id="Path_1845"
            data-name="Path 1845"
            d="M309.51,162.523c.329-.21,1.83-1.1,2.27-.915,1.1.567,1.51,3.349,1.83,4.475l.824,3c1.583,5.729,3.111,11.366,4.4,17.177l.156.723c.4,1.83.778,3.734,1.1,5.619.183,1.016.366,2.2.494,3.221s.275,2.242.357,3.377a26.547,26.547,0,0,1,.119,2.819,12.867,12.867,0,0,1-1.126,5.546,9.841,9.841,0,0,1-.961,1.748,6.843,6.843,0,0,1-.485.586.6.6,0,0,0-.174.366c0,.311-.7.988-1.766,1.656a.8.8,0,0,1,.055-.284c.311-.814,1.254-1.757,1.83-3.13a14.762,14.762,0,0,0,.915-5.875,54.962,54.962,0,0,0-.677-6.324c-.668-4.576-1.73-9.49-2.846-14.02-.613-2.5-1.254-4.933-1.83-7.193-.787-2.91-1.528-5.537-2.1-7.641-.046-.174-.092-.339-.146-.5-.256-.915-.485-1.739-.686-2.535A3.349,3.349,0,0,0,309.51,162.523Z"
            transform="translate(-8.218 -13.711)"
            fill="#5b3db2"
            fillRule="evenodd"
          />
          <path
            id="Path_1846"
            data-name="Path 1846"
            d="M324.74,289a13.08,13.08,0,0,0-1.071,4.136c.055,1.08.366,2.215.348,3.661a35.528,35.528,0,0,1-.21,3.661c-.137,1.409,0,2.077.613,2.636a21.525,21.525,0,0,0,5.418,2.809,5.673,5.673,0,0,0,2.48.339,11.172,11.172,0,0,0,3.331-.6c.3-.119.613-1.309.641-2.334.046-2.16-.146-1.977-1.043-5.39-.3-1.171-.549-2.288-.97-3.661a19.217,19.217,0,0,1-1.235-4.859l-6.314-.247Z"
            transform="translate(-9.419 -24.524)"
            fill="#111214"
            fillRule="evenodd"
          />
          <path
            id="Path_1847"
            data-name="Path 1847"
            d="M324.74,289a13.08,13.08,0,0,0-1.071,4.136c.055,1.08.366,2.215.348,3.661a35.528,35.528,0,0,1-.21,3.661c-.137,1.409,0,2.077.613,2.636a21.525,21.525,0,0,0,5.418,2.809,5.673,5.673,0,0,0,2.48.339,11.172,11.172,0,0,0,3.331-.6c.275-.11.558-1.089.622-2.041h0a7.068,7.068,0,0,1-5.656,0c-3.908-1.913-3.4-3.5-3.038-8.017,2.553-.448,3.551-.915,4.841-2.3-2.169.641-4.5.75-5.656-.577l-.357-3.587Z"
            transform="translate(-9.419 -24.524)"
            fillRule="evenodd"
          />
          <path
            id="Path_1848"
            data-name="Path 1848"
            d="M333.9,294c-1.83,1.446-1.181,2.077-3.853,2.425a14.98,14.98,0,0,0,2.077,5.2c.11,1.007.192,2.324,2.151,2.334,3.661,0,1.116-2.992,1.107-3.1A29.761,29.761,0,0,0,333.9,294Z"
            transform="translate(-9.961 -24.948)"
            fill="#20232e"
            fillRule="evenodd"
          />
          <path
            id="Path_1849"
            data-name="Path 1849"
            d="M356.165,275.23c.714,2.224.915,3.386,1.894,4.658,1.949,2.553,4.759,4.329,8.849,7.037,1.949,1.281,2.4,2.553.5,3.789-1.482.979-5.225.366-7.559-.11-4.393-.915-6.232-3.441-7.742-4.072l-1.126.293c-.915.046-4.384-1.693-5.116-2.617a18.173,18.173,0,0,1-.915-2.956c-.256-3.661.339-3.322,1.226-6.241C349.567,275.147,352.806,275.22,356.165,275.23Z"
            transform="translate(-11.221 -23.337)"
            fill="#111214"
            fillRule="evenodd"
          />
          <path
            id="Path_1850"
            data-name="Path 1850"
            d="M368.621,288.984a2.134,2.134,0,0,1-1.208,1.73c-1.483.979-5.225.366-7.559-.11-4.393-.915-6.232-3.441-7.742-4.072l-1.126.293c-.915.046-4.384-1.656-5.344-2.48a22.158,22.158,0,0,1-.668-3.093c-.256-3.661.339-3.322,1.226-6.241,1.483.064,2.947.11,4.411.146.348,2.416.128,6.607,2.178,8.1,2.288,1.666,4.045,2.077,5.564,2.938C363.2,288.92,366.416,291.162,368.621,288.984Z"
            transform="translate(-11.223 -23.337)"
            fillRule="evenodd"
          />
          <path
            id="Path_1851"
            data-name="Path 1851"
            d="M358.241,279.73c-.448.714-1.373,1.144-2.9,1.574,2.581,2.745,2.919,2.453,6.333,4.219,1.748,1.876,1.995,2.233,3.084,2.819,1.309.7,3.148,1.4,3.889.824.32-.247-.137-.915-1.583-1.83-1.647-1.107-3.322-2.233-4.832-3.413A17.443,17.443,0,0,1,358.241,279.73Z"
            transform="translate(-12.107 -23.737)"
            fill="#20232e"
            fillRule="evenodd"
          />
          <path
            id="Path_1852"
            data-name="Path 1852"
            d="M344.884,242.978c-8.968-7.724-22.11-7.4-28.79-11.21-4.868-2.745-7.4-3.057-4.631-9.353l15.676-6.525c.046,1.5,1.043,3.468,1.519,3.661a105.242,105.242,0,0,1,22.686,10.982c1.2.622,3.093,2.27,3.166,3.734C354.6,236.261,349.671,241.98,344.884,242.978Z"
            transform="translate(-8.287 -18.32)"
            fill="#00263d"
            fillRule="evenodd"
          />
          <path
            id="Path_1853"
            data-name="Path 1853"
            d="M344.884,243.358c-8.968-7.724-22.11-7.4-28.79-11.21-4.868-2.745-7.4-3.057-4.631-9.353l5.811-2.425h0c.915,1.656,3.258,3.4,4.621,4.493a22.366,22.366,0,0,0,3.761,2.434c3.285,1.72,11.842,5.7,17.717,7.943,2.361.915,2.874,1.876,3.047,3.047a15.41,15.41,0,0,1-.055,4.576A8.237,8.237,0,0,1,344.884,243.358Z"
            transform="translate(-8.287 -18.7)"
            fill="#001e30"
            fillRule="evenodd"
          />
          <path
            id="Path_1854"
            data-name="Path 1854"
            d="M357.445,240.81c-.082,11.073-.238,22.055-.54,33.155-1.492,2.636-9.087,3.038-11.8-.5-.723-10.066-1.611-17.937-1.51-23.437.091-4.576,1.19-7.321,1.565-11.329,1.574-4.576,8.529-6.58,11.229-4.768C358.077,235.063,357.464,238.87,357.445,240.81Z"
            transform="translate(-11.11 -19.794)"
            fill="#00263d"
            fillRule="evenodd"
          />
          <path
            id="Path_1855"
            data-name="Path 1855"
            d="M349.731,276.184a7.212,7.212,0,0,1-4.621-2.425c-.723-10.066-1.611-17.937-1.51-23.437.091-4.576,1.19-7.321,1.565-11.329a6.672,6.672,0,0,1,1.327-2.233c2.123.915,2.6,1.83,2.745,2.938.6,3.944-.805,7.22-1.034,11.119C347.818,257.781,349.09,267.92,349.731,276.184Z"
            transform="translate(-11.11 -20.091)"
            fill="#001e30"
            fillRule="evenodd"
          />
          <path
            id="Path_1856"
            data-name="Path 1856"
            d="M329.874,251.647c-5.033-4.338-12.263-6.818-18.211-8.492-4.631-1.3-8.236-2.077-10.863-3.359-7.019-3.478-5.765-8.529-2.864-12.345,1.556-2.059,3.2-3.2,5.161-5.079l13.553-.842c.137,1.775,6.15,4.576,6.141,6.534a2.087,2.087,0,0,1-.714,1.254c-1.007.76.805,1.73,1.62,2.205,3.514,2.05,9.151,5.491,12.638,7.66,1.181.778,3.111,2.343,3.194,3.661C339.656,244.838,334.66,250.65,329.874,251.647Z"
            transform="translate(-7.04 -18.798)"
            fill="#00263d"
            fillRule="evenodd"
          />
          <path
            id="Path_1857"
            data-name="Path 1857"
            d="M329.874,251.725c-5.033-4.338-12.263-6.818-18.211-8.492-4.631-1.3-8.236-2.077-10.863-3.359-7.019-3.478-5.765-8.529-2.864-12.345,1.556-2.059,3.2-3.2,5.161-5.079l1.537.458-2.114,5.729c6.406,4.017,16.811,9.591,24.709,14.441,2.315,1.418,3.661,2.087,4.063,3.715a14.643,14.643,0,0,1-.137,4.576,9.38,9.38,0,0,1-1.281.357Z"
            transform="translate(-7.04 -18.876)"
            fill="#001e30"
            fillRule="evenodd"
          />
          <path
            id="Path_1858"
            data-name="Path 1858"
            d="M335.884,247.329c-.485,12.7-1.062,26.722-1.83,39.415-1.574,2.59-9.151,2.745-11.778-.915-.384-10.066-1.016-18.98-.732-24.48.238-4.576,2-7.66,1.931-11.723C325.616,244.043,335.984,242.662,335.884,247.329Z"
            transform="translate(-9.233 -20.749)"
            fill="#00263d"
            fillRule="evenodd"
          />
          <path
            id="Path_1859"
            data-name="Path 1859"
            d="M326.821,288.7a7.193,7.193,0,0,1-4.576-2.581c-.384-10.066-1.016-18.98-.732-24.48.238-4.576,2-7.66,1.931-11.723a6.717,6.717,0,0,1,1.5-2.288c1.345.915,2.16,1.611,2.4,2.837.4,2.041-.6,4.841-.988,10.927C325.869,269.831,326.968,280.117,326.821,288.7Z"
            transform="translate(-9.231 -21.013)"
            fill="#001e30"
            fillRule="evenodd"
          />
          <path
            id="Path_1860"
            data-name="Path 1860"
            d="M327.967,219.12a36.78,36.78,0,0,1-5.317,3.34,16.344,16.344,0,0,0,4.475,3.221c6.918,3.487,14.047,7.22,20.9,9.261a5.07,5.07,0,0,0,4.319-.86c.805-.641,1.428-1.565,0-2.526a78.205,78.205,0,0,0-12.336-7.129c-2.581-1.19-6.8-2.27-9.481-3.331A6,6,0,0,1,327.967,219.12Z"
            transform="translate(-9.333 -18.594)"
            fill="#002b45"
            fillRule="evenodd"
          />
          <path
            id="Path_1861"
            data-name="Path 1861"
            d="M357.365,236.66a7.321,7.321,0,0,1-4.869,2.2c.119,3.249-.8,7.01-1.144,11.457-.567,7.321.275,16.994.915,25.175a5.564,5.564,0,0,0,4.7-1.382C357.209,261.478,357.228,249.3,357.365,236.66Z"
            transform="translate(-11.753 -20.082)"
            fill="#002b45"
            fillRule="evenodd"
          />
          <path
            id="Path_1862"
            data-name="Path 1862"
            d="M324.2,211.359c0,.22.211.7.073.915-2.745,4.118-20.966,10.515-24.764,10.323,2.05-25.038-20.947-47.248,1.958-57.406,1.4,3.661,6.15,4.082,9.023,4.155,1.153,0,6.141-.421,4.887-3.5-.119-.284.915,1.949,1,1.656,2.947,3.661,4.521,8.41,5.335,14.642C322.986,191.857,322.72,201.2,324.2,211.359Z"
            transform="translate(-6.667 -14.017)"
            fill="#a7daf9"
            fillRule="evenodd"
          />
          <path
            id="Path_1863"
            data-name="Path 1863"
            d="M320.661,206.266a.562.562,0,0,1-.046.265c-2.26,2.745-2.453-21.606-5.765-30.062.183-1.034.357-1.894.6-2.892-1.739-1.364-1.83-1.354-2.224-3.322a4.228,4.228,0,0,1,1.72-1.171h0a4.987,4.987,0,0,1,1.739-.156c.439.265.668,1.666.1,3.844a5.581,5.581,0,0,1,1.83.659C320.084,181.749,322.015,196.757,320.661,206.266Z"
            transform="translate(-8.534 -14.333)"
            fill="#041e2e"
            fillRule="evenodd"
          />
          <path
            id="Path_1864"
            data-name="Path 1864"
            d="M320.661,206.282a.562.562,0,0,1-.046.265c-2.26,2.745-2.453-21.606-5.765-30.062.183-1.034.357-1.894.6-2.892-2.352-1.757-1.83-1.986-2.224-3.322a4.227,4.227,0,0,1,1.72-1.171H315l-1.226,1.226a3.386,3.386,0,0,0,2.343,2.938l-.577,3.4s1.592,2.27,4.008,25.239C319.544,201.953,320,206.7,320.661,206.282Z"
            transform="translate(-8.534 -14.349)"
            fill="#020d14"
            fillRule="evenodd"
          />
          <path
            id="Path_1865"
            data-name="Path 1865"
            d="M287.06,177.359c-.092-4,3.194-6.6,6.086-8.328,1.547-.915,4.695-3,8.09-5.052-2.8,3.587,4.521,11.76,8.136,22.137a56.741,56.741,0,0,1,2.471,13.855c.329,4.987-.476,28.836-1.473,32.945-3.9,3.185-6.406,2.745-9.993,1.336a34.9,34.9,0,0,1-8.593-5.042c1.025-11.457,5.116-12.052,5.2-19.163C297.071,203.486,287.27,186.373,287.06,177.359Z"
            transform="translate(-6.313 -13.914)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1866"
            data-name="Path 1866"
            d="M316.124,157.69a2.092,2.092,0,0,0-.064.329h0a6.565,6.565,0,0,0-.165.824,1.03,1.03,0,0,1,0,.165,13.216,13.216,0,0,0-.22,1.483,3.364,3.364,0,0,0-.055.394v.448c0,.348-.064.686-.092,1.043a2.22,2.22,0,0,1-.055.586c-.055.21,0,.192,0,.284v.494a14.916,14.916,0,0,1-.311,1.547,6.771,6.771,0,0,0-.183,1.116.659.659,0,0,1-.284.531c-.192.174-.448.3-.622.448a.421.421,0,0,0-.192.247h0a.073.073,0,0,0,0,.073.55.55,0,0,0,0,.174s0,0,0,.055a2.612,2.612,0,0,1-.393.448,2.267,2.267,0,0,1-.247.192l-.128.073a3.443,3.443,0,0,1-.613.293c-2.169.805-5.784-.064-8.108-1.592l-.293-.2a4.264,4.264,0,0,1-2.1-2.288h0a1.285,1.285,0,0,0-.055-.22,1.406,1.406,0,0,1,0-.339c.165-.393.311-.778.458-1.144a.129.129,0,0,1,.046-.1l.339-.86c.137-.339.256-.677.384-1.007a13.663,13.663,0,0,0,.393-8.675l2.206,1.089,9.957,3.935Z"
            transform="translate(-7.575 -12.941)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1867"
            data-name="Path 1867"
            d="M316.132,157.685a2.093,2.093,0,0,0-.064.329h0a6.56,6.56,0,0,0-.165.824,1.031,1.031,0,0,1,0,.165c-.073.4-.128.814-.183,1.235a4.705,4.705,0,0,1-.082.641v.137h0c-.046.485-.082.915-.137,1.336h0c-4.64,1.391-7.541,0-11.091,1.235a12.5,12.5,0,0,0-1.208.549c-.183.092-.366.2-.558.311l-.549.357a1.284,1.284,0,0,0-.055-.22,1.409,1.409,0,0,1,0-.339c.165-.394.311-.778.458-1.144a.129.129,0,0,1,.046-.1l.339-.86c.137-.339.256-.677.384-1.007a13.663,13.663,0,0,0,.394-8.675l2.205,1.089,9.865,3.981Z"
            transform="translate(-7.583 -12.937)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1868"
            data-name="Path 1868"
            d="M304.1,169.2c.073.265.741,2.453,4.118,3.331a21.046,21.046,0,0,0,3.944.769s.842-3.468,1.72-4.045,3.816.833,3.725,1.19.778-2.141.778-2.141L316.4,166.84s-2.745,2.581-4.31,2.489-7.989-2.489-7.989-2.489Z"
            transform="translate(-7.759 -14.157)"
            fill="#83c9e5"
            fillRule="evenodd"
          />
          <path
            id="Path_1869"
            data-name="Path 1869"
            d="M314.78,168.69a7.522,7.522,0,0,0,1.7-4.75c1.107.1,1.034,3.789,2.032,5.72a5.061,5.061,0,0,0-3.734-.97Z"
            transform="translate(-8.665 -13.911)"
            fill="#a7daf9"
            fillRule="evenodd"
          />
          <path
            id="Path_1870"
            data-name="Path 1870"
            d="M303.181,161.94c-.1,3.56,6.726,5.811,10.524,6.58-.915,1.171-2.086,2.645-1.995,3.78-2.745-.65-7.385-1.775-9.371-5.189a3.807,3.807,0,0,1,.842-5.171Z"
            transform="translate(-7.554 -13.741)"
            fill="#a7daf9"
            fillRule="evenodd"
          />
          <path
            id="Path_1871"
            data-name="Path 1871"
            d="M329.441,188l-2.434.165h-.091l-.558.046s-.668-17.653-2.443-20.856c-1.245-2.233-2.526-4.512-3.176-5.674a.431.431,0,0,0-.055-.082l-.394-.723h1a4.576,4.576,0,0,1,4.017,2.8,5.168,5.168,0,0,1,.32.778C327.346,169.473,329.441,188,329.441,188Z"
            transform="translate(-9.133 -13.651)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1872"
            data-name="Path 1872"
            d="M329.126,214.634c-.128-.119-.247-.247-.375-.384h0c-.439-.448-.851-.915-1.254-1.409-.183-.2-.357-.421-.531-.641h0c-.128-.156-.265-.3-.384-.467a.576.576,0,0,1-.092-.11h0l-.22-.275c-.11-.668-.21-1.364-.3-2.041h0c-.631-4.228-1.171-8.685-1.73-13.1-1.1-8.492-2.251-16.866-4.136-23.235a28.927,28.927,0,0,0-1.135-3.176l-.1-.247h0c-.156-.339-.293-.65-.458-.961v-.055c-.137-.293-.284-.558-.448-.851s-.21-.4-.329-.613-.22-.384-.339-.567c-.238-.375-.467-.75-.723-1.126v-.128c0-.21.046-.412.046-.631a.284.284,0,0,0,0-.092.329.329,0,0,0,0-.137v-.467h0v-.284c0-.092.046-.4.055-.586,0-.357.064-.7.092-1.043a1.751,1.751,0,0,0,0-.293h0v-.137a1.457,1.457,0,0,1,.046-.393v-.247c.055-.421.11-.833.183-1.235a1.031,1.031,0,0,0,0-.165l.165-.824h0a15.556,15.556,0,0,1,2.745,2.151c.183.183.348.339.512.531s.192.21.293.32c4.091,4.676,5.491,12.016,5.591,22.43,0,1.51.064,2.745.146,4.008a4.923,4.923,0,0,0,.055.915c.119,2.2.3,4.411.384,7.751,0,.595.055,1.272.092,2,0,.22.046.448.064.7s.046.494.073.75a2.915,2.915,0,0,0,.055.549c.082.7.165,1.428.256,2.187a1.234,1.234,0,0,0,.055.439,6.484,6.484,0,0,1,.11.824c.037.275.055.476.082.723.256,2.041.558,4.173.833,6.214a.831.831,0,0,0,.055.366A18.447,18.447,0,0,1,329.126,214.634Z"
            transform="translate(-8.817 -13.467)"
            fill="#ebf9ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1873"
            data-name="Path 1873"
            d="M316.89,164.12c5.052,3.752,7.44,14.514,7.669,24.251.329,14.084.668,10.268,1.528,23.3.714.769,1.83,1.656,2.809,2.636-1.931-12.226-2.608-15.777-2.132-27.39.412-9.893.156-20.591-5.774-26.036C320.45,162.015,317.723,163.186,316.89,164.12Z"
            transform="translate(-8.844 -13.651)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1874"
            data-name="Path 1874"
            d="M293.146,169.063l7.879-4.713c-1.135,1.958-4.265,4.118-7.614,7.138a15.74,15.74,0,0,1,4.713,7.715c2.05,7.1,5.125,16.472,5.82,22.979,1.83,17.461-5.994,19-5.646,31.115a49.9,49.9,0,0,1-6.479-4.054c.805-10.982,4.878-11.11,5.161-19.163.238-6.534-9.71-23.647-9.92-32.661C287.005,173.392,290.254,170.793,293.146,169.063Z"
            transform="translate(-6.313 -13.946)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1875"
            data-name="Path 1875"
            d="M316.817,161.65a9.7,9.7,0,0,1,5.271,4.356l-1.73,1.528,2.27.659a226.023,226.023,0,0,1,1.528,28.323c-1.309-9.279-2.169-17.388-4.667-24.892a17.89,17.89,0,0,0-3.029-5.921C316.68,164.029,316.6,163.27,316.817,161.65Z"
            transform="translate(-8.808 -13.717)"
            fill="#ebf9ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1876"
            data-name="Path 1876"
            d="M301.533,214.271a30.665,30.665,0,0,1,8.456.192l-1.263,9.481c-2.178,1.007-5.317.86-8.126-.2Z"
            transform="translate(-7.462 -18.165)"
            fill="#d2eefc"
            fillRule="evenodd"
          />
          <path
            id="Path_1877"
            data-name="Path 1877"
            d="M301.533,214.271a30.665,30.665,0,0,1,8.456.192c-.393,2.828-.165,2.791-3.175,3.075-5.372.494-3.661,1.034-5.372,6.5-.073.238-.567-.183-.842-.293Z"
            transform="translate(-7.462 -18.165)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1878"
            data-name="Path 1878"
            d="M301.837,212.932c3.962-.256,5.729-.622,8.666-.732l-.631,3.78c-.988.558-6.25,1.354-8.611.329Z"
            transform="translate(-7.518 -18.006)"
            fill="#d2eefc"
            fillRule="evenodd"
          />
          <path
            id="Path_1879"
            data-name="Path 1879"
            d="M301.837,212.932c3.962-.256,5.729-.622,8.666-.732-2.828,1.162-7.678,1.025-8.41,4.374a4.683,4.683,0,0,1-.833-.265Z"
            transform="translate(-7.518 -18.006)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1880"
            data-name="Path 1880"
            d="M309.562,218.12l-4.942.915-1.83,5.006a17.1,17.1,0,0,0,5.491.128Z"
            transform="translate(-7.648 -18.509)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1881"
            data-name="Path 1881"
            d="M310.277,212.73c-2.288.787-5.491,1.876-6.827,3.661a17.745,17.745,0,0,0,6.076-.6A13.724,13.724,0,0,0,310.277,212.73Z"
            transform="translate(-7.704 -18.051)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1882"
            data-name="Path 1882"
            d="M326.6,206.121c1.126-1.309,1.437-1.638,2.507-2.041l1.153,10.506a3.467,3.467,0,0,1-2.828,1.446Z"
            transform="translate(-9.668 -17.317)"
            fill="#d2eefc"
            fillRule="evenodd"
          />
          <path
            id="Path_1883"
            data-name="Path 1883"
            d="M326.6,206.121c1.126-1.309,1.437-1.638,2.507-2.041.211,2.993.275,2.892-.577,3.972-1.519,1.931-.915,2.041-.76,8.044a1.382,1.382,0,0,1-.339-.064Z"
            transform="translate(-9.668 -17.317)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1884"
            data-name="Path 1884"
            d="M329.445,208l-1.345,2.288.32,5.784a3.02,3.02,0,0,0,1.684-1.318Z"
            transform="translate(-9.796 -17.65)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1885"
            data-name="Path 1885"
            d="M326,203.457c1.29-.622,1.83-1.162,2.745-1.537l.586,4.027c-.21.677-1.83,1.977-2.846,1.116Z"
            transform="translate(-9.618 -17.134)"
            fill="#d2eefc"
            fillRule="evenodd"
          />
          <path
            id="Path_1886"
            data-name="Path 1886"
            d="M326,203.457c1.29-.622,1.83-1.162,2.745-1.537-.714,1.473-2.379,1.766-1.922,5.344a1.18,1.18,0,0,1-.339-.2Z"
            transform="translate(-9.618 -17.134)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1887"
            data-name="Path 1887"
            d="M328.907,202.55a8.9,8.9,0,0,0-1.537,4.438c.915-.092,1.19-.339,1.922-1.171C329.228,204.728,329.072,203.731,328.907,202.55Z"
            transform="translate(-9.734 -17.188)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1888"
            data-name="Path 1888"
            d="M299.864,165.532c-1.062,2.828-.32,7.769,1.217,12.565l2.745-1.135-1.254,3.111c5.893,7.2,9.426,18.111,10.24,29.4,2.553-27.893-9.49-36.944-10.268-46.406a10.542,10.542,0,0,0-2.681,2.462Z"
            transform="translate(-7.357 -13.837)"
            fill="#ebf9ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1889"
            data-name="Path 1889"
            d="M324.9,164.214a1.73,1.73,0,0,1-.732-.915,3.542,3.542,0,0,0-2.608-1.638,10.57,10.57,0,0,0-1.1-.183l-.439-.046h-.137a19.719,19.719,0,0,0-3.175.055h-.275a5.015,5.015,0,0,0-1.062.183l-3.532-.915L316.562,158l.412.165a2.1,2.1,0,0,0-.064.329,15.555,15.555,0,0,1,2.745,2.151h.915a4.576,4.576,0,0,1,4.017,2.8A5.176,5.176,0,0,1,324.9,164.214Z"
            transform="translate(-8.416 -13.407)"
            fill="#c3e6f7"
          />
          <path
            id="Path_1890"
            data-name="Path 1890"
            d="M290.895,277.58l20.8,12.254-.366.284-.879.439-20.215-11.8-.586-.448Z"
            transform="translate(-6.533 -23.555)"
            fill="#a8a5a3"
            fillRule="evenodd"
          />
          <path
            id="Path_1891"
            data-name="Path 1891"
            d="M312.38,291.693l1.245-.723a2.929,2.929,0,0,0,2.745,0C314.778,292.215,313.936,292.544,312.38,291.693Z"
            transform="translate(-8.462 -24.691)"
            fill="#a8a5a3"
            fillRule="evenodd"
          />
          <path
            id="Path_1892"
            data-name="Path 1892"
            d="M316.893,289.68l1.327-.86a2.91,2.91,0,0,1-1.08,2.745l-1.4.915A2.983,2.983,0,0,0,316.893,289.68Z"
            transform="translate(-8.747 -24.509)"
            fill="#c9c7c5"
            fillRule="evenodd"
          />
          <path
            id="Path_1893"
            data-name="Path 1893"
            d="M307.992,235.717a1.088,1.088,0,0,0-.082-.137h0a37.656,37.656,0,0,0-7.092-9.4l-.183-.174a33.861,33.861,0,0,0-6.973-5.07,30.692,30.692,0,0,0-6.516-2.819L287.09,218l1.089-.65h.119a32.783,32.783,0,0,1,6.287,2.581,35.974,35.974,0,0,1,15.026,15.695c.091.2.192.4.293.6a55.475,55.475,0,0,1,4.777,16.262c.229,1.547.814,5.875.869,7.431l.22,22.878-1.327.851-.512-24.251C313.629,251.988,311.222,241.793,307.992,235.717Z"
            transform="translate(-6.315 -18.444)"
            fill="#d6d4d2"
            fillRule="evenodd"
          />
          <path
            id="Path_1894"
            data-name="Path 1894"
            d="M303.477,228.571a33.786,33.786,0,0,0-9.92-8.017,29.55,29.55,0,0,0-6.507-2.535v1.034a32.5,32.5,0,0,1,6.269,2.553,33.027,33.027,0,0,1,9.618,7.788,43.29,43.29,0,0,1,8.84,18.678,82.987,82.987,0,0,1,1.83,13.489l.156,21.762c.064,2.288-1.528,3.267-3.56,2.178l-20.8-12.245v.723l20.8,12.254c2.379,1.281,4.264.128,4.182-2.562-.22-7.9.137-14.1-.082-22.009a84.122,84.122,0,0,0-1.876-13.727c-1.73-7.7-4.667-14.267-8.968-19.337Z"
            transform="translate(-6.312 -18.5)"
            fill="#534b48"
            fillRule="evenodd"
          />
          <path
            id="Path_1895"
            data-name="Path 1895"
            d="M293.469,220.823c-.3-.165-.8-.247-1.089-.393l.073,1.29c.284.137.558.275.851.439,5.656,3.02,12.885,9.1,16.9,21.149l1.025.073a34.491,34.491,0,0,0-17.763-22.558Z"
            transform="translate(-6.764 -18.705)"
            fill="#4332a5"
            fillRule="evenodd"
          />
          <path
            id="Path_1896"
            data-name="Path 1896"
            d="M299.957,225.452a36.411,36.411,0,0,1,5.939,6.827,45.158,45.158,0,0,1,5.335,10.982l2.151-1.354a43.643,43.643,0,0,0-6.525-12.638,36.851,36.851,0,0,0-4.75-5.171,34.342,34.342,0,0,0-7.5-5.1h-.064l-2.16,1.345a33.861,33.861,0,0,1,7.577,5.143Z"
            transform="translate(-6.764 -18.584)"
            fill="#8662de"
            fillRule="evenodd"
          />
          <path
            id="Path_1897"
            data-name="Path 1897"
            d="M306.44,160s6.982,4.127,8.108,3.981,1.043-1.995,1.043-1.995Z"
            transform="translate(-7.958 -13.576)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1898"
            data-name="Path 1898"
            d="M317.13,163.07s3.725,1.2,5.784,11.22"
            transform="translate(-8.865 -13.837)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="0.78"
          />
          <path
            id="Path_1899"
            data-name="Path 1899"
            d="M303.183,161.94s-5.289,2.425,4.155,13.361c0,0,1.83,2.59,2.251,3.157"
            transform="translate(-7.556 -13.741)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="0.78"
          />
          <path
            id="Path_1900"
            data-name="Path 1900"
            d="M313.2,194.077c2.27,1,3.386.247,1.1-7.495-2.517-8.492-4.786-6.864-4.786-6.864s-4.493,1.235-2.507,15.109a2.626,2.626,0,0,0,1.29,2.123c.522.329,1.656-.229,2.032-.915"
            transform="translate(-7.962 -15.239)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="0.84"
          />
          <ellipse
            id="Ellipse_180"
            data-name="Ellipse 180"
            cx="1.638"
            cy="2.324"
            rx="1.638"
            ry="2.324"
            transform="translate(312.2 160.526)"
          />
          <path
            id="Path_1901"
            data-name="Path 1901"
            d="M325.166,177.784a2.865,2.865,0,0,1-.211,1.1,2.379,2.379,0,0,1-.512.824,1.3,1.3,0,0,1-.915.394c-.915,0-1.638-1.034-1.638-2.315a2.626,2.626,0,0,1,.778-1.986,1.309,1.309,0,0,1,.86-.339,1.217,1.217,0,0,1,.531.119,2.416,2.416,0,0,1,1.107,2.205Z"
            transform="translate(-9.268 -14.889)"
            fill="#3b3d3d"
            fillRule="evenodd"
          />
          <path
            id="Path_1902"
            data-name="Path 1902"
            d="M325.366,177.8a2.865,2.865,0,0,1-.211,1.1,2.379,2.379,0,0,1-.512.824c.833-2.992-.393-4.118-.393-4.118h0A2.416,2.416,0,0,1,325.366,177.8Z"
            transform="translate(-9.469 -14.9)"
            fill="#6b6b6b"
            fillRule="evenodd"
          />
          <path
            id="Path_1903"
            data-name="Path 1903"
            d="M318.178,156.375c-.128.75-.366,1.62-.421,2.37-.1,1.327-.265,1.9-.476,2.123a.979.979,0,0,1-.229.2,5.084,5.084,0,0,1-1.126.613,6.077,6.077,0,0,1-2.489.586,5.171,5.171,0,0,1-1.528-.329c-1.29-.714-4.356-3.13-5.491-3.963-1.391-.988-1.428-2.361-2.059-3.661a11.8,11.8,0,0,0-2.59-2.819,5.491,5.491,0,0,1-3.029-4.173,10.066,10.066,0,0,1,2.928-9.362,9.069,9.069,0,0,1,7.751-2.2,10.012,10.012,0,0,1,8.575,7.321,11.572,11.572,0,0,1,.439,2.242c0,.238.265.476.293.714a3.119,3.119,0,0,1,0,1.235c-.238,1.016-.256.613-.265,1.336,0,.86.522,1.565.494,2.654A35.571,35.571,0,0,1,318.178,156.375Z"
            transform="translate(-7.286 -11.507)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1904"
            data-name="Path 1904"
            d="M320.327,147.39a2.937,2.937,0,0,1-.046,1.016,3.825,3.825,0,0,0-.229,1.327c0,.915.549,1.345.512,2.443a18.073,18.073,0,0,1-.6,3.953c-.32,1.391-1.83.5-1.995.522s-.092.156-.082.339,0,.11,0,.119,0,0-.073-.092-.11-.3-.238-.311-.211.11-.275.165a.714.714,0,0,0-.064.512c0,.21,0,.174-.11,0-.137-.293.485-.2.156-.238s0-.21-.329-.65c1.19-.961.622-.448,1-.622.586-.265.8-.1.476-.732a10.358,10.358,0,0,1-1.19-3.139,2.69,2.69,0,0,1,.915-2.654A3.249,3.249,0,0,0,320.327,147.39Z"
            transform="translate(-8.85 -12.506)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1905"
            data-name="Path 1905"
            d="M311.93,161.942c-1.29-.723-4.466-3.532-5.61-4.356a4.8,4.8,0,0,1-1.446-2.059,15.219,15.219,0,0,0-3.084-3.99,5.491,5.491,0,0,1-3.02-4.182,10.067,10.067,0,0,1,2.938-9.362,9.151,9.151,0,0,1,7.76-2.187h.265c4.814.787,7.577,3.661,8.456,7.687-.7.54-3.661.128-9.334,1.913-1.611,1.126-1.537,2.462.137,3.661.631.448.686.75.467.988s-1.272.595-1.83,1-.366,1.062-.22,1.748a8.931,8.931,0,0,0,1.528,3.285c1.235.915,2.69,2,2.745,3.221.092,1.528.769,2.9,3.331,2.745a4.686,4.686,0,0,1-3.112-.128Z"
            transform="translate(-7.289 -11.511)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1906"
            data-name="Path 1906"
            d="M305.923,143.664c-.915,3.587,1.126,8.639,2.1,12.162A4.576,4.576,0,0,0,310,158.114a9.306,9.306,0,0,0,1.977,1.144l3.267,3.761a5.024,5.024,0,0,1-3.121-.339,19.748,19.748,0,0,1-6.324-3.661c-.686-.577-.915-.915-.677-2.306a19.218,19.218,0,0,0-.247-6.571c-.357-1.766-.375-3.121-1.83-4.914C304.715,143.573,306.755,140.3,305.923,143.664Z"
            transform="translate(-7.669 -12.066)"
            fill="#4c4c4b"
            fillRule="evenodd"
          />
          <path
            id="Path_1907"
            data-name="Path 1907"
            d="M319.9,157.111c-.128.75-.366,1.62-.421,2.37-.1,1.327-.265,1.9-.476,2.123a.981.981,0,0,1-.229.2c.119-1.144.577-5.262.915-6.616.421-1.556,1.016-2.69.586-3.963s-.567-.915-.284-3a11.587,11.587,0,0,0-.183-3.935h0a7.868,7.868,0,0,1,.293,1.83c0,.238.265.476.293.714a3.12,3.12,0,0,1,0,1.235c-.238,1.016-.256.613-.265,1.336,0,.86.522,1.565.494,2.654a35.587,35.587,0,0,1-.723,5.052Z"
            transform="translate(-9.004 -12.243)"
            fill="#f4bd98"
          />
          <path
            id="Path_1908"
            data-name="Path 1908"
            d="M311.816,160.08a10.844,10.844,0,0,0,2.672,3.413,11.3,11.3,0,0,1,.915.915,2.014,2.014,0,0,0,.549-.128,5.884,5.884,0,0,0,2.508-1.428c.805-1.062,1.025-4.466,1.034-5.793-.4.393-.567.339-1.364.174a8.309,8.309,0,0,0-2.883.65c-2.489,1.153-1.94,2.544-2.562,2.636a3.158,3.158,0,0,1-.915-.439ZM315.394,162c-.915,0-1.19-1.153-1.19-1.235,0-.265.631-.915.851-1.153a11.412,11.412,0,0,1,2.608-1c.97-.348.824.458.714,1.153s-.22,1.272-.833,1.62a.5.5,0,0,0-.567-.247.476.476,0,0,0-.384.5,2.452,2.452,0,0,1-1.2.357Z"
            transform="translate(-8.41 -13.327)"
            fill="#5b5b5a"
            fillRule="evenodd"
          />
          <path
            id="Path_1909"
            data-name="Path 1909"
            d="M310.644,143.878c-1.364-.622-2.215-2.032-4.429-3.176s-4.713-2.407-6.488-.915c-1.5,2.05-1.785,5.765-1.373,7.751a12.327,12.327,0,0,0,4.923,7.413c1.08.842,1.675-2.032,1.94-2.9a30.206,30.206,0,0,1,.476-3.249,13.814,13.814,0,0,0,.128-1.592c-.165-1.885.7-2.745,1.135-4C307.652,142.212,308.54,143.585,310.644,143.878Z"
            transform="translate(-7.257 -11.803)"
            fill="#3a3a3a"
            fillRule="evenodd"
          />
          <path
            id="Path_1910"
            data-name="Path 1910"
            d="M314.965,150.1c-.2.512-.3.915-.851.988a13.919,13.919,0,0,1-2.745.265c-.787,0-.522-.21-1.071.421a3.807,3.807,0,0,1-1.428,1.016c.613-.686,1.135-1.327,1.7-2.068.805-.073,1.592-.2,2.306-.293a10.064,10.064,0,0,1,1.162-.2c.11-.046-.073-.064-.348-.046A2.306,2.306,0,0,1,314.965,150.1Z"
            transform="translate(-8.164 -12.731)"
            fill="#4c4c4b"
            fillRule="evenodd"
          />
          <path
            id="Path_1911"
            data-name="Path 1911"
            d="M317.969,149.734a1.418,1.418,0,0,0,.869-.329,9.318,9.318,0,0,0,1.153-.769c.11-.092.293-.265.339-.064.073-.183,0-.146.064-.412-.128,0,0-.384-.476-.137-.275.165-.7.293-.915.4s-.512.238-.961.485a1.5,1.5,0,0,1,.192-.174,1.153,1.153,0,0,0-.567.329C317.594,149.294,317.63,149.679,317.969,149.734Z"
            transform="translate(-8.908 -12.553)"
            fill="#4c4c4b"
            fillRule="evenodd"
          />
          <path
            id="Path_1912"
            data-name="Path 1912"
            d="M316.246,151.556a.11.11,0,0,1-.146-.073.119.119,0,0,1,.073-.146l1.354-.458a.116.116,0,1,1,.073.22Z"
            transform="translate(-8.777 -12.802)"
            fill="#4a4642"
            fillRule="evenodd"
          />
          <path
            id="Path_1913"
            data-name="Path 1913"
            d="M303.49,150.82l.384.366,6.15,2.077h0c.137,0,.119-.586.073-.6l-6.6-1.83Z"
            transform="translate(-7.707 -12.797)"
            fill="#383838"
          />
          <path
            id="Path_1914"
            data-name="Path 1914"
            d="M304.007,150.638c-1.922-.979-2.279,1.364-2.169,2.828.073,1.007.915,1.043,1.071,1.83a1.83,1.83,0,0,0,1.483,1.574c1.235.137.732-1.83.7-2.553C305.4,153.173,305.233,151.27,304.007,150.638Z"
            transform="translate(-7.565 -12.762)"
            fill="#e8a476"
            fillRule="evenodd"
          />
          <path
            id="Path_1915"
            data-name="Path 1915"
            d="M302.359,152.752c.156-1.364.4-1.446.915-1.492s1.226,1.364,1.2,1.785c-.265-.165-.714-.366-.979-.073a.824.824,0,0,1,.595.174c.174.11.265.329.531.357a1.446,1.446,0,0,0,0-.714c-.183-.824-.641-1.83-1.409-1.73C302.8,151.105,302.3,151.4,302.359,152.752Z"
            transform="translate(-7.611 -12.817)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1916"
            data-name="Path 1916"
            d="M304.319,154.75c-.055-.238.119-.549-.229-.86.4.082.558.256.622.5a1.559,1.559,0,0,1,0,.567C304.712,155,304.4,155.162,304.319,154.75Z"
            transform="translate(-7.758 -13.058)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1917"
            data-name="Path 1917"
            d="M299.2,140.4c3.331-1.9,3.981,1.885,7.98,3.661,1.7.778,4.146-.915,6.616-1.574,1.556-.421,4.9.915,5.125.192.869-1.922,1.437-2.489,1.3-3s-.769-.869-2.288-2.205c-.961-.467-3.542-2.745-4.649-3.166-4.338-1.748-11.293-1.318-13.626,5.052C299.584,139.606,299.273,140.183,299.2,140.4Z"
            transform="translate(-7.343 -11.321)"
            fill="#5b5b5a"
            fillRule="evenodd"
          />
          <path
            id="Path_1918"
            data-name="Path 1918"
            d="M298.94,141.536c3.331-1.9,3.5,2.087,7.5,3.908,1.7.778,4.695-.631,7.165-1.327,1.556-.43,5.061-.128,5.289-.805.869-1.922,1.437-2.489,1.3-3a8.621,8.621,0,0,1-3.743.8c-3.148-.22-8.556,2.91-9.106,3.4s-3.99-3.459-5.207-3.953a4.969,4.969,0,0,0-2.846.174C299.215,140.941,298.995,141.317,298.94,141.536Z"
            transform="translate(-7.321 -11.905)"
            fill="#4c4c4b"
          />
          <path
            id="Path_1919"
            data-name="Path 1919"
            d="M315.67,160.365a16.957,16.957,0,0,1,2.745-.915A2.077,2.077,0,0,1,315.67,160.365Z"
            transform="translate(-8.741 -13.53)"
            fill="#c97563"
          />
          <path
            id="Path_1920"
            data-name="Path 1920"
            d="M313.964,152.2s-.805-.485-2,.412"
            transform="translate(-8.426 -12.903)"
            fill="#401c28"
            fillRule="evenodd"
          />
          <ellipse
            id="Ellipse_181"
            data-name="Ellipse 181"
            cx="0.869"
            cy="0.503"
            rx="0.869"
            ry="0.503"
            transform="translate(303.873 140.868) rotate(-78.3)"
            fill="#401c28"
          />
          <path
            id="Path_1921"
            data-name="Path 1921"
            d="M318.61,150.6c.055-.073.686-.522,1.062-.265"
            transform="translate(-8.99 -12.749)"
            fill="#401c28"
            fillRule="evenodd"
          />
          <ellipse
            id="Ellipse_182"
            data-name="Ellipse 182"
            cx="0.76"
            cy="0.403"
            rx="0.76"
            ry="0.403"
            transform="translate(309.455 139.105) rotate(-80.43)"
            fill="#401c28"
          />
          <path
            id="Path_1922"
            data-name="Path 1922"
            d="M310.587,152.287l-.247,3.24,5.088-1.748.229-3.029Z"
            transform="translate(-8.289 -12.791)"
            fill="#e9f5f5"
            fillRule="evenodd"
            opacity="0.5"
          />
          <path
            id="Path_1923"
            data-name="Path 1923"
            d="M315.2,151.114l-.183,2.581-4.429,1.409.22-2.745L315.2,151.1m.549-.668-5.408,1.537L310,155.8l5.491-1.739.265-3.661Z"
            transform="translate(-8.26 -12.762)"
            fill="#383838"
          />
          <path
            id="Path_1924"
            data-name="Path 1924"
            d="M318.179,150l-.229,3.011,2.892-1.181.211-2.809Z"
            transform="translate(-8.934 -12.645)"
            fill="#e9f5f5"
            opacity="0.5"
          />
          <path
            id="Path_1925"
            data-name="Path 1925"
            d="M320.71,149.407l-.174,2.334-2.388.915.146-2.407,2.416-.814m.558-.7-3.478,1.162-.211,3.487,3.4-1.254.265-3.4Z"
            transform="translate(-8.903 -12.62)"
            fill="#383838"
          />
          <path
            id="Path_1926"
            data-name="Path 1926"
            d="M317.07,151.45a10.285,10.285,0,0,1,1.592,4.3.6.6,0,0,1-.137.275,2.792,2.792,0,0,1-1.217.439,2.242,2.242,0,0,1-1.208-.165,3.559,3.559,0,0,0,1.107-.247,3.861,3.861,0,0,0,.915-.512c-.1,0-.082.2-.092.11a29.672,29.672,0,0,1-.915-4.2Z"
            transform="translate(-8.777 -12.851)"
            fill="#e09870"
          />
          <g
            id="Group_1038"
            data-name="Group 1038"
            transform="translate(208.836 187.696)"
            opacity="0.17"
          >
            <image
              id="Rectangle_1004"
              data-name="Rectangle 1004"
              width="266.304"
              height="183.942"
              transform="translate(0 0)"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASMAAADJCAYAAABoiFR9AAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4Xu29abNlz3LW9+RuvojBERiELOle6YWFBiNdSRFgJvExPM/GExeFJZkIg0QgpM/hAWOM5hHN09UAxuP36J1+kdOTWbX23qf7dPc5/V8ZXbuqsrKGVWvV72TV2ue0qCpOOeWUUz61XO4ZnHLKKad8DDlhdMopp7wIOWF0yimnvAg5YXTKKae8CDlhdMopp7wIOWF0yimnvAg5YXTKKae8CDlhdMopp7wIOWF0yimnvAg5YXTKKae8CDlhdMopp7wIOWF0yimnvAg5YXTKKae8CPkT9wxOOeUR+TP/yt+SptBtEtj8lYibfzji2f6qhAB9hPjn/98PPFfjpzyDyPknRE55H/kzf/KrsgGGvGAYLQ2eUHoZcsLolHeSP/snvyqAr2zV4XO8WBjNxtRL8McnkD65nDA65UkSEHIRhxFQm6DF/3hBMAL6cGLgGqP/4//3hNKnkhNGpzwkf/ZPfZWXcgJJAdnCyArLe0rd5nnTzd6Jym6UPioKac6bckwwyo5OKH18OWF0yk1JCIVoh47DaIKogesTw8hH0bi4g9HiMQEnlD6mnDA6ZStf96e+KuPJCMAwcGKbJlnuerdF2kTZh4fRNJ4wYhAFRRlGMz6B9JHkhNEpTb7uX/3bEnTwJ2N6Ow08unpGDCN2R1ynlQ55HhjtIQQoIDiAjUoAqvC52vkW74//n7/90EBOeTc5YXSKA4hFZcCoYKNN57BRIUjtYET183mrPm/BCMDWmxoWB/m4hOn5ZBie0S0YJXH/6ITSB5ETRp9YvuHr/rv8mazx/G+WlnJmZxOq7e3sq72ZVIaAlDBaPR5teaB7Rz2UbbW1ni/N4a1yfGHNYqQplun5ZJBIF4zYztJiO80El8sJpeeVE0afSBJCIQr5hDAagGgw6kBSSjNo9jDqwAKwhZG3e/NJ3D+nrNRNbN12r6eFDYw4WDsFo96HAH/0f59Aei45YfSR5Rv/3A8KoLy28me2xk5g3pK2ULVFw+xgRbcGIsl97WAkZFfl48wIeMgzKhiVbZSZVH976RfHpnojVtQWjfXXKL8DI66/g1GO44TS+8sJo48k3/j1P0iPrkLHK3Io8AFhJKz3ZPQ1wSBYPaMJo7A/glGVa4OR97m8fctx0DALVKHW/kFluk/LDchAAVwHjK6rjQR0AlzRD8Mox3NC6d3lhNEHlm/8+h/kn/6A/4DdwEhyxVVZ1lPOUDTMdnoZDfCiZxAMiOj7e0a1XDuQ1rdv0XYf1yoxRWHJMKC0WP4YROwZXYddB5KIkm3va/W4Uk4oPV1OGH0g+aZ/3SDUtmPxCOMmjHgBw8voSdcWsWjpx2JW01GZroCJslhzoqs+xwr0soM3ak2nTa+jvxrfjSeyFr5dLINAcR9Cigkis7/uyq2swYjbAfWDGYsI/vD/+uqNSzllygmjZ5Zv+oYf8kVl89oWdDzCSBg1IHiNIxgRYLQefRLtCbYPiKRe78AlxtHsOmDI9q53FDbUxmILt91dGgsv+pk+CjvYxBYtPKM9kI5hxNDDjEWKqSeUHpMTRs8kX/qGH6qnTwE4AA5gZLbsSXiZ7mAESL9N9ryj6Wo1jPoy7MVNCgJ7GAE6zno6XMj2MRhZV6E7gJEbab/++ZBOCOzCPP+5cizdK7pirePlCaM6X4qQo13HI/W7cDn2E0q35YTRe8qXvvGHEgoehWdki6/DyNPqi5cWYnoPynlEObUD72mBkZewPvsj+w4Fy0wgBDC6XQdMz+MxIGnT6Wwj5MhD0k18FLbeUMRyDCOqJ3yetIMR50F6CGTqTQT4w//zq5tLO+WE0TvIl77xh2ORRySU28FoLPq7MJreUXhG3O+EUY1hgAze59Imlz/dOyK7GDvuwoj6nWPqY86pbTIXt94IC4AilhVEO+/o6l5RwkkojQ6iHgQ4gFHemRNIq5wweoJ8+Zt+OLZXLv0sxtUMI4YILcgFRuQ5KLpttamZX8+Aws7H1xd2LPxRpr39CQSBdbqHUV4n5ZHbTJl67kObLl5SLWM2UZru1GTMC/7mtsxjPieaIFq9IxEGGLfFMOJ+EWV3YJSXdEKp5ITRg/LlbzJvqC92BWhR+kz6orMy5YX5GIw4DyqH1iJe+iZb6FZ/B0a7Pq2CQDe2vY8MGn09DUjRDscluotaHOG6SV+B9Goq2OjfDjsK0g62ZcJtDyONMkHcigygeiF54X9wQumE0T358pd+mB8f9oyEgFAQsEQsfl7ItBgXGF0iPWBUC1QJdr3vkLTX0vMCn3UCClW+wsjzuukfdK09WP9P2a5hAikk8kqf0LnAe2hAkgmbvUe0BvKKvB1uu50lLWOQ5hn1sQqlPc6LFuAP/uVXQ/+FkxNGB/LlL/1wLYxapNC2mJu3MT2jXHy6LMaE0QW97KLRbl/kAJqXhdE32A4xlmNPp+nG+LiM6/Rr5PLnARJoyxZ9sCileEGr0qIXi7sXcx9Cb3u+eUUr0OyKG/QofQSjKAPlgbyRUSb4g3/5t+pav0BywmjIl7/03+ezAdCjwws3F3kCB+CFdR9GF2rn0stw2XhH3BZK52Ok8UWZAvXo84KPegS2MT625zrH3tFurHAvb6Of9trayecxdCy6iRWaizvC/O7QU0HUbIQhZG1zu7qkDUYdUPUU9TwWGOUEfNGgdMLI5Zu/bBCqA2daFLRAtXRhw14DLbTyCsijye0YoJemt3oXxCIeC3bTVjzDFnfwADEe7TrUtQnXybFXW9RH1hMoQLa9/P2AFO0g+tmIbuKj8AiIJoze+vZsB6IjGK1AEuEzph4KRgidACh9TGnNwBcFSl94GAWEXOjLhbll2C1aX7C0DWEPqIAj3qaggONpFTU4hWfE50ZsuyxgrTxynBsYIRZ5L+N6E7Tba17qLWPo4xt1Ht2yofUPAOuzyYp1ofewA8YeQJEWaV6S7ODVvabZj0JwpS3aCqTuGcW2EqWPqUDFPit/8H983lD6wsJoQigS9eXCXDzgBYNcXBA8BqPuAd2CkdUN7+gekFBjakDqC7rGGzoq10WvlZ5ls16H1xjf1NkY7gMJqBWZQj8hWEsh8quXsoJoQugtamuWMJJl+3YTRpWWtkV7FEauj1vQrqnuBD5vIH3hYPTN3+wQqoUWEnpfZBq6ZVFqLqADGFn+EuW6BU6eG11ST7DyrRpt61rboL58bD7ejYcUT/ko83TbRrE91xl9QVBA4vZ4jIvOrvcASFYnRABQlqQe2LloFe8CI9uWvWWd7EH0FscgKp3I+uatAacDSqoMKI+Kr4tnJt31r32GUPpCwCgBVLI8+KAFobHYynazqNKmLT5t27H0bvwtmYOnyi4DVASjbH8HJGD1TJBj3nhI2hf8KF88pA6ZtT0ah4b9HOMWSABEj4GUy5JlPKG0UDXeq/EinkBawSG4AjchtG7jHvlKQHlFE0QOqnWMEmM1zyjKEeUAQPVicnJKPicofdYw+pZv/jsCAPUmmBZUXXZfaPnTfiwYWlia+bSh8x7OH8LIAaQXrfyRdyRlT+P0a9Cpi2dWWZdp1Ng39YYXpOj5UU71l3OkCkdA6h7ZMk66PynaohZzmDCKeBfuQ2j1iPbbN+BKB9ezX0s/DiMOoHp+owAqAwB87V+8fih9ljAKCIXkL5/yA68jTwtOY4EdLCqtfG7FIm91B4zKA+Jzodiq3YARjWO/qGO8yHzVAZR1ldZ+/VTW+ipbbvvQS7oBpIPxb4AEik3WxzMXo1aew8MwknsQMoDsD7sXEOFKXtEKJNmPTSJvMLrCpK5HKA2baLKpO4nXD6TPCkbf8i1/JxYhQA/1HRgtC0u717MsJm1bJ99Kmc2AkQEn8oqEDgEogVTtPAYkZFwQKF3VCV27TvV6U29BMfvSdS5Gnaz7Pl5SCKdLlD57zOFhGOHpEDp4C7cF0S0YZSwx1oJRv56CjQIJr8zTTIX+1ULps4BRQsiEflbEQtrC6HBB1dsvAhLBQksXntHdsyEvmzDKcp3eEfWpPJYDbwcK6NTZRBzW0Zorvv6ou9Rb2j+AC24B6bgeDv6W0xT1z74oKzwFRh00440aVghtz5Kknz+tIHI7jDFJ5NP7OYRRBp8YLo98iKcFX/sX/y3rX7y8ahgtEArpiwgDRrEgep7CBkZ8iFxA2sAIaN5ReUYFnLB/1DuSarNtv+Y1wccAbTrlsnUe4Pbv6iX1uiM8yUuKfkFQ2olu4gr6BBh1+Nzfss2yYxDt+pljUQmdHajPMQds2vVJv15QOXrsUyrA1/7564DSq4TRIYQivYfRfOgPF9GAUfNS3IZfywtoK+ZlW+8He+8ogBXbv513JF4eY5pg6bG2cyTX39223faS1j47ZA6B5PXvQwkzVgA3vvg4F2GEx2H0CHAOIYS3qK3Z8bnSja8DSOQFiu4VVVp6XviaO6jQYwkbAK8DSK8ORgcg6vGyaDTTLRwtII3zHfKMyr68nwmbQyAt3tFij9quVX+3gbRcJ6WjbECJ5kFbvayr1d8sr/pj3pRt7nhJi/06nhBOe7HW5mxdhOtCfm4YJYRwBeTYbg+iFiTGVl8zmONVFHAmjLhszoGnhWc0Z+0lQ+lP3DN4wdIeVsrvFtLMHwVb/AICDekLIiLARcvuTpCAjdXjMglgyQVQ8Tz3yToRQCypNk4gwAMaL6JMyiPx6hB7VrHzSkS8pgITLFVfupclbqN2PVHGdQUQH6+KrFCK8cb1INMubqQ+NsBcpke+Z3QPRnIQV1ogdEB9bMe62gLKjaCbNPfbACP9OmcgaVMX7QKA/rk//QMiAH7/BULpNcMohGdeKJaD/AyX47wDgiC0TydsEi4S0EnYFHxkbteoPUGDXI2L4CE2Nv/Rp7aMN2DxlP1p+B2UZDmDyvrifTqUuE3x+iAo0bi8TocSz+mEEghKMWag+mVRL45LCe8AmotSDUCGqafDyP6SfnguMmwe03UQzf7eis1HfPlS0OvP9nWkHwnwOjyD0Y4CwNf/6R8Q4GVB6XOA0RSZeYHIODeKcASiiyC2aqm3n/oEFsGhd/Rm5LfAonabdzTarfH1BQ4bo4ivTbvuW1ByqNTi92aGp8MhLapfanvxlKKOZD97T+mCglK4eryljFSleYNWiywXnyR05IKC1NNhVPHTdbK1YzDF3DB4OOgmfQtIV+wl6t+ShNJLAdLnCCN7iA/PLih0u0uLc2tUWyys3sxN2AjwRjts3oSNYLtdi/4YSDy2GHdCRwCge0mm2kGpjMVMwmbr6VQ93Ny+Rf13gZLVlbDXGPe6kgQsu+2ZwuaJF+plxDOw9zLjx3UFoQvq3GipI9yv0LxVKBhJA1a8eYs2E8KUniEk2mWJfgBAX4qX9HnC6LbwzZ/5GS4jvXg1YtDonk73jN6MeplftmsNSBCBMpB66NCB2L/ngJK4j7I5M1q2b6G/9PoQ0IG1eBsNStv2yVvygVHEEj2vi7D+0Np1E88gm/R9nRzaHdaRFUS78US9CAGNtV1pZUdAmmCKiQ6JNhT49Fu3LwyMfMb5XtgN3y92g4FAlrdfN4NcAGX4vBHgog1I5R2hgPQm+y1oiQ1BL+iLPwJ8/Ba/D5S8fs1P83S4/QzemQDbsV1QYJGoL1S/gal7Ytl85qAMplgoHFeQTF838RW6LHwDRKUly2Wj29ndaEc6QDzdvhIgSyhgK7Bs7TjWkVab2rxeKX0GkH6KAsDX/2sOpT/+uFD6fGEUj3dOp8zMUTzTYs8DnTkNgEnzjnK79gYdSKRbgPRG07twIAHi7XkfKtoXbx+neLpDCQaYO1Dy+l5hPVMCAkziUygcxOrvoCQxfutB21tBIKFUbdbjL+CkZEr9X1iqrgvuCpvPgpDl+XX7HkCV3pXfq5M64fKEmhy1xSH0F2ozgsGne2Y5D9hf/5Ro55YklD4mkD5fGIXQ1BtDNnNrNnHDQyNAekeCFUi8NRtAojDPj3IL170oB5KMug4k61+8f9+68TiRcQELPi7xrDwIJXNLvHwBk9AcrN5S/lQ/BJP4OLxcqFy9hxzTeqvyTqI8IEi85jdExWJUAFetRV1AehqAtrCZadmVC9ve/GpAeUiC2S7PoVJ6tqWo7ysBdgcZUBxCok2W6AMA9GN6Sa8PRlLJzcO6l5xau9sDSNxi5O+Fy0HeATK+ErAeaBuEdAAJZqcFJIMe4As7z5IASVAEOHjsVtPqwepAvEiUoZRtU12rLVnP27D+hPpoYGpzItSGLn00bynq+97M2tZMQSJLt00pVqqikOYVXB1UvD3ja70LG3VQyDGMCmAyyxcAHfe1/pmSCSKbBxn5bEd4TqLtBiG5DaYp0Y4CH2fr9upgJB4rZ0LuTZNPrXiCzKU3PKrJoXfEi7C+DiAJmp2HVLARvDE77M6RCnDWV25xUFs3eJld1i0oAYj6frEOl623VHXiOnETTHLgMYXX+AiY4HMLFJhSxv1W/9wtrgulY5He+Da03tyOSeluQOUmdN4epMu2Q4zh10N/w8btCDo8uM05P1d0iTr3Vo8CHxZKrw5G8UROH749rLemKW0WJEl+bhalCHADSJEPIAlqK+bpW0BK2+kliU6vC9xfrlnbwglwCKUYa6Rzi2SXpwAD5VEwSda9D6aqdwym6AMJJhsLKpM3TBNdM9RW7TLiGd76uI9BUen7UNmnj8tl1Uu3ufcNbrFpXPqaMXtFwDpnJbEsjiWh9NxAen0wiqeSnlVT17y0oqPpchtbN4kku8H9duSNFwePrZ/l/Cjy9WVIILZsOw/pDQJKbduGst9DKReztZ9XYmO0lSvwp3TAANQGqL5TTaLePTBF7aj7FDDldYi1INYF6FogNVxQ0q+obtYCIrXRKlYQLWD08FzQeazeBkBA84TWtjdbOAtyIbvqrx9wR3wLRjs4CaVDFHU3nv086fXBKISeVQCNQE8Ck9hHrNw0KS8krMS1IsBFVQT1ZUgDEgpK4vDR3LIlZN6Q7eZNW3hJC5QEivjzJDwe+Dj9ShMEcG8pDhN2HlPVr/JbHtM6H9HeQ2CCgM6IYNeNrBejQcJpiFiRhInfNLtxCjQPoC1IpTEeBn1G6BREbrYn61u1nl7f/nl52xpWkAQG9xF5LrsFowhHEu0o8Hxbt9cLoylC6SRQrT5lm1pQJQJAxRei1gIuKLWbbl6SuMcyoLT7UmR6Pg6k/uo/vCQG1Q5Kudh1fQjjKlBjFQC+hXObrLdC5SlgYrvDdiS8oB2cVjBxO/QBAfwPidSjHrcnNOENKeLA2trNxSdzjBYuQB1So2D1NOgcA2Xbhhy3x4fhm7oPfT9JSccgirjmrMIVcItVos1bklB6HyC9OhgJTdjhXz8RSvhTzPM8WMU30yqpvUbXXja3GemxkJeUngwSKL7VOvaSDEyHWzdc/KoLegElQKAEGPj4hdIKNzUbiasXAto9MHk7rsq+NFq51U6N59hrKjCB2om2KkElChz8SgidoZS9wH6BNq/F0wrkXF4pHIHoLayDW4Bi6LD+sfS6jdudawkmkDpIgX5drJ8wusKezzGPWW+uspjfXfxe8upgxPI4mMTBYwsnZy7q90Vktxbivy5BUIob3l9jX8Qho+zFBJTUYQP3gARvFHgDFddreUl7KEV74iDzftPbiWkIj2lzLTlugLZNZqB5XZo2VKe3k/2EEeouiK5e02yng4lsqEnviW5oJaN9FbPjhWDnRf3wOsqvqAUdPXietqB9zBM4uahlgcWT0mvd2wASdPCsab7HHqTgA3RQMIxqnqTZAzV/O3k2ALG8QhgJpekpJfUWTOIfCgCai0HjZu4WoSC9JCDPdsK+oFNe0kX7gfXYdplO9lBiTynfulG/8TbNz6XKQyEwIa4LCiRE4dcmlK+tXJZLBxO8napf7XA+2oJQWzavT4ZTtqV8R13jot7WsiAkP+onvcaCq+NAQS1yQf2PHG08FTRAscLlsTOmSq9/WsRjOdDjLUyEypFxfUZIA5JoKyTmIUB0pTmbQDqCTZv355LXB6M22xJw6SZkowUZi+OWeT3xG1lvv9rNFQgugFxsdWi81Vq2YhHE7N+o0neHxnYMx57SBfV6/022Sd9lSnjG+MY2zC9MUGTgrVHZBVJ6O6mTaMvtNOawzyeQFqRft3S+mVverM2QrcVFxa3tG+2wox87ZqAjXCXAVFs2BXyrVdciaIDiIDJsbpzr6GqznvfsbHb6CaJI5xyB5o1mZ0zUAo3oK+DDEOK6AfudPDuIgFcIo3jimiLmbA8mAeDfEcoavhjFH1HylApKAZKwvwDiYFD2ViaQ3gC5dXujAZc6tA4oHW3f3HZ7BiVCY0rs1EMjdimeJo8JcMD4AtR6kPkBp3aiCiihuQxyljslZHxK2Nj8SuqtpQVOVTvS0pRKdrp6T2aCSl7Q4RQG6iMRdAhdtcZyKxwA5OaXH4+8nwmgiNHSQp+cuC98fZdF39vNuR3pjyKvDkYQ1DsUHICpoJSTHD+qdT5oAl/AtjDEF7sK4qFsng/8fEjib1Z3WLwh2zcQXATyBoqAUoVjKPlv8QtBrt6mIWCUC9yuC9jASXkrB0FtwyBx/bktQreNVLYFgBZ/KstzgquqZpitoAs4pV7pM23XZSBUIhKLxuxU87LS2iUbiu0ag4ljEfN4YlwZGrz7M3QLOE9JdxAJfXLiWHi2FB08IQWmepZCB4+V4tABvf0PIq8PRkB/3nZgEgDk9ZCWfvE1gy9y8bMYOx8S8Cv5xf7i9hcpL4kPoRfwPAFKeYANcdjlGzgI6I0aXxdqJQqQmMi82WzhBKBt6YA+rUKfldJFKYk0UEqzTvXLqDOb+FlBKvRRpLKJwPAnnmE4RRXxhtRtfUui4TWZmd1jBku0L0CC38IGVl7nrVIa+/TGo8Jbqf6m7CAwwXOki/TR2EFp3aQ/OIBYXieMWCQ/5x96t6mH2CNIWwLfuu28pICMoG/dAkqrlwR5I34+pAWRNyhPaYUSEGdKE0oBswsKTOkROZhozHlNfq2e3ntNCZ6y4y2dKSKV9f1x1Ga3Sd2Gk7gJg2LXVojavewFWnASGEAqfdBeJqvfi9pQlLR+pqRsKQCuWLds4U1wCKiYZ3UMn8e2ZHtRClOHEQdoY7wx8/Na+FpnXofug8vrg1Gsn/bcRJlHBSXTGpTEf5spgxhk+A+oids7lOpPxMI8pYBM2BN85I2YvZ39HGzFIojXQf5SrHJ7BTwamxSY/PpknLW4Fzh/+q1wgua8pEg5kaHXmlOOFByZnlvKQmntCwB6w8a3kB/8uAa+uRIDblUlk2xXbfSSNWlVL0D8TaRsUFBnKte4mKZfIbXbpu3gE+loM2Qd821RCpw3EEkDkqS+jzlCn+uPCCCWVwcjoUR69/VSxSbXH+fhKYmfHAWUAj4X8pSG5xPnNgYKKSjx+VDFYl6PaHk8erAVqz7iG9jWF4EpynOc6N9vMsD41do1xtY0bHwR1Sr2+aJtmUtf66GUofF5rm1RUyupRlvRLxYT2oplM6UKYx3tUWc5FAXA3lPp19pWJrmAr26wnCn5dAr4vAXwc6X+w62V6wIfjkF5Fn1yqGu4kP4yYu5zF7isTeDHlFcFo3/j2/4HnriYRdGCTKgtOGTuQEngC18E63+y6FsxdCjVQTNtqZAekb8RU7zxg27+O0YMpqUvAS7wraKNN8HJXpFByVcKQHAJsFqWbYDuOYXYXPZHUMia1bI+qprtCamyhGW2Z7crFot3l7UEAYPN2EZbGp9iU5Ftmkp5Qe6WWy1ku8Jr6GLiUGdKgA36GlO3DQare9uyR0QPQo6RgpBuP659vzFnn1ReFYwA8FSmqyw+yRrvzMZ2DB1K9OXF5vkkkIAGJdo6yRvfupkH5F6PdsBUqK3YG6lX/PwGznR9m7gFE5BwCrvu8bTtWoNT6MykeQn0/M1HdCGJWy/K44qtRFtkyRpbwqSGHt1le34NGH8bj2QdiogNKPqwNqKlbsvCi9xKC8MC0O+6afOYxlcm8lpmHDKvRMF/tdLCBE709wh0IoDimX4x8mpg9K3dK6LHE3FLJ5TEwRH2ueURnVCo86EIDqU3K5T8y4la3x+S2JLtt2Nvsg8HjxD8agyI8vVhCpgC9i/hlHhg6NQ8jUdd8sPE4ZSLNLRR1PTqPaPry51xXYeToryxiNRLJAzS2q6ij1pz1Hmx5MZVai7rNM66FucWNT0yAFgPx22rBezAZDZxplRp1DMIm/+6Fx7vholq/w1yWjJw/9Mb8n6bhx/j477nOGb6RciLh9G3fvvf9WdHIHGnDrZjfvMv8UA4lC4bKJldntHg4lsrhtIbrFBazodQ37TO376H0N+73m/7EjyCPjatMyK+ph78MfItSW7FFpdhPm5Kn/BFKaXTUFczmuZ9a5ctSfVibZRVjHIOS7xi3kSvLcDymzzRaxtRDB0gFtLo6GKmiPdb1v3ypDS4qDQvpUBQV5RzidrClcz5R1w85vh0hAsQh+oJmOifPTEvyz/0DyqTjQ4YPy1ekrxoGH3rd/xdnricWKEzH+WJ71CanhJDKcHQvKSC0psNlMz72Xs9b6iO2VMfauDpULLxXhBAKTjl9WiuEXqsd4exEhEVaSxsFcSjX8WmW1a+61szkqBgrVfoes020kjNrj4BHetBvCKZul6pjdKOsSDWV1a1XBvWSKSZ9kmDIkcy5jMBoYr+d7at3pjLITri6CXCG0orvG3RBqCMtQNphilDtzO5PfiPJS8SRn+eIcQP8vQShP7+EJeN7wWJL34V/yVWBoPbEpR4O/YG2r6kGFC6QOmsqOpUu7TtE+pHA0T9zVjASVBwyr8aAJMjOHFKUiNtO5Latr7nLK+LKrynsZ7Te1LWYgMKqZ6qjd7vhJPr6xd4MvI+x9I58p7IwJU1d3EwHuPqA1iGg3GJCaKCg+hlUyvqactZPENrE/bGboLInguPQdtADd0aHpBpNmb4I8mLgtGf/86/54+LPSPSJ2PeZ4UAACAASURBVDueBL4RHsRfz+tlQEmwQEl8K7SF0huHUm2zuqfUPCJJ8CRk8pD6AEzxIOWbMV2uBaDxh8o+fAWF+JzwYmq/uwUWB0X+tNeMpK1vaalHvac9nPIa+qCFxwtstnbYeU8TTpbUBU7Va4hPVDdBTGiZeHuLsbU44XH158d/GTe3SpdqT8PzCtBYXPebIdNtqmzalFdE6yHndN6Bd5J2ez6avAgYJYRKhB5ZARJMAqSHYPkOJf8io/LbsANPyaE0tmNwz0f81bt2T+kC6Po6fw+mS44rtpUGJhqvP0R+9bQgWKSnJEyF4BQ1RJdjawxQpDZa0+xCI0Ntjt5hi4lF7AaV4h22dlZC+n7sjf3Wznuhkr331Kq6aBYIrDtBwUOBhf1T4r51WPjbNWtPAizidvFVg9Br6GFwC7s9fNYAii3NP8KAuKfvKNz0u7fyqHxyGH3bv/n34oU8AH82+zLw+woBVKB0FmRaW/TtTEYuA0p2Y3dQEvHfll89H5CnhASTJLDmGzj4wyArmOoBKjBZIDhJXDP9ZL+5ICSXsrgxvdwyCw0ssCygCGsHS1TQiLTbS0s9x9aOFIgRtD6XrR1kXoFg5z25ZrnYdU6AcMm9DwEEnfh8vTzuuIcBsx7oB6ZdVz0DfiECez6vR/Wov5nmeBWhgR49Rw9JTM2Hk08Go2/7CztvyOfOS7RuSBSRa6rxil60QMM3kKHUX9H3V/AMpQum50O/MyYEPOsz//LiBJONQWhb5mOrlR42+WCajCdG8qOV5uEu+ClJu8S7jh/vYsrlqbrjPbVzJybB6NfHMlqX0NMdfwfvSSrnH4L6BJ5yMO4VKJrXkHNcPyqtwdrpAu7p2DXHfVzntmqYTfXIcEqdxkuMCba2Flqa40OJXt4dSu0WPLt8dBh9+1/4ETrTBOpG+TNDhUI3UutmCAw0XqaXDZSaB4TVU7Lg3g8KSm9g27c3sDOlOgMabQ8wdY9nfukSfk0FJ9Npu62ma34iAG2PTj5PYZ1NlJUsufpQWp9podVeyc57ihEGHpAWr/lgfPbWrJvoovS5UKFrmeeAaZux9EZo1nxa6geUVqcFp3F3nyo+6M0FPyp1W59TPiqMvv27fkQgOcv8LIQ20CMoGwF8Ectyoy+wbZOgoNT/8FlB6Q0gF7H9+qW9oi8omQdk7b7ZHnSHlyPR/x0w+dYS64NZcxGi8Y/UMizqKRLw+qsHXMsEYVca6R+1ZLOCeOv9SdPRTlrHOKSV2j19FQfjWSqjPY9211BWeStKhNo0I3Arq8x2qUcHU58Gtr/V7g3Jh+cd65usE/I+8lFg9O3f9SNz1PEwxapIj8gjKZu2mANKF7/d8Y3lgNIFK5T471C/gX8niKDkoAKdBTlkqF1rawFTjLPGN/b5Cqmrtef96CebQhI9CpuT3ZuiUQ1wT4xWapoIQG30frWMW625tQPwhTkYD9PpPWmMbulYKB2W9hhHAMNpcy9WqdENVU65kGqxfVTsZnvmHeo/t3xQGH3Hd/+oT1g+D3zrYhpiUiUs/VHw8xXJMhgMwi48lPGlwjhg1s13h4adQckOp9ftWwAswCTwraEvrAbJDNLy7esJeWmhgWkOHoQJp5iXOqcwEfh7tarZH7HsLvBe7VUJ2fvIS/9xD8ZrLL2ld9nakQIxgtbnfifX6ikNXb00x6bNDv3e1nRlTuJnA0/FOmNwmzZ2UwGAaB8iqt+jtg4kJ2N/5z6qfBAYfcdXflTGPMlcElp3vR3oRTngXpDmoa/AYHBBvH1wr0gcIHobSv3PeeS2zL4PJG7bvhJgY9mB6YIJpvU6wNeCUPQbrmrtKNrjQI+4VwMQiz+3/LA+p/e0wgkAe090J+LzUe8pUh/yYLyPoFKPbu1CQ9Z+2VKZSFFVtmS7QLFWUPUrYzgpbPBlJ1wnbLgtVSE7rSvkK+W2skR89E3pBa32A9IejCfWfU55dhh9x1fCG0qVtFjjQYxnCfHH2U3dvQ1AHEoOH7ub/hbLt1por+r9C4t5+Cy+TVMrr9ft80xJQAfdKG+pxlNeT1yHj01yrPQjs2aApbQKQLxCewwOvKf5qMgwjXGtcALwTN5Tz9XHazgYJ0tPrmPrvSNnXisLdRQrgCtsujucdmAiG6QNb+dUJaBEbfBYso3SaD4EXgwAM/uIrDfl48uzweg7v+dHc2u8udWSsWQ+Fk9b0A4mK+9gEkj+EqyDQgTAhaBEr+oJOuQBQW5CyfuyMyuhseg6Fr6GuCbkzsqveLMG4gGzqRKP4bW0Txzgr3+qVYX5IPzsVBvS6qfdeNA2WzsIyDTboO3OaCj1lasP7Ld2foUky0oKa7um7F4zEjBvpaWe4j2R5BPLWhtu91YMFA0qorAvJnq89ZquiqxjtpJlrg8wlbekBaRoX0ddeD8A4jUhXcLIPiTvUueZ5Flg9J3f8/eFVoHQQxiPgMDuRuXTOtOCDqb+39nYTIenEr9NL1BcFEJvxcpbEoeNNg+oQSmBpzaS2qItYKpDQwJTXQFLex4kNPaAAeIGiv70iNtMCWxkqwSnquf/SJempBDXbrZ2fHtcPs+Dcb4ONxC24YmM+bP7p7Xw4YDQApMBQ/O/K7oi/gNISY/J6mQ5dlBy8OhVZOslVagfSQrMB8ivod3B25KmT6jznPLeMPrO7/37/ARTOs8X4vEVqeNCAdLbyDyOwXTRggG/0SpvKT2dgk3YygqlbDfs/FwpzqcuOZaCEmKs7sMByJNEnoPItcebihRxVuLLTsPbPnoARuu0dPKx2XhP3G+0kKMV1q/ek7f0LFu70kj/sAtvXTy+tQMA2W7taj7Lrsu4M21EAAhO0aKaGkq1r95R6K4+9oLRBJOXiddVkG3U09CZxyXuaanXQfUHGlPcQxWAHkk328/ei5P3hhGA9WaXJm6xoJaARBD6748VoIWP8FIsrRDxcyItgAj6G7A8WxpbOIs1t3j8v32I2zkI/X8E6d4SX0vc+rgWEJgA5JOQWfSHWL0NRT0iIgUnr7SFUz1SMvIAZPxIXOHkRdXmbI8j7aau/yAH4/UBPHgwvvz4T2tvrPuSLWMGXVEzHdfRPCI1Tdw/xQqnAFNu13QBTIApvaWAktkWlLTqQK2eXgXuhR17SXlFfYIX5U1pN/MB++eU94aRrMkWqz0irLNQq0UAB4mDQ7PcQ4HpIuTVaHg/w1uysx74b/DnYbe4XUBLUN9XivG43m6HmB4AahXSBdfNomJBPKxmUje0PzhVW+nTJ0TUoqqr8Yh0kGWdHGkoNwvWp5z0yg9ct5dUxGjXrR2AZ/KexijyQ6GbS5twAmJWu75dgISd0gBo1ul+dDjlGY4r9OAAO0EExVU8rQWlt+hQeos9lFKP1Uu6EpCivwoEK4Fv8dzZBDBn+sXJe8OonrZ9KT2qAiyLWjIQDGzJaNjTwTKaxyT+f4gp2bOt0FZLCzTNTmJcZYsYh43QFpdk2SGY6DaLaQAlOIlb+bkRSmdVKo2WArD1niw3/Se3z9GGqF8Dtbx6T7r0m/Zp6jnvd3S+ek/uVoRptkFQHA2lvnL1AX34YHwKX4fyRFqBQ8VsKj08EbErUq+gvhXz8jojQkEpvR4VB43iLQxKb2FQegvBW7H/UaQ8pb51U0ACSHPLVqEDKS5IdxNyJP1B/Hjy/jDiR3RbrM1A7FaLJR0k9mimDnsw9b9VRHXIWxI6W6p+hKAT/wkibRFR3pKVRLp7b2g8oLulZdEfjHxg8iepQKBSToYC8H3AuP+CVap7zbUsXJTrdD5LYd70d7Z2rm/Pcel799nv6NihOC7mwx+Mg546Hak293Y/gLxHecXLVizKMy1WfgUmmHQHk6u416PlKb0FxADFZ0rr1o2BpALVB4AE0vn1KajsvqxP5QeV94aR0HPWxp0ZetRSVZZi0yOujUdSvE4714k3Wrp6S5l2b+mitl5Nv/GWEkrAzluyUcZoAL8eulq+hnHD+qWnKh5k8Rpxq8W9p6pVOW55ejvtsZJqN/t9qvdEtVPvgJLMtqGyHjGI0q/ek8/o9J60tZPT5v1mjzf65cmGAjK4qH4pqLainGMFw0ljq5NeU8LH66dXJO4RKXBFvu5foPQWDiU1PXtKi5eksWXrQLrCPKQAUkErxkjBb6ZfYwKJr//FyHvDiIUeh5HJKWheT1q5oy1ko1mGsrX/cz68JXtDlm168G1cbeHuQYnGM7yqHA8Q2zhUOwwmoK2USiqQ2zKryQ+/pg2oPV//NidhGUZuL2GXNuvjJbmWpRkEgubDeMt7St3wnjS0fPmpF8xIu6nrn+dgvDRSxvA+/dJy7rVArGGT6QgSb8samK5RhgBAei1+VuTwUV0PreHwEatbUMqtGx1wH3tIAaS5ZSsg2Y8gBfj8CLCnczqwq7TJv2v9PPL+MBKsshn8eKDKZC5s34H4I89gah4QNLZxOn8VhG0vAhFo/Da9bfeiXQD5v8kCB96SjzHHA/tcFwNdQu0bJEvSK6IzI0Hc6ogP2oNYlzSxlqt6VSUqjvZWOFnmxtbOPpt+bu0sIcB7eE+jY+/3Ye+plOtVRJ+ulZiTtlVWuwR1+1zELRSY/LW88sIPyCjISxFxmOh6aI2dl2QH3Ece0u5ge3pI0b+67e5aYHdRD8o+nbw/jPjJzmvdGrbLzQeyHiYBEE5yaAWy9ZjI20koCYTKB5jEba38trcEHIIp7XNMXkdjzJrD7xMj+ZPewNI9jlqQXAtkAQh4e2eUrVLNOewPleSnhh2Xyntu7bzT1u/qPeluVNkvXXL2OzpfvadulaSKu6Bh1a86+lSfS7tY89fU600wze2Pf4kxoITwZrZQEgeITigNL0kNPrxl23lIAamdh9Q8tDZeNO9oTG2TW2UfXN4bRrS5AD9W61XputDIkB4mSVX9X+8C9pi23pII0oPRCwJMBaX6LpLGd5ZUIM1TyrDdxtnomt0YP8N1JMbF9/9ymf+LeAGyms5qfWJ51oADOPVa0ipO5Gy2dgBueU9RwsrhPQ04uV7XUVG/LVq9Jy9ZvCeebfWEAg1OYaMZCE4bMNXCnos9X8sLQ2l+V6hDKV/vdy9JViCFDXtI0V6dJSHbo3yO8cg7suvt3lEIz2Er+NDy3jBKmWttlufznAo2DHN7LEhrWZDHdNNb8u8aBZgISmbr3zmCoLZwVt63cPX1Af7yJYbHxB6Wjz3rxfX4lbSbqmEGjQRZcGnMi/pHeCYSOli/bTI9+ZStXaQ07EgpOTi3far3RLXpIqVmJ0a2jipr0pXlAEbn6rMe1xANKpCeU3o9Wu1wcJAEmNR0cA+oIJN6hPdiULo6N9OrwYTSMZBub9kKQlHHbXK7F+dHDKQcn7fPvyPn11nbVdSU9rg/MR9Mng9G98QvqK6rP2/TzlOS2Vj0CQP3UNLbIeiYvkMJiENofhMX3tIl2tUOmP7WDje2cgB7TTZiulBBpSHtqn3LJiDxmmklQPOewsimp1XNfrWqesImqlrRbIPss0rpe78b78nvUOu37N2u6aVvU3kKSK+7RTC9p9yKVSX4aCTymvjxINaOej32EGohi7+qV6j4VkwLMuEpVRBcxTZ9V2VPZbz1krZtexBItl0L72gCKeDWx9OhxNdH19iuHZt4pj+YfDwYAfmYtadw5BAPLxn4Y2prMR5YFQFy8SeUdMADBaX4P+7j10EEZnspO4hA8u8kDTCFfQYZZcrbObtQQUnzF7gAjRAA+nKLIqGtnQLg31Hzal7WGk+NRjMpApldQw9uUVVU+gSwwskyN7Z29tlv+vACLSE8XI1/0y7akhqbkqVaU+btWCkUvhUDCkxeZ307JbjCIbOB0vRG/JxH/JyH3qSNbZt5MgmRPAuSAlI/Q7LtWv+mNqUFclXR1s8MArpOQFHe0QwY6Q8uHxdGwHzMj2V5NAFBej/ejniqoBSAGFDyX3xNKAmAi6a3RedKAIMpgaX+1g716ycy6iQ0rc04LM8AwinZ+bhB4hl/aMQzCnIUyy7bhLgVSfQ4Z5y8mNGzAAfe02g5P7MlLpX33NrRyFLvcCI7Ta+oaoWZp71r5bx5TVF2hS9Gr3P1Cdhux9ChxL/u0T2lvnV7FyDZGVIHzwKg2eZhkHY9dU020zkHI3xU+fgwAgCxR0FZcXTto8iztpBzA5BbtzA5gpLXEf8dNU2Q6Oa8CAaxCabYyrWzJGz6kVGugzl5JSYSqiiUKlUfY5TSop6AyjmwNvq0RnZ6TwQny6ZegAM4kX1WKf3od3pP3l1c83rz93DSysGntPJAHsiGzoIkaBTlNUXZFQmmel0vvoDV6vQFbHUcGgkla2u3dbsHJHh7AaRen7dr3l4DVQvDO9JRrtvYnqaaEwqCPMifNs8unwZGW+lr6kbRWH22YGA/DwW8dUODUocHbd8ArT/aJmmznBd5T81jgq33+JMj1cfmr0QK55FnTiQaeCUV1O0XOFnCpyInZAsnZBvrFIs/bIseBTzWilC3ACI3+m2pMUbArmXrPe3QxOOLtupQGkFLca8HihVMV2/HwFRQSgAhz4gSSvxqvns+CRbzKgTkJT0VSDIOtbt3xEA6Ata6VVwBFNDZbNWgOPaOZghZ79J7yqeDkcQqeFDskRbOopZaLGJ71AaQAIPS4iX17ZvZ+RYOAP/ybOgKMAktaf8jiEbfBbXVa3KRGLNLfa8vNVQaCjQvphqzZJtSsxDOpVVVfSneU5FY0oB7DOu4Dl4c/ko+y1X3YFJMKAFX74g8BXF9Hgizp9RhI1BArlBleDwZSCO/9XpAWzOps6MNhOQKe20/yzie6UcCNmmO30s+HYwAe+jaZSyKLr1Y/KOAZJ+SPzM7lGKvsINSwYPe1omXkbdkj/FRXSB/DcVM28hKqo2QGF83KzjFVQugNyFBRQIBlGcsU0/zntT1B9exXqS5jq2VcF3Q+q3ikfJr8Wn0mR+eU18UBSeF0rYMC5i2B9Ri9eLVtwNigRK/Qi87s81tm+5gkxDZA0nQtms778htD9+aJWy8jrIu5+YmjETRvSP08szvYvz+H/83mX4X+bQwwnw695qlGN1kWRENLGkYADAvyRaxsN5rUl0ICkoAFjBVn9V39kVgEiC9pqoRsl6uwsYZJdHfJJFghRNAkBjWYsXUo1kJ59LKUwJMLyZOpubICYy9Z+th8Z7WK+9tMnggcbYjWX1uxaK80r4tAWJrIu7NpOegKFiYB7RCyUGgAQ5Fbq06bKByG0gFnEUvvc0j74j6amPnvKK2XTfgs+iwKccmzTGA9wcR8AJgVMvmrvKWCf+or1UgXmSPbwODZDnmn44dwKgtHNAOeeYvz6Z+k8oKrCXPSVFXNLZDdKWSlaMNHVs7W3c3IdGGdeQ9RU90Va3qo1u70Mxbo9YDNaJMKnrghfLl0QTVEzzat2IVpBab0GLVhBKuqC83xsK2M6C5jYJo85L227bbQJpbrC2wHFZ+ViQYcPTyoedrqGufXuDjAZt0SKafA0Ihnx5GgJ2ILpdEz/CRDJNcKZasEAxQcIUoj+3b9DGyvLRitxgAJaiIVLuhj4UqHSTIbUjvVekz9HUR1YQAC5xc/2TvqW5H74lG0ebx6GAcWMFIXpZNeyRpa6dQ+D+EDYNJ3SbLxcDkoNmcEVn9q9cLb8nfgvniH56SOCiUF7vI0batQHC4xWIgyVu97x31sNse9mvM2G76dg6OoM1eKM/7Ln5WCIW8CBgBeD8gAc3sQOVbsNj8rO3ywl7HEiUjkXaxe/AVti5+TjFuIq/uprThk/fUL6vaa/oBJ0C3W7sdJPbe09O3dpGbgNJW6rr+SY0IlOGk97djkb46mFRjmzLBJL6Q1bdlwLU8JZ3g0OWweAXS+reF5IFD7ZvfFUrvSDf1NMaGDlCO9SCvgJ2p+YSyHps0xx8EQiEvBkbAewAJOCTQtqb4RxYuVm0/Nsak4N4kupFc/EASr6RWlqRVH7WEXaumfdE/FU6QVKR+3dqZGk2dI1EysqRNXfWYqQko7aWjhkY6Zs4+w0qphor9eFC34J/66m1kGXwB+hmT/UZ7HVzXgh5Q0oCADFtxL2eFTdoIFg8pgVJtc/1xmD3Kejs8vnENFc9tmc9ffXcKdS/0hg6bGMCHBRHwwmAEOJCAMQ0b0hwJLyhdshSx7RZMebOEfwIjvSZFgIXjXFixxrM5IY1AGuPKSe4imHCysUZ/VU3ys+z7lWZubu2g0STrn7y1s2YA+hwNdDjpgJN6w8o6usC6B6L5tkwJPlZGea2FDKt0hW3h2kLH3FbFlk87KHwLpanbbdkWqNBh9d47Wsq8HR022mMDjd2oMQePBWzSuxi//0cfFkIhLw5GgK+QLX/6WrsrCQYo7KefhsKlJr4goq1k7S/glADyB3Q/OBkJspCeGTnYqLsEclL/HFs7SCpS/+DBePStbhTWc559UFI5ALQZViDhpABtIbZbsQKTe0xX6GZR0hkREOdEB99QdltxW11hoyggEUQ6kDCBs4BuliWsFL1cN2n2fhg+j4IIB/ldjN/7SBAKeZEwAmhVLFDaUmrKnHBaB/lWJSdfex1L5yLwBz/raCy+tM0NGsn9MyfKaOQ0lBrFWWR2s9UFTgAe39r1lHDuwYPx2XcbYbs6s675tUutPKDkObV7pFkORSy8DqYreUvsvXhZ1nEomeej/XyobPkN1oTNMZDU2j7ernH72RYWSNHYl3Mj7eWHeQ64kccmBvDxQQS8YBiFLFACfNqagiduptebM37ayrDRXb0OJ6tpiejvCvuGtnUx1u7B1s6NI9/h5EU7OEWt3QNzd2sH0PAf9J7G9Qi07eM0o7LT+TngFPMcg6m5BRR0RkRgKu9nOSNyKAEqYp6G7ryfAtVVzEtKSE27BMUOSDaWXu8IMLe8o6PxdQDdAtFOh40NsJaFZPpTQCjkxcMopK+MUVikUre4dVN6kFXHDz/Q4HT1Ni+wn7YX++nlENLQLfdTpb4sqR6DtnddGFNj2yjsK3Z2iWdm5xIVm/JR76m31vqWUbp+Y1y532gv81lfaI47mCzsweSei6XRvCExKDholBd+HVpfbQzi/3XQ2LpNgIwDa8j8vtCd7Vr/oqN2u3bQ7ONq50Y6dDQ3PGdLAJUjdWuM3/vD/zrTn0peDYxCeOVqRMLZ5rn4vWs36IqCQqS7ruNBxB5ewKAT9S7qceS93tWqwIJ6bL5R6AEkoEKvqi3fJZCynGmN7yoUIWJWdg/ZXe9Jeys5ZrTCLuMVYmzt6MHXDidaRBK6YzBdYc5YlI3vCvmibdsuezMmSC+pQ4nOkrTeok2gHHtIy/lQlWcdH2MLi4eWXlbo9E76VsBBfhcDeBkgAl4hjEjqJ6tPvPJNqG1VB40mGCaIrt5W2PJDcEGdVwAOINEEUSxW0QKOhfSIpECzAsoqZyolAAXUuCqXOuES3NzaAcAD3pNUxWxLY7M5x9nbqzYGePxSfF41+qvg8BG6h1plV5S3dAUdXIsvVLWFHnpf/AYy8df1egAFAa4EJB02OwBRPSo/ChNs9WzdivUgvwu4kw7J9EuBUMhrgxFP8KKTSmfQqRMoClAdRBrpw3sU8AF8vcLqJ5SkwcaCouVjEQoCUCucIj46ewLZVS4xcWNr51ZZZNrdBdPXFCy+843xst1tC2oQdl/qxb76VTWvJ+zinmp5PgogIUNQYk9pDyVR/r6Q1y8buwFtO5XBb84Vs3xu1zjUuU+NYd2qcTzTt3S4oQOQP5GmHr/7wiAU8tpgFPLIjVGgHU5fMQDkFWsp5XnJIADgvaiiDqmF4tAbVOp8SIBDQCnZew/Ne3JpCf+F0+zTCgoH/SGr69FZetN76tZV1KeF4WSzE1FeT7ZU6bgv5BU5mDzQVsxgYvaxIMW3ZQkUuXqdKwhKugWC2a5vw8pGgPW38pfzI4zzoAy62appK38yiMTmZNFnwCa9i/G7f/AyIRTymmB0dCOOyuLmykEMobRLX26gTsyjChAp4vwo/4haejX9j6oVcFperJWmU2tXqj+Ig6SWd33kWA+8JwnjFKHP1XuqOpLqqr9LjTMiGWdEtK2re6KUjnru9ahCgQama9btW6PwlBwa4otd8yzIbwjDRFFAuoqgnyPR9kv6d5GWcmy8I3Q46Z20AVc5nVCdc7QGu0vLPAKA16+8y0sHEfAyYaSghYaa8AUUVDZDQIfTAR1u56hNNog2VxD5WZIaNAJCMVb/S5HagNNCAseC1KMUOm/bdQbEGnM8frx5Q3pP7TpueE/+KVamqdZmOhX7rVjLS3k80LkVsxYqjYISkGDyfEKpnfEAUF1AA9u6KdkcwIQ8JKvftmwJJG879HvvSKIfG4eN2ewYOunpoeA000cBaz69pigLyfTvfu3lQyjkJcIoJCZdRn4fZNExfO6ldxKLhSEU+RYLA6M8I1WBoCBlYQWUtvL+hk3ExhFz0J64WvwTUKvVeNPF3lOv0OwkSpSKsqZWvZirKA+bvB8EpvCY+IwoynJRDm/pinj1XWdHCQGIA4Kh1M+S6o3b3LIFXCooer5Cr6/oZ0tKdgUgLPHuFX3AjHU7D0hhci/G73ztv8r0a5GXAiNFX5gRR1npV+jEjWaJNrhMNna3ZPZ1oXQfqz02i2ckK2z8P5WkV/8AeUMNUsi6Ummp/nKO6KkL76nyCYn2bC7ek2o3KMvWPG0BeDcH1bJjuLgt2lwGmLQAU/dqgKmgRFuxvuDNDu2bz5oAcztBejRU7/bbs7veEVq9Np42rpgD61MRMH48xJ20NA5jAK8TRMDLgRGLgmFSi4Ynnm4ugA4K1rMI9nL0AMw2eVw97t4MQ2n+UX8FfDvWAQUFBMv3k/KQudWfVyJAzI4CcRjEhZmQsmtW638N0OFU6QSH9+rtCW0X9MZWDDZfCiSUrlqL89CrENdr37o1UAhy2zaBdAQcBeQqovNvCCmle2Do9C9CMnjm+Gf6kYA76ZBM/87vv04IhXxqGClqSVhOfgAAFY1JREFUucRE7hb47qZc8RiEQsZyOxRub7Y/xzS3bFxuujq43mzXyl64zIDDHpRWHVWyqz4JUY6JJlp2bGVFulRgOFnp/qcy/bCQ/Mkt9JN/A6ZalFZ2LU8JV9jp1tXtOxzEF7wiPIzrtBU0IDU7fwUfbfGZT9+uTe8ICZwJKz3QzfQuvws4yLM+JNOvHUIhnxpGQE2q+OfuJsyYQcQAYnhMMB3ByBeFxNcAjgCUaf9q8SwP4HAboZs2y9s1JGwqSC9XFKCQ7SkU+RUekqERQEEoUn6wJT8U+dkPRmXcF725FUswhcekAIFJx6JNKEHBi9/1ZG/gkAGksC0g2d8wGudDWbaAZPn2NZVh9azwiBfUtmO3QIQbulsxAOC3f+/zABHwcWF0NGkTQqGbkx8AmiDaQSnaaDlpr40zzANqRfXP6exLRBYd2TXwqKYns4cShx2gbGYirdLLAlBofdcviYXOhOY4a7gdTb435xbqOkvEnAScFMDtv8Koua0K2G++wOhxeUpXoJ0pPQqk9ratA6nKJYA02k39AYA2abtOPUzrojfRTcAmvYsBAL/9e/9ly38O8rFgpJhw4LK1hCc6Fjzr42EIOGGkIYDsfr9iCD8Mcif9VJ3Bw8C19ZTcw1qhNEOHlLWzB5QCEBX6bhLgHtHm2RUvjyRBRaNu2qSFVrFd+wZMFcK7SW/J3mABDUpzgTs08i8hbrduBKQrypuaQPJ8Oz+acLE21t/g93baVk3RQcXXO/NrYEiZ3EqHZPq3f/fzg1DIx4CRohZG5Eu45Mim8gygqJktCMAA2rU8H47LQVo26afqjs+RPE0eVpQJAHFI3QpxRhQB0OpLqk8AEIgdxKRofjRNtmTJWDQAoFo2ivAwDS5RR4H5Sr6Fa9ZVXLFCqS9wb4f+NGu1QcAQgS5A6t4LA0eB8Yus03vqdauNgsgoz+3YfRDFHO7zrA/hNH7rMwYR8OFhpIhHvCa28rQ+hgR0OB8LdqYvAlwdQtwX14+b/OiWrHT7g/TbOm26o3MkTnN7AaklDEiB6sTxdZSpl2a6TbWMyVcA44wIZpJpoZ/mWnOj6GAKm4JSltEitnoOn/zTqfvX42JAAlDeyXyLNoHUDqAxDrTRyikokP/FUI1zem1ruuUlrpmC34Smg8m9GADwW7/zeUMo5DlhpFgXaS2Mnt7lpwR0YsGy7gJ70OJfrKwZx41nr2fmbRyyHfe76eTQLsZuab0JJdYJANlACgQosN5zlQbabLcCAbS+EeBrPq/B0rQVCzApz2l5PYqCUnwpcf6hM4sFCv+zq4IFSGGbOrF9VOgeBlLrk79AucDoEEBbEEmfgwkojPzUYRO39G/99t9k/WcvzwkjFsW6ENHSfZncEwaTb8QkzlKAand6IXMbhszLUofH+qhOnqjjOP4syeIZAYgzoa5bAwhQCL2mkzNmec65VoqK1N/r2zVstmI+7ht/gTGhlIvZz5V2fxJW4V6SuD15MmFLQHJoLZA5LhNsfvmV7dczoAVCBEJ9YsBBHggfmnUAfvMLBqGQ54aRoh75SHP8iIT9NghwAeSKOjNR9AV9C0jvtu0C4k3QtHtSGzPWnu9QkgagmpM6uJ4BEUt8v9p1BKcuZlWFvjSkdP46PrZitQ2DzWWmHUz1beOxFXO7W1C6wv/ioeDGOVL8QukKEcoffNlx6W+MYR/rQf5ewJ10CKfxm7/1xQQRcOtBfaJ811/8B7wAgLFAWrpAErqZ3i2yANHuFfj0HC5LLIt+tfG03CgbbXpaDux16izWgzGOa9H9tc0AAAEpNF2XzGttw1j6QimvJ3S1JRlbsSj3sqvb9kVdUEr9AqSsr72NeY6k4LdbC3CU+6K62mzt1zxGH34NWlClMSo08hmr2dc8Kc+TwtuEXytC7zbxid/4zf8iyr+w8mwwAm4CidN82DpjOcj7FwB9S7L/Ps4xkFYQbWO5CRxcvP/bgHqs7MjG0w6xAy9INzqYVFy3VXBDtD8ASnFbYKSrxVYLkYHUFrd2iCj6ec08S2IgKYDxC7AdTgmk0Ua12YA0YbSOkcqUrzntCEZAECXmoOtMD9czjMCT/hu/cUIo5FlhFHIXStJ0HB+mBRDsvSIOK5BkKbsPIcEFe28n4ncte4rNwXUpb9VANtCu4xi4fZuttBZJWGsLA0pAgum6hZIv7rTJhZ22OyBF3QeARG++tJcpqj6OYFS2Wm1CcQwjoOv9+kmfCkwYZRqq+PUTQot8EBiFHEKJP/dxSwsgyHPrtkh3oRaujPxY7LKHUOTfFSLvWraLZ3oXYLGGNxQ6KKUX6bddZ0xbuTUMKOkeNBXrANIKr/4/taYNFAYcar8DS8PTGmXKY6m2CUhZj4Aa17TAyK9T+7VbRUX5PQwjgLZvvMx+/df/c8qdEvJBYRSyQGl9Fc9pmWnLLF4R23IIsKw6Sku3fV4IHW8LH2knXvnvxr4L2KThSyJ0odmLZtEuVp0H132RXtMuodG3YiAgKOu73XqG9IB3pLztIw+rvK0GKwMPeUDQBlMN/Q0YgfTx7whGYQvVE0L35KPACBhAEvpkzSaWiuar/NvhxiG38ALvIJrxbWjIAzY4OIu6EWsH0B5GB1s1ikc6l0jkWDRjHXkKB1Aij+LA++ieTS1+4DrBpav3E+0YyKp8BZL2etZP845obFAYROZhtWKFEaxuekYI+ypynXdi5Zb4tV87IfSIfDQYhXzXX/wH0pbLfvFkLBXxWdNchD0cb+XiD56F3S0Q7ePyelqZvAvM9ra78iVopZF6zXQIp0l8+a05XmiRX8KA0gSBooFDy6ZBogEpbBhIpXMgaYHkPoysHQVtx2hcPs5DGAVeWB9ahQnDCKzXSp0geoJ8dBiFfNdfeuzNm7RoswB3+QMYCS/utJFbEGAILTpZbR+BzqN1ZvooINJaaZNbv3BDRm0hpRKxzpTyGQhIW+/H23Ld+MazUtnwfqztPYyAxTvK/nZAchhpt8OEkR7p1dpB2WikU0v/Qg9V4Nd+9T/L/CmPySeDUcgNKEll5JZXxGkLstFhOScShMd1yyu5DaFHYDPbesx2TR994RGbNABAKR2KA5kLqhYiEItZM13huoWSVl73QFL0Q+1lW7cCybwnHe1HXR0eEBCeEa4g6JBeUaCaMELq4BZuzH4PyiBn7lf/2Qmhd5VPDiPgGEimbF5RqdeFyHZLEM53EEVYIdC/Bf20s58FYje/KnArvhHytzh2X3qcabQ73W+7trgAE+utQoeSL3rNdMbsoWR+2GnCagGWdug0WHlZ2DrYugcUY9WAEY1dM91gBLBe6drVy2AXi5CsZ5YniN5PXgSMQiaUJP5ZZi42jit9cMgtka7t2W6BFwBWEHH5LqbzpCeeQ92OHwmo2AF1Y4vW7jgttBHHUqsFTIvc07nw9cYbNK+/HmrPA20DFntHUb/BSkfbNtLmGeX4dEAnryVwk/Utg2MYAUgWhS0UwK/+yn9aFqe8s7woGIUElGw1ebKWltyId1s0ABNGWxAJyiNqeeGyvRckeMzzecRGNul7AfuY7u3BbdaIlLMca1/EtUAVBCMgt2x3PKR750e3YARFfNFxHJhbOx061Ubqkdcx9Hlt6ialq5rojtE/++UTQs8pLxJGgAHJVpWvrZbJeOq2Z0vCC1dCtV3UE0b90HumV0/oHmSWWKy/e17RzAN+fqSR57LKs4gvr90Nj6dgByVfpLZwlXXloVgatz0kzXxCK4FVZYhtlbc321H2pJTa2MFIb3hGMBv1up4PffII7VNVTwh9IHmxMAr57r/0Y7aoamntFlzFMvKIQydfrKtnBErzr48wxFY4PO4NZSwFu1te0+zvloeEmfbbGXkW0ikvMk7toERB+4LeQWHnIVG5FlT2MOqwisNm8rIIisv50F0YgerGpe5hVMq0BIBf+aX/hHKnPKe8eBiFfPe/9WNzgXFe/FNa3heqRNoAkvptkKwzyy7Dhj0itnmq93PLK7oFIoHJTFfsK5z0LFWq9BmL2FK5qCscAql5RIuHtJwPHcKIoRNbNSpLGLFXdgtGbp56KKVRLpDlSZ9LQ08IfQx5NTAKuQmlPYwgsWAtd7SY5/Zst/jJc9qCqMVibd6Dzr34XsCNuNK52pooReQVWKy00IERGApm0+EzPaT92VHznqgtRR1k81Ytyu7BCFRX0X0cBq1l7ULZxhIK/MovnhD6WPLqYATcABJ/kl5i4VpuLuLKH3tFEWJ71nUjLQWte6B5H68oAjbpEE6n0C3nmx9LUit/C0jqANhvx3Bju6aZ77BKvZEg+mLv6AhGzo7FM0LV1bi2Ixg1LaD45V84QfQx5VXCKGSBkmwXIm/TKLtZzB1GbBPlF9z5SoA07+kudHq8elFL+9iPzfKaeo73wguwxdo8C8TirUVeXorZ1q9T7IG0hZWuMGKwKZcdwIih4/W3nhForEBcT+nhfSM0v/wL/3FmT/l48qphFJJQquUnlKjFKQCOYERbPOkLvcLqFTVgSLVzc/vW4uMvR876M6DnNfIh/AfWDiWXqGcr1ljsbsYwWKHh5be8o7Zd00yXB+RQoHas7EEYgWBU47aU+j/NTNdDAfzyz58Q+pTyWcAo5Lv/8rp9I8UORhEHihhEVWblgmMQTY9oQmT1eG7/BcldG9HP/pdkK+0x3VdtZbsbTos2Y17ABoUGhAak8nasvJ0f7bwjHXWjXW12GxhZnRhPG5+T9REYoWys6JdOEH1y+axgFMJQEo7GH6qneMKo9FkXglswWj2iCDdAtP9qgEz72wGc1sqHCGjdkXDO1ict4orTQwoArDA6/nvSE0ZcZvZ1NhQwym0bAkbVp41Jmz7G6/VJiwVG8HqRxi/93H8Utqd8YvksYQQUkGhVCvlJssSWqvOludALRlwuCHgcw6jrb4BIdvb7/BwDZqxd56ItaqlcqumdhM6gcA9ISr9VXx6QAvkt6OYBpe0Ko2gXXNa8I02eDEglTzu6vLHQKYBf+tkTQi9NPlsYhXyFt27GEl6gtYCFLOYiNxCxvgWRvX4E/lpA24pJlPeYt3JHAS3dfx8t0+sdVo5q2UasvtA5MDSQQHrEO1LU2ZGCQFUwuQkd1oP1mqNFpoo9yDgSUOAXTwi9WPnsYRTylb/8Y+wZAX0x56eUrsolixYIiJXfAsYAS7az25JdUO3dA9EcS4/X2xp/72hGbJkLu0HBVehbrPBK6DxI2bPp9vag0RYsvaAOOl30czyBnXswIp0lf/FnThC9ZPnCwAgAvvJX/qGgi1BKSNEXupXMxS+hxD0Y7T0iO/Su/O4rAbt863/kQXFIA1NPBmdoQVdM5y0RtAFICywOGS1936rNcyMlux2MMPVtLIpSrTCaWvzCz/yHkTvlBcsXCkYhWyhJJJZFzTAKfabHFo3LK9R5U0JFJmj23tAt7wibNMc9PW5zLvhK0fKt9PCQGBD8J1wdNBowaR4Q6tyI2rFYe5vw+popTz8AI6+R14Nf+OkTQq9JvpAwCmlQslT/KkDE0ooaAEQw9T1IlMkORGHzFAjNgE080yW6JH3t57IOi4RGwoGAE3kdh9WorVqDEYDYqnGZdX7oGSHHRjBC6OOD9FAofuGnTgi9RvlCwyjkK3/lH7JnRFGhBB1GoSDYLHAI0AjovEkmTI63Zkf6W/2B4pCZryWMJE8uelrcGbTr2ut4LbDEVq30Vebt3PSMov+nwKhdCxT4+Z/6Dyp/yquSE0YuX/mr5iXRyhVKCWVz0YuX4AgUWfYQjARP8Yii9fXPzeZAR7pLB1Ks/wmjsOze0Qqj6yxL+9swsr7327SEjtXNcXWVj/Lnf/KE0GuXE0ZDvuev7s6TpNIUSwNOxpWug+uyPwZRhGMgVV8c0GJt+dvCSzuXdW7DosxBUulACPq5EYFmu1ULGIH1xJUYzQ5Ghcno2aOf/6cnhD4XOWF0IA1KB99Pkg6IiCtdHpV4Kx0i92FE7SwB0aaGHcd1W3dg0pGqrVEkCyJWvgFOpHVAZwMjb6N5RtFvwCX7zbGQfuMZ4edOEH1WcsLohiSQDr6fJJU7glGYBYzKZg+YBTbTrtoQ8VXZ7OluTijtRPvyDmtlfYTQJnAirQWdLCOglF1trBJSOqCDFUZWSNfxc//7v38+tJ+hnDB6QL7nr/349C6EPhhEPe4wgjA4HoHRFkTb7zt5OgnSx6tpu7vZ7KW4dSECBCTyThS1nQvEpN0dzyis78HIS2pwJ4Q+bzlh9ASZUKLX+sCEUZbVWzhhmwJN1OmBICepl7DlOqzz9AZK621mzQBSgYFsdzAK40c8I9yBUeijU9bjZ//JCaLPXU4YvYMElGj3tkJpwKiAkqU7EFXeYSWpW79acBB7usiRcgtIbek7EqZ3FNps3LZqBCNvKfXRhsMoUdPhNxCUg1LgZ//Jv3c+oF8QOWH0jvI9f+3H+x8kmTDIXINRlE0QcTrLO8DuwmimXVTaHd4wCoydAMRtGHkdHaAJu1AVdMpmC6NMhsXP/m8nhL5ocsLoPeV7//r+PKk+jStBFP/cAaXAs3pF05bjW2kXYs16u3WkaDfWYQKMrVqhZKt/AEYoG1P8zD8+IfRFlRNGzyQLlOq1PvA4jBJErnwERLv80HWizOw0IzpNGJXGoFOQ6uDRJA/X1yJVQ5ACP/OP/93zQfyCywmjZ5QGJNl8PA4jItmyPbuVviE3vSPWM4y4mlJhWGrqF/C0Q+yMk0FZCPzM/3qC6JQTRh9Evvev/3ghxYSPl/gd3AqlFUY7u5AHQQQ8BKMq6wc4VKN5Ro0ud2EEKFVX4KdPCJ1CcsLoA8r3fv9PFI044s8Zd4wFk94DQiwPAEk5IvS4erpND8ColSgUP/2PTgidssoJo48g3/v9PzG/w73bZm1gJDu7nTwIp7swatun4E2WAcsebgMjb4eaCr0CP/WP/p3zgTtlKyeMPpJ8H3lJ2KXuw2jav4PchdH0jCIzEVQpN9TFrnlG+Kn/5YTQKbflhNFHlu/7/p+QgZQOpL6fO4LPO0LpnWDUt2q3YUSfVu2n/ucTQqc8JieMPpF839/4ib3XIyAevSNzbsjYh+0MKNrYKmfbefSAluInTxCd8gQ5YfSJZYGSHP2WyfPIM8No5xnhJ/+nf/t8qE55spwwegHSgNT8ITo+eiZ5JhixP5QmP/k/nhA65d3lhNELku/7Gz8hGxg9qzwTjJbMPz1BdMp7ygmjU0455UXI5Z7BKaeccsrHkBNGp5xyyouQE0annHLKi5ATRqeccsqLkBNGp5xyyouQE0annHLKi5ATRqeccsqLkBNGp5xyyouQE0annHLKi5ATRqeccsqLkBNGp5xyyouQE0annHLKi5ATRqeccsqLkBNGp5xyyouQ/x+wHxiQI2pe2AAAAABJRU5ErkJggg=="
            />
          </g>
          <path
            id="Path_1927"
            data-name="Path 1927"
            d="M365.96,186.3l4.274,67.793,3.057-1.794,2.553-69.248-2.3.677Z"
            transform="translate(-13.009 -15.533)"
            fill="#b7d5f1"
            fillRule="evenodd"
          />
          <path
            id="Path_1928"
            data-name="Path 1928"
            d="M366.763,252.318l3.3,1.72-.027-66.622-6.049-5Z"
            transform="translate(-12.842 -15.479)"
            fill="#d4eaff"
            fillRule="evenodd"
          />
          <path
            id="Path_1929"
            data-name="Path 1929"
            d="M427.86,223.428l4.274,67.793,3.066-1.794,2.544-69.257-2.288.686Z"
            transform="translate(-18.262 -18.683)"
            fillRule="evenodd"
            fill="url(#linear-gradient-32)"
          />
          <path
            id="Path_1930"
            data-name="Path 1930"
            d="M428.672,289.448l3.295,1.72-.027-66.622-6.049-5Z"
            transform="translate(-18.095 -18.63)"
            fillRule="evenodd"
            fill="url(#linear-gradient-33)"
          />
          <path
            id="Path_1931"
            data-name="Path 1931"
            d="M269.75,243.8l4.265,67.793,3.066-1.794,2.553-69.257-2.3.677Z"
            transform="translate(-4.844 -20.412)"
            fillRule="evenodd"
            fill="url(#linear-gradient-32)"
          />
          <path
            id="Path_1932"
            data-name="Path 1932"
            d="M270.553,309.818l3.294,1.72-.027-66.622-6.04-5Z"
            transform="translate(-4.677 -20.359)"
            fillRule="evenodd"
            fill="url(#linear-gradient-35)"
          />
          <path
            id="Path_1933"
            data-name="Path 1933"
            d="M331.61,280.019l4.274,67.793,3.066-1.794L341.5,276.77l-2.3.677Z"
            transform="translate(-10.094 -23.486)"
            fillRule="evenodd"
            fill="url(#linear-gradient-36)"
          />
          <path
            id="Path_1934"
            data-name="Path 1934"
            d="M332.422,346.038l3.294,1.72-.027-66.622-6.049-5Z"
            transform="translate(-9.926 -23.433)"
            fillRule="evenodd"
            fill="url(#linear-gradient-37)"
          />
          <path
            id="Path_1935"
            data-name="Path 1935"
            d="M330.69,270.486l5.088,7.339,93.82-54.039-.027-5.948-1.318-.769-48.63,15.8Z"
            transform="translate(-10.016 -18.42)"
            fillRule="evenodd"
            fill="url(#linear-gradient-38)"
          />
          <path
            id="Path_1936"
            data-name="Path 1936"
            d="M267.72,243.671l62.714,35.91-.027-5.948-6.9-12.876-18.458-10.021L267.729,237.75Z"
            transform="translate(-4.672 -20.175)"
            fillRule="evenodd"
            fill="url(#linear-gradient-39)"
          />
          <path
            id="Path_1937"
            data-name="Path 1937"
            d="M267.73,232.737l62.678,35.882,93.8-54.048L361.531,178.68Z"
            transform="translate(-4.672 -15.162)"
            fillRule="evenodd"
            fill="url(#linear-gradient-40)"
          />
          <path
            id="Path_1938"
            data-name="Path 1938"
            d="M319.338,217.167l21.14,12.016c.348.247.5,0,.723-.595l29.12-16.957c.238-.485.284-1.016-1.1-1.73l-19.172-10.67a3.285,3.285,0,0,0-3.066-.082l-28.744,15.786v.915C318.175,216.289,318.624,216.774,319.338,217.167Z"
            transform="translate(-8.958 -16.87)"
            fill="#292929"
            fillRule="evenodd"
          />
          <path
            id="Path_1939"
            data-name="Path 1939"
            d="M319.339,216.017l21.14,12c.348.247.5,0,.723-.595l29.12-16.967c.238-.476.284-1.007-1.1-1.72L350.051,198.08a3.285,3.285,0,0,0-3.066-.082l-28.5,16.372C317.93,214.827,318.405,215.5,319.339,216.017Z"
            transform="translate(-8.96 -16.772)"
            fill="#665861"
            fillRule="evenodd"
          />
          <path
            id="Path_1940"
            data-name="Path 1940"
            d="M331.459,217.838l12.94,7.321c.21.156.311,0,.439-.366l20.92-12.162c.137-.293.165-.613-.677-1.052l-9.307-8.383a2.059,2.059,0,0,0-1.885-.055l-22.942,13.727C330.6,217.115,330.891,217.527,331.459,217.838Z"
            transform="translate(-10.025 -17.221)"
            fill="#8c838a"
            fillRule="evenodd"
          />
          <path
            id="Path_1941"
            data-name="Path 1941"
            d="M348.033,201.708c-3.066-.805-.284-5.829,1.528-6.607C352.133,193.984,351.794,202.7,348.033,201.708Z"
            transform="translate(-11.371 -16.547)"
            fill="#b2d9ed"
            fillRule="evenodd"
          />
          <path
            id="Path_1942"
            data-name="Path 1942"
            d="M348.565,195.778c4.64,0,4.118-1.071,6.69-.7,1.107.165,4.7,2.654,6.168,3.8.915.714,2.26,1.144,1.83,2.114-.256.631-.284.577-2.151.915s-5.491-1.181-7.623-1.428c-1.638-.183-4.255.631-6.26-1.153Z"
            transform="translate(-11.418 -16.547)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1943"
            data-name="Path 1943"
            d="M347.933,197.99c4.631,0,4.1-.284,6.68.092a13.782,13.782,0,0,1,3.029,1.382c1.025.54,2.993,2.672,3.45,2.654-1.876.348-5.491-1.18-7.623-1.428-1.638-.183-4.255.631-6.26-1.153Z"
            transform="translate(-11.418 -16.792)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1944"
            data-name="Path 1944"
            d="M351.032,199c.567.1,3.715.165,4.9,1a.915.915,0,0,1,.293,1.464c-.183.229-.842-.229-2.608-.467-2.453-.339-4.75,1.83-5.9-1.958Z"
            transform="translate(-11.46 -16.886)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1945"
            data-name="Path 1945"
            d="M351.3,199c.567.1,3.715.165,4.9,1a.915.915,0,0,1,.293,1.464c-.091.119-.311.055-.741-.064,0-.732-.073-.814-.851-1.007A39.55,39.55,0,0,1,350.85,199Z"
            transform="translate(-11.726 -16.886)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1946"
            data-name="Path 1946"
            d="M328.045,200.4c6.278.6,11.2.165,18.431.915-.915-3.322.4-6.406,1.995-6.708-6.113-1.272-13.471-3.5-20.206-4.329-.146,2.745-.339,5.637-.256,9.151A6.115,6.115,0,0,0,328.045,200.4Z"
            transform="translate(-9.786 -16.146)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1947"
            data-name="Path 1947"
            d="M328.045,200.416c6.278.6,11.2.165,18.431.915a8.631,8.631,0,0,1-.284-2.938,162.4,162.4,0,0,1-16.582-2.453c-1.025-.3-.915-4.082-1.345-5.491-.156,2.745-.339,5.564-.256,9A6.037,6.037,0,0,0,328.045,200.416Z"
            transform="translate(-9.786 -16.161)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1948"
            data-name="Path 1948"
            d="M287.494,176.2c1.089-8.145,11.805,1.162,12.537,9.435.668,7.65,1.171,12.135,1.272,15.841l18.577,4.1a3.55,3.55,0,0,0-1.83,1.51l-16.893-3.761c-.485,2.581-2.2,4.923-4.713,4.768-3.24-.2-4.347-3.057-5.427-6.827C288.922,193.86,286.68,182.293,287.494,176.2Z"
            transform="translate(-6.335 -14.684)"
            fill="#e0f5ff"
            fillRule="evenodd"
          />
          <path
            id="Path_1949"
            data-name="Path 1949"
            d="M287.494,176.2c-.814,6.095,1.428,17.662,3.542,25.066,1.08,3.761,2.187,6.626,5.427,6.827,2.068.128,3.587-1.428,4.338-3.413l-1.574-.3c-2.8-.54-2.517,0-3.24-2.672-2-7.449-5.116-24.178-4.228-27.8a2.748,2.748,0,0,1,.137-.412C289.773,172.52,287.943,173.078,287.494,176.2Z"
            transform="translate(-6.335 -14.685)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1950"
            data-name="Path 1950"
            d="M320.361,215.381l-.961-1.913.384-3.5c1.666-1.08,2.928-1.455,3.661-1.19C326.062,209.762,323.655,216.68,320.361,215.381Z"
            transform="translate(-9.057 -17.709)"
            fill="#8f9ba6"
            fillRule="evenodd"
          />
          <path
            id="Path_1951"
            data-name="Path 1951"
            d="M292.68,205.367c.622,2.1.494,3.56,2.434,4.933a18.827,18.827,0,0,0,3.294,1.345c4.823,2.05,12.409,2.562,19.84,3.34-.439-3.963.778-6.278,3-6.653-6.223-2.288-13.727-3.276-19.922-4.887a12.812,12.812,0,0,0-2.334-.375Z"
            transform="translate(-6.79 -17.232)"
            fill="#d2eefc"
            fillRule="evenodd"
          />
          <path
            id="Path_1952"
            data-name="Path 1952"
            d="M292.68,205.455c.622,2.1.494,3.56,2.434,4.933a18.826,18.826,0,0,0,3.294,1.345c4.823,2.05,12.409,2.562,19.84,3.34a9.38,9.38,0,0,1,.366-4.356c-5.491-1.446-11.769-2.324-18.934-3.706-2.8-.54-2.517,0-3.24-2.672a1.241,1.241,0,0,0-.064-.229Z"
            transform="translate(-6.79 -17.32)"
            fill="#c3e6f7"
            fillRule="evenodd"
          />
          <path
            id="Path_1953"
            data-name="Path 1953"
            d="M324,208.872h1.711l2.846,1.428s3.23,2.324,5.445,2.068a11.539,11.539,0,0,0,1.181-.091c.915-.357-2.205-2.4-3.313-2.928C329.042,207.929,324,208.872,324,208.872Z"
            transform="translate(-9.448 -17.698)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1954"
            data-name="Path 1954"
            d="M326.92,210.063l1.9.275s3.212,2.27,5.427,2.022h.32a7.98,7.98,0,0,0-2.324-1.885C329.546,208.8,328.3,210.264,326.92,210.063Z"
            transform="translate(-9.696 -17.791)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1955"
            data-name="Path 1955"
            d="M320.356,212.946a12.655,12.655,0,0,0,.146,1.281v.165a.552.552,0,0,0,0,.1c.3.732,2.965-.21,5.491-.458,2.306-.238,4.356,1.83,7.193,2.013a5.848,5.848,0,0,0,1.684-.11c2.636-.5,1.556-1.775-3.111-5.235-5.564-4.118-9.371-1.51-9.371-1.51a3.661,3.661,0,0,0-2.068,2.745,5.489,5.489,0,0,0,.037,1.007Z"
            transform="translate(-9.135 -17.682)"
            fill="#f1b287"
            fillRule="evenodd"
          />
          <path
            id="Path_1956"
            data-name="Path 1956"
            d="M320.5,214.612v.165a.549.549,0,0,0,0,.1c.3.732,2.965-.21,5.491-.458,2.306-.238,4.356,1.83,7.193,2.013-1.693-.824-3.477-2.224-5.491-3.24-2.453-1.217-5.491,1.977-7.376.137v.238A3.056,3.056,0,0,0,320.5,214.612Z"
            transform="translate(-9.135 -18.067)"
            fill="#db9669"
            fillRule="evenodd"
          />
          <path
            id="Path_1957"
            data-name="Path 1957"
            d="M385.276,184.249c-.311-.174-.558-.439-.86-.613s-.815.192-1.638.677l-26.685,16.061c-1.83,1.1-1.6.769-2.562,2.69q-5.628,11.21-11.22,22.448c-.494,1.107-.741,1.684-.595,1.83l.915.641Z"
            transform="translate(-10.948 -15.579)"
            fill="#292929"
            fillRule="evenodd"
          />
          <path
            id="Path_1958"
            data-name="Path 1958"
            d="M354.5,203.755,343.281,226.2c-.915,2.077-.988,2.306.814,1.153L371.2,211.067c1.684-1,1.4-.915,2.288-2.663l11.467-22.833c1.062-1.83.174-1.391-1.208-.567l-26.685,16.051C355.215,202.163,355.462,201.824,354.5,203.755Z"
            transform="translate(-11.031 -15.638)"
            fill="#665861"
            fillRule="evenodd"
          />
        </g>
      </g>
    </g>
  </svg>
)
